<template>
  <div ref="mainDiv" style="color: black;overflow: visible;" v-show="showMessageBox">

    <oxygen-button-ribbon style="display:none;" @vue:mounted="buttonRibbonMounted" ref="buttonRibbon1"
                          v-if="mainPanel.componentData.messageBoxModeButtons.length"
                          :buttons="mainPanel.componentData.messageBoxModeButtons"
                          :containerDivStyle="containerDivStyle"></oxygen-button-ribbon>
    <oxygen-button-ribbon style="display:none;" ref="buttonRibbon2"
                          v-if="mainPanel.componentData.messageBoxModeButtons2.length"
                          :buttons="mainPanel.componentData.messageBoxModeButtons2"
                          :containerDivStyle="containerDivStyle"></oxygen-button-ribbon>
    <div style="/*border-top:solid 1px #0072C5;*/"
         v-show="showMessageBoxAttachmentsList ||
         mainPanel.componentData.showMessageBoxSchedule ||
         mainPanel.componentData.showMessageBoxScheduler ||
         mainPanel.componentData.showMessageBoxRecipientsTable ||
         mainPanel.componentData.showMessageBoxRecipientsList ||
         mainPanel.componentData.showMessageBoxSubjectTable ||
         mainPanel.componentData.showAgreementTitleTextbox">
      <div style="max-height:88px;overflow:auto;">
        <oxygen-menu-table
            v-show="showMessageBoxAttachmentsList"

            :tableData="mainPanel.componentData.messageBoxAttachmentsListTableData"
            ref="attachmentsMenuTable"
            @vue:mounted="attachmentsTableMounted"
            v-on:selected-rows-changed="selectedAttachmentsRowsChanged"
            :active-selection="false"
        ></oxygen-menu-table>
      </div>
      <!--
      <oxygen-menu-table

          :tableData="mainPanel.componentData.messageBoxScheduleTableData"
          ref="scheduleMenuTable"
          v-show="mainPanel.componentData.showMessageBoxSchedule"
      ></oxygen-menu-table>
      -->
      <div style="font-size:12px;" v-show="mainPanel.componentData.showMessageBoxSchedule">

        <div style="display:flex; align-items: center;">
          <span style="padding: 0px 10px; flex-grow:0;width:80px;">Start Time:</span>
          <Datepicker ref="startTime" style="flex-grow:1; font-size:12px;" v-model="startTime" utc></Datepicker>
        </div>
        <div style="display:flex; align-items: center;">
          <span style="padding: 0px 10px;flex-grow:0;width:80px;">End Time:</span>
          <Datepicker ref="endTime" style="flex-grow:1; font-size:12px;" v-model="endTime" utc></Datepicker>
        </div>


      </div>
      <div style="font-size:12px;" v-show="mainPanel.componentData.showMessageBoxScheduler">
        <oxygen-scheduler
            @schedule-data-changed="scheduleDataChanged"
        ></oxygen-scheduler>
      </div>
      <div style="max-height:174px;overflow:auto;">
        <oxygen-menu-table
            :tableData="mainPanel.componentData.messageBoxRecipientsTableData"
            ref="menuTable"
            v-on:selected-rows-changed="selectedRowsChanged"
            @vue:mounted="recipientsTableMounted"
            v-show="mainPanel.componentData.showMessageBoxRecipientsTable && !componentData.simpleMode"
            :active-selection="false"
        ></oxygen-menu-table>
      </div>
      <div style="width:100%;" v-show="mainPanel.componentData.showAgreementTitleTextbox">
        <InputString
            style="padding: 10px; width:95%"
            v-bind="agreementTitleTextboxProps"

            ref="agreementTitleInput"

        ></InputString>
      </div>

      <div style="width:100%; display: flex;" v-show="mainPanel.componentData.showMessageBoxRecipientsList && !componentData.simpleMode">
        <InputString
            style="padding: 10px; width:95%"
            v-bind="recipientsListTextboxProps"

            ref="recipientInput"

        ></InputString>

        <span style="padding: 0px 10px;cursor: pointer; align-content: center;" v-tooltip="{content: 'Upload Recipient List', popperClass: 'simplia-tooltip' }" @click="uploadRecipientList" class="fal fa-plus"></span>

      </div>
      <!--
            <v-select
                v-show="mainPanel.componentData.requestGuestAccountEnabled"
                class="simplia-select"
                style="margin-left:10px; margin-right:10px;"
                v-model="mainPanel.componentData.selectedRequestGuestAccountAtt"
                :options="mainPanel.componentData.requestGuestAccountAttList"
                @input="requestGuestAccountAttSelected"
            ></v-select>
            -->
    </div>
    <div style="font-size:12px; padding: 10px 5px;display: flex" v-show="mainPanel.componentData.showHomepageRole">
      {{mainPanel.componentData.homepageAccountTitle}}:&nbsp;
      <span style="flex-grow: 1;">
      <select v-model="mainPanel.componentData.homepageCurrentRoleAccount">
        <option  v-for="account in mainPanel.componentData.homepageCurrentRoleAccounts" :value="account.value">{{account.label}}</option>
      </select>&nbsp;
      </span>
      <span>
        <span style="padding: 0px 10px;cursor: pointer;" @click="addHomepageRoleRecipient" class="fal fa-plus"></span>
      </span>
    </div>

    <div style="font-size:12px;padding: 10px 5px;" v-show="mainPanel.componentData.showHomepageRole">
      Homepage Role:&nbsp;
      <select v-model="mainPanel.componentData.homepageRole">
        <option  v-for="role in mainPanel.componentData.homepageRoles" :value="role">{{role}}</option>
      </select>&nbsp;
    </div>
    <!-- <component
        v-show="showBodyComponent"
        v-if="bodyComponent"
        v-bind:is="bodyComponent"
        ref="bodyComponent"
    ></component> -->
    <squire-component
        v-if="showBodyComponent"
        ref="squireComponent"
        :data-viewportid="viewportID"
        :embed-mode="true"
    ></squire-component>
    <!--
    <div v-show="mainPanel.componentData.meetingLinkHidden" style="display: flex; height: 39px; align-items: center;"
         :style="{'color': fontColor, 'background-color': backgroundColor}">

    <span @click="meetingLinkCheckboxClicked"
          style="flex-grow: 0; cursor: pointer; margin-left:5px;margin-right: 20px;">
                      <span class="fal" :class="mainPanel.componentData.meetingLinkClass"></span>
                    </span>
      <span style="flex-grow: 1; overflow: hidden; text-overflow: ellipsis;"><span>{{mainPanel.componentData.meetingLink}}</span></span>
      <span @click="meetingLinkCopied" style="flex-grow: 0; cursor: pointer; margin-left:5px;margin-right: 5px;">
                      <span class="fal fa-copy"></span>
                    </span>
    </div>
    -->
    <div v-show="mainPanel.componentData.showSubject && !mainPanel.componentData.showHomepageRole && !componentData.simpleMode"
         style="display: flex; align-items: flex-end; background-color: white;">
      <oxygen-menu-table
          :tableData="mainPanel.componentData.messageBoxSubjectTableData"
          ref="subjectMenuTable"
          v-on:selected-rows-changed="subjectSelectedRowsChanged"
          @vue:mounted="subjectTableMounted"
          v-show="mainPanel.componentData.showMessageBoxSubjectTable"
          :active-selection="false"
      ></oxygen-menu-table>
      <div style="width:100%;" v-show="mainPanel.componentData.showMessageBoxSubjectInput ">
        <InputString
            style="padding: 10px;width: 95%"
            v-bind="subjectTextboxProps"
            :event-handlers="subjectInputEvents"
            desk-mode="false"

            :get-desk-channels="getDeskChannels"
            ref="subjectInput"
            :active-selection="false"
        ></InputString>
      </div>


    </div>
    <!--
    <div v-show="mainPanel.componentData.showEventSubject"
         style="display: flex; align-items: flex-end; background-color: white;">

      <input :placeholder="mainPanel.componentData.eventSubjectPlaceholder" wrap="off" ref="eventSubject"
             v-model="mainPanel.componentData.eventSubjectText"
             style="width: 100%;border: 0; height: 39px; padding-left: 6px; resize: none; overflow: hidden; background-color: white;"/>
    </div>-->
    <div style="display: flex; align-items: flex-end;"
         :style="{'color': fontColor, 'background-color': backgroundColor}">
      <div ref="textareaContainer" style="flex-grow: 1; height: auto; display: flex;">
        <InputString
            style="padding: 10px;width: 95%"
            v-bind="initialTextboxProps"
            v-show="componentData.showInitialInput"
            :event-handlers="initialInputEvents"

            v-model="componentData.initialInputText"
            ref="initialInput"
        ></InputString>

       <!-- <textarea placeholder="Text. Email. Call. Meet. Share." wrap="off" ref="textarea"
                  v-show="mainPanel.componentData.showTextarea"
                  v-model="mainPanel.componentData.messageBoxText" rows="2" cols="50"
                  style="width: 100%;border: 0; height: 39px; padding-left: 6px; resize: none; overflow: hidden; background-color: white; font-size:12px;"></textarea>
                  -->
        <InputTextareaString
            is-textarea="true"
            wrap="off"
            ref="textarea"
            :event-handlers="textareaEvents"
            v-bind="textareaProps"
            desk-mode="false"
            :get-desk-channels="getDeskChannels"
            :get-commands="getCommands"
            command-mode="true"
            v-show="componentData.showTextarea"
            @vue:mounted="textareaMounted"
            v-model="mainPanel.componentData.messageBoxText"
            rows="2"
            cols="50"
            style="width: 100%;border: 0; height: 39px; padding-left: 6px; resize: none; overflow: hidden; background-color: white; font-size:12px; word-wrap: break-word; text-wrap: wrap;"
        ></InputTextareaString>
      </div>
      <span style="display:flex; height: 39px;" :style="optionsStyle" ref="optionsSpan" v-show="!componentData.simpleMode">
        <!-- <span ref="switchDeskButton" v-tooltip="{content: 'Switch Desk'}"
              class="far fa-circle-nodes fa-rotate-by" :style="allButtonsStyle" style="-fa-rotate-angle: 80deg; padding: 9px 12px; cursor: pointer;" @click="switchDeskButtonClick">
          </span> -->
          <span ref="newContentButton" v-tooltip="{content: 'Add HTML Content', popperClass: 'simplia-tooltip'}" v-show="showHTMLContentButton"
                :class="newContentButtonClass" :style="allButtonsStyle" style="padding: 9px 12px; cursor: pointer;" @click="newContentButtonClick">
          </span>
          <span ref="scheduleButton" v-tooltip="{content: 'Schedule', popperClass: 'simplia-tooltip'}"
                class="fal fa-calendar-days" :style="allButtonsStyle" style="padding: 9px 12px; cursor: pointer;" @click="scheduleButtonClick">
          </span>
        <span ref="scheduleButton" v-tooltip="{content: 'Simple Scheduler', popperClass: 'simplia-tooltip'}"
              class="fal fa-calendar-range" :style="allButtonsStyle" style="padding: 9px 12px; cursor: pointer;" @click="schedulerButtonClick">
          </span>
          <!--
          <span ref="takePictureButton" v-tooltip="{content: 'Take Picture'}"
                class="far fa-camera" :style="allButtonsStyle" style="padding: 9px 12px; cursor: pointer;" @click="pictureButtonClick">
          </span> -->
          <span ref="attachButton" v-tooltip="{content: addAttachmentsTooltip, popperClass: 'simplia-tooltip' }"
                class="far fa-paperclip" :style="allButtonsStyle" style="padding: 9px 12px; cursor: pointer;" @click="attachButtonClick">
          </span>
        <!-- <span ref="recordButton" v-tooltip="{content: 'Record Message' }"
                        :class="componentData.recordButtonClass" :style="allButtonsStyle" style="padding: 9px 12px; cursor: pointer;" @click="recordButtonClick">
          </span> -->

      </span>

    </div>
    <div style="display: flex;" :style="{'justify-content': componentData.simpleMode ? 'flex-end' : 'normal'}">
      <oxygen-ribbon
          v-show="!componentData.simpleMode"
          @vue:mounted="settingsRibbonMounted"
          style="flex-grow:1;/*border-bottom: 1px solid lightgrey;*/  border-top: 1px solid lightgrey;"
          ref="settingsRibbon"
          :rightRibbonWrap="rightRibbonWrap"
      ></oxygen-ribbon>
      <button
          v-if="mainPanel.componentData.messageBoxModeButtons.length"
          v-show="selectedModeButton"
          @click="actionButtonClick"
          type="button"
          style="height: 27px; flex-grow: 0; border-radius: 0.3em;"
          class="dhx_button dhx_button--color_primary dhx_button--size_medium dhx_button--view_flat"
      >
        <span class="dhx_button__text" :class="selectedModeButton.class || {}">{{selectedModeButton.html}}</span>
      </button>
    </div>
  </div>

  <options-menu
      :title="containerTitle"
      :container-name="containerName"
      :options="options"
      :width="menuWidth"
      @row-selected="optionsMenuRowSelected"
      @row-deselected="optionsMenuRowDeselected"
      ref="newOptionsMenu"
  ></options-menu>


  <options-menu
      :title="simpleMenuContainerTitle"
      :container-name="simpleMenuContainerName"
      :options="simpleMenuOptions"
      :width="simpleMenuWidth"
      ref="simpleOptionsMenu"
      :show-checkbox="false"
      :show-folder="false"
  ></options-menu>

  <p-e-details
      :detailsData="componentData.detailsData"
      :add-thread="componentData.addThreadInDetailsForm"
      :subject-role-label="componentData.subjectRoleLabelInDetailsForm"
      :subject-label="componentData.subjectLabelInDetailsForm"
      :subject-role-change="componentData.subjectRoleChangeInDetailsForm"
      ref="detailsForm"
  ></p-e-details>

  <options-menu
      title="Menu"
      :container-name="ribbonMenuContainerName"
      :options="ribbonOptions"
      :width="ribbonMenuWidth"
      ref="ribbonMenu"
      @row-selected="ribbonMenuRowSelected"
      @row-deselected="ribbonMenuRowDeselected"
  ></options-menu>
  <form-container
      :title="formContainerTitle"
      :form-rows="formRows"
      ref="formContainer"
  ></form-container>
  <multiple-forms-container
      :title="multipleFormsContainerTitle"
      :viewport-i-d="viewportID"
      :client-i-d="ClientID"
      :form-rows="multipleFormsRows"
      :buttons="multipleFormsButtons"
      :form-width="multipleFormsWidth"
      :initial-form-data="initialMultipleFormsData"
      :allow-new="multipleFormsAllowNew"
      ref="multipleFormsContainer"
  ></multiple-forms-container>
</template>

<script>
import OxygenButtonRibbon from './../OxygenButtonRibbon/OxygenButtonRibbon.vue';
import OxygenRibbon from './../OxygenRibbon/OxygenRibbon.vue';
import OxygenMenuTable from './../OxygenMenuTable/OxygenMenuTable.vue';
//import vSelect from "vue-select";
//import 'vue-select/dist/vue-select.css';
import * as oxygenUtil from './../OxygenUtil/oxygenutil.js';
import InputString from './../InputString/InputString.vue';
import * as async from 'async-es';
import * as historyLib from "./../HistoryLib/historylib";
import SquireComponent from './../SquireComponent/SquireComponent.vue';
import OptionsMenu from './../OptionsMenu/OptionsMenu.vue';
import PEDetails from './../PEDetails/PEDetails.vue';
import FormContainer from './../FormContainer/FormContainer.vue';
import Datepicker from '@vuepic/vue-datepicker';
import InputTextareaString from './../InputTextareaString/InputTextareaString.vue';
import { vTooltip } from 'floating-vue';
import MultipleFormsContainer from './../MultipleFormsContainer/MultipleFormsContainer.vue';
import OxygenScheduler from './../OxygenScheduler/OxygenScheduler.vue';


export default {
  directives: {
    tooltip: vTooltip
  },
  components: {
    OxygenScheduler,
    MultipleFormsContainer,
    OptionsMenu,
    SquireComponent,
    OxygenButtonRibbon,
    OxygenRibbon,
    OxygenMenuTable,
    PEDetails,
    //vSelect,
    //TemplateAttachmentSecondRow,
    InputString,
    FormContainer,
    Datepicker,
    InputTextareaString
    //,
    //BodyComponent,
    //DTComponent,
    //TimezoneComponent
  },
  props: {
    viewportID: String,
    ClientID: String,
    defaultMessage: {
      type: String,
      default: ''
    },
    parent: {
      type: Object
    }
  },
  data: () => {
    return {
      createAIAppMessage: `What would you like to name your Smart Agent? The name should be at least 8 characters long; otherwise, it will be padded. If the name you specified is already taken, you can still use it with an added 4-digit suffix. You can always rename your App in the future.`,
      createSimpleTableMessage: `What would you like to name your Simple Table? The name should be at least 8 characters long; otherwise, it will be padded. If the name you specified is already taken, you can still use it with an added 4-digit suffix. You can always rename your Simple Table in the future.`,
      showMessageBox: true,
      lastParentMode: '',
      lbmAppId: '_FFFFFFFFFFFFFF00001702665676367014_',
      eventsAdded: false,
      standardTaskTemplateId: '_FF07508219919316956629008089530238_',
      lastTasksViewportId: '',
      textareaActivityFlag: false,
      startTime: '',
      endTime: '',
      formContainerTitle: '',
      multipleFormsContainerTitle: '',
      lastSelectedContentTemplate: '',
      formRows: [],
      multipleFormsRows: [],
      multipleFormsButtons: [],
      multipleFormsAllowNew: false,
      initialMultipleFormsData: [],
      currentMessageTemplates: [],
      multipleFormsWidth: 400,
      selectedRole: '',
      ribbonOptions: [],
      ribbonMenuWidth: '350px',
      menuWidth: '350px',
      simpleMenuWidth: '350px',
      rolesTableData: {
        showCheckbox: false
      },
      roleModalName: `modal${oxygenUtil.getUUID()}`,
      roleModalTitle: `Role`,
      containerTitle: 'Add Attachment(s)',
      simpleMenuContainerTitle: 'Options',
      roles: [],
      roleModalStyles: {},
      containerName: `menu${oxygenUtil.getUUID()}`,
      simpleMenuContainerName: `menu${oxygenUtil.getUUID()}`,
      ribbonMenuContainerName: `ribbonMenu${oxygenUtil.getUUID()}`,
      simpleMenuOptions: [],
      options: [
        {
          icon: `fal fa-inbox-in`,
          title: 'Inbox',
          callback: ()=>{

          },
          path: '000-inbox'
        }
      ],
      newContentButtonClass: {
        'far': true,
        'fa-plus': true,
        'fa-minus': false
      },
      supportDomain: "simpliasupport.com",
      _componentData: {
        recordingState: false,
        recordButtonClass: {
          'far': true,
          'fa-microphone': true,
          'fa-microphone-slash': false
        },
        messageBoxMode: '',
        simpleMode: false,
        SMSCallParams: {},
        lastConversationMessageEventId: '',
        currentConversationRootThreadId: '',
        newBotRootThreadId: '',
        conversationPE: '',
        minimalMode: false,
        currentlyConnectedBot: '',
        commandMode: false,
        channelMessageSet: false,
        currentComponentDialogues: [],
        openAIDialogues: [],
        deskMode: false,
        botMode: false,
        replyMode: false,
        currentCommand: '',
        nextCommandStep: '',
        currentCommandData: {},
        lastReplyMessage: '',
        conversationMode: false,
        directBot: false,
        botService: '',
        botCommunicationMode: false,
        homepageAccountTitle: '',
        textareaPlaceholder: 'Message',
        currentContactsModeViewport: '',
        clientContactsMode: '',
        currentForwardedMessage: null,
        currentInboxFocusedMessage: null,
        showMessageBoxSubjectInput: true,
        shareAsAdminFlag: false,
        showMessageBoxSubjectTable: false,
        subjectRoleChangeInDetailsForm: ()=>{},
        detailsData: {},
        addThreadInDetailsForm: true,
        subjectRoleLabelInDetailsForm: 'Subject Role',
        subjectLabelInDetailsForm: 'Subject',
        replyFlags: {
          reply: false,
          replyAll: false,
          replyRole: false,
          replySelf: false,
          replyBot: false,
          replySelect: false,
          replySelectInbox: false,
          replySelectContacts: false,
          replySelectAttachments: false,
          replyRecipients: false
        },
        currentReplyIcon: 'fal fa-list',
        attachmentsSelectionFlag: false,
        viewportSelectEnabled: false,
        meetingLinkDisplayed: false,
        meetingLinkHidden: false,
        messageBoxModeButtons: [],
        messageBoxModeButtons2: [],
        meetingLinkClass: {
          'fa-square': true,
          'fa-check-square': false
        },
        meetingLink: 'Select the checkbox to create meeting link',
        messageBoxModes: {
          'meetingMode': {
            set: 'setMeetingMode',
            unset: 'unsetMeetingMode',
            buttons: 'messageBoxMeetingModeButtons',
            default: 'invite',
            toggle: 'toggleMeetingMode',
            showActionButton: true,
            name: 'meetingMode'
          },
          'sendMode': {
            set: 'setSendMode', unset: 'unsetSendMode', buttons: 'messageBoxSendModeButtons', default: 'send', toggle: 'toggleSendMode', name: 'sendMode'
          },
          'shareMode': {
            set: 'setShareMode', unset: 'unsetShareMode', buttons: 'messageBoxShareModeButtons', default: 'offer', toggle: 'toggleShareMode', name: 'shareMode'
          },
          'contactsMode':{
            set: 'setContactsMode', unset: 'unsetContactsMode', buttons: 'messageBoxContactsModeButtons', default: 'offer', toggle: 'toggleContactsMode', name: 'contactsMode'
          },
          'promiseMode': {
            set: 'setPromiseMode', unset: 'unsetPromiseMode', buttons: 'messageBoxPromiseModeButtons', default: 'promise', toggle: 'togglePromiseMode', name: 'promiseMode'
          },
          'homepageAssignMode': {
            set: 'setHomepageAssignMode', unset: 'unsetHomepageAssignMode', buttons: 'messageBoxHomepageAssignModeButtons', default: 'assign_homepage', toggle: 'toggleHomepageAssignMode', name: 'homepageAssignMode'
          },
          'agreementMode': {
            set: 'setAgreementMode', unset: 'unsetAgreementMode', buttons: 'messageBoxAgreementModeButtons', default: 'offer', toggle: 'toggleAgreementMode', name: 'agreementMode'
          }

        },
        messageBoxText: '',
        showTextarea: false,
        showInitialInput: true,
        initialInputText: '',
        eventSubjectText: '',
        eventSubjectPlaceholder: 'Subject',
        showEventSubject: false,
        priorityConfig: {},
        messageBoxStateInitialized: false,
        messageBoxRecipientsTableInitialized: false,
        messageBoxSubjectTableData: {
          showHeader: false,
          showCheckbox: false,
          showFolder: false,
          showRightMenu: true,
          cols: [
            {
              type: 'icon',
              callback: ()=>{},
              header: {
                type: 'html',
                html: ''
              }
            },
            {
              type: 'html',
              callback: () => {
              },
              header: {
                type: 'html',
                html: ''
              }
            },
            {
              type: 'icon',
              callback: ()=>{},
              header: {
                type: 'html',
                html: ''
              }
            }
          ]
        },
        messageBoxRecipientsTableStyle: {
          display: 'none',
          overflow: 'none'
        },
        messageBoxRecipientsTableData: {
          showHeader: false,
          showCheckbox: false,
          showFolder: false,
          showRightMenu: true,
          cols: [
            {
              type: 'icon',
              callback: ()=>{},
              header: {
                type: 'html',
                html: ''
              }
            },
            {
              type: 'html',
              callback: () => {
              },
              header: {
                type: 'html',
                html: ''
              }
            },
            {
              type: 'icon',
              callback: ()=>{},
              header: {
                type: 'html',
                html: ''
              }
            }
          ]
        },
        showMessageBoxRecipientsList: false,
        showHomepageRole: false,
        homepageRole: '',
        homepageRoles: [],
        homepageCurrentRoleAccount: '',
        homepageCurrentRoleAccounts: [],
        homepageAccountsMap: {},
        showAgreementTitleTextbox: false,
        messageBoxAttachmentsTableInitialized: false,
        showMessageBoxAttachmentsInputBox: false,
        messageBoxAttachmentsFlag: false,
        messageBoxAttachmentsListTableData: {
          showHeader: false,
          showCheckbox: false,
          showFolder: false,
          showRightMenu: true,
          cols: [
            {
              type: 'icon',
              callback: ()=>{},
              header: {
                type: 'html',
                html: ''
              }
            },
            {
              type: 'html',
              callback: () => {
              },
              header: {
                type: 'html',
                html: ''
              }
            },
            {
              type: 'icon',
              callback: ()=>{},
              header: {
                type: 'html',
                html: ''
              }
            },
            {
              type: 'icon',
              callback: ()=>{},
              header: {
                type: 'html',
                html: ''
              }
            }
          ]
        },
        showMessageBoxSchedule: false,
        showMessageBoxScheduler: false,
        messageBoxScheduleTableInitialized: false,
        messageBoxScheduleTableData: {
          showHeader: false,
          showCheckbox: false,
          showFolder: false,
          showRightMenu: true,
          cols:  [
            {
              type: 'html',
              callback: ()=>{},
              header: {
                type: 'html',
                html: ''
              }
            },
            {
              type: 'html',
              callback: () => {
              },
              header: {
                type: 'html',
                html: ''
              }
            },
            {
              type: 'html',
              callback: ()=>{},
              header: {
                type: 'html',
                html: ''
              }
            }
          ]
        },
        modeArgs: []
      },
      replyOptionsList: ["replyAll", "replyRole", "replySelf", "replyBot", "replySelect", "replyRecipients"],
      rightRibbonWrap: 'nowrap',
      settingsRibbonHeaderStyle: {
        'flex-grow': 1
      },
      currentSimpleMode: '',
      toggleRibbonIconIds: {
        expand: 'far fa-angle-double-down',
        collapse: 'far fa-angle-double-up'
      },
      initializeFnMap: new Map(),
      modeRibbonParent: {
        ribbonBGColor: "#E5E4E2",
        ribbonIconsColor: "black",
        selectedRibbonIconColor: "#0072C5",
        selectedRibbonBorder: "solid 1px #0072C5"
      },
      selectionEnabled: false,
      ribbonMenuInitialized: 0,
      embeddedMessageAttachment: null,
      htmlBodyTip: '',
      htmlMessage: '',
      bodyComponent: '',
      bodyComponentProps: {},
      bodyComponentDivId: '',
      showBodyComponent: false,
      recipientTextboxPath: '00000',
      startTimePath: '00000',
      endTimePath: '00001',
      timezonePath: '00002',
      rowTypes: {
        attachment: 'attachment',
        thread: 'thread',
        contact: 'contact',
        email: 'email',
        phone: 'phone',
        validatedPE: 'validatedPE',
        string: 'string',
        PE: 'PE',
        channel: 'channel'
      },
      message: '',
      iconIds: {
        channel: 'fal fa-hashtag',
        homepage: 'far fa-home',
        UIMenu: 'far fa-ellipsis-v',
        reply: '_FFFFFFFFFFFFFF00001606173378480016_',
        selected: `grey-background`,
        replyAll: 'fal fa-reply',
        replyRole: 'fal fa-share-alt',
        replySelf: 'fal fa-user-shield',
        replyBot: 'far fa-robot',
        replySelect: 'fal fa-check-square',
        options: 'far fa-bars',
        attach: 'fal fa-paperclip',
        attachment: 'fal fa-paperclip',
        advanced: {
          type: 'html',
          html: `<span class="fa-stack" ><i class="fal fa-plus fa-stack-1x" style="     vertical-align: middle;      "></i><i class="far fa-paper-plane " style="     vertical-align: middle; "></i></span>`
        },
        send: "far fa-paper-plane",
        replyRecipients: "fal fa-list",
        //recipient: 'fal fa-reply fa-flip-horizontal',
        recipient: 'fal fa-address-book',
        savedTemplate: "far fa-plus",
        meetingLink: "fal fa-link",
        blank: '',
        remove: 'fas fa-times',
        schedule: 'fal fa-calendar-alt',
        inbox: 'fal fa-inbox-in',
        subject: 'fal fa-notes',

        threadSubject: {
          type: 'html',
          html: `<span class="icon-thread16-simplia"></span>`
        },
        //threadSubject: "fal fa-inbox-in",
        attachments: 'far fa-folder',
        contacts: 'far fa-address-book',
        media: 'fal fa-music',
        sms: 'fal fa-sms',
        email: 'fal fa-at',
        setupSchedule: 'fal fa-calendar-check',
        message: 'fal fa-comment-plus',
        page: 'fal fa-walkie-talkie',
        call: 'fal fa-phone-plus',
        share: 'fal fa-share-alt-square',
        offer: 'fal fa-hand-holding fa-rotate-180',
        request: 'fal fa-hand-holding',
        setupSend: 'far fa-paper-plane',
        link: 'fal fa-link',
        meet: 'fal fa-video',
        promise: 'fal fa-handshake',
        save: 'fal fa-save',
        cancel: 'fas fa-times',
        help: 'fal fa-question-circle',
        saveAsTemplate: 'fal fa-save',
      },
      roleSingleSelect: true,
      containerDivStyle: {
        'justify-content': 'space-between'
      },
      simpleStringRowComponent: '',
      accountRoles: [],
      lastRoleClickEvent: '',
      emailMessages: [],
      phoneMessages: [],
      recipientPathPrefix: "___",
      unwatchFns: [],
      buttonOpsQueue: [],
      ribbonOpsQueue: [],
      currentButtonMenuItems: [],
      postMountTasks: [],
      postActionMenuActions: [],
      allIcons: ['reply', 'replyAll', 'replySelf', 'replyBot', 'replySelect', 'attach', 'replyRecipients', 'replyRole'],
      _selectionEventsSet: false,
      recipientsListTextboxProps: {
        addValuesToMessageBox: true,
        placeholder: 'Name, Phone or Email',
        value: '',
        parent: '',
        menuTable: '',
        messageBoxComponent: '',
        mainPanel: ''
      },
      agreementTitleTextboxProps: {
        addValuesToMessageBox: false,
        placeholder: 'Agreement Title',
        value: '',
        parent: '',
        menuTable: '',
        messageBoxComponent: '',
        mainPanel: ''
      },
      subjectTextboxProps: {
        addValuesToMessageBox: true,
        placeholder: 'Subject',
        value: '',
        parent: '',
        menuTable: '',
        messageBoxComponent: '',
        mainPanel: '',
        defaultRole: 'visitor'
      },
      textareaProps: {
        placeholder: 'Message',
        value: '',
        parent: '',
        menuTable: '',
        messageBoxComponent: '',
        mainPanel: ''
      },
      initialTextboxProps: {
        addValuesToMessageBox: false,
        placeholder: "Text. Email. Call. Meet. Share.",
        value: '',
        parent: '',
        menuTable: '',
        messageBoxComponent: '',
        mainPanel: ''
      },
      gatewayGrant: "",
      attributionRecord: "",
      AIAppTemplate: "_FF10417414215817153025902968394051_",
      OpenAIAppTemplate: "_FF07508219919317151983433656234605_",
      DeepSeekAppTemplate: "_FF07508219919317380185511195822506_",
      trainerRole: 'trainer'
    }
  },
  computed: {
    showHTMLContentButton() {
      return !this.currentSimpleMode || (this.currentSimpleMode !== 'sms');
    },
    messageCommands() {
      return {
        //'/create Smart Link': this.createSmartLink.bind(this),
        '/create Labeled Smart Link': this.createLabelledSmartLink.bind(this),
        '/create Labeled Anonymous Smart Link': this.createLabelledAnonymousSmartLink.bind(this),
        '/create Smart Agent (Claude)': this.createAIApp.bind(this),
        //'/create Agent (DeepSeek)': this.createDeepSeekApp.bind(this),
        '/create Smart Agent': this.createOpenAIApp.bind(this),
        //'/create Simple Table': this.createSimpleTable.bind(this),
        '/offer': ()=>{},
        '/request': ()=>{},
        '/agree': ()=>{}
        //'/create component': this.createComponentCommand.bind(this)
      }
    },
    DeskContext() {
      let context = {};
      if(this.client && this.client.DeskContext) {
        this.componentData.deskMode = true;
        context = JSON.parse(this.client.DeskContext);
      }
      return context;
    },
    CurrentContext() {

      let context = {};
      if(this.client && this.client.CurrentContext) {
        context = JSON.parse(this.client.CurrentContext);
      }
      return context;

    },
    subjectInputEvents() {
      return {
        keyup: this.handleSubjectInputKeyupEvent.bind(this)
      }
    },
    textareaEvents() {
      return {
        keyup: this.handleTextareaKeyupEvent.bind(this)
      };
    },
    initialInputEvents() {
      return {
        keyup: this.handleInitialInputKeyupEvent.bind(this)
      };
    },
    addAttachmentsTooltip() {
      if(['offer_task','request_task'].includes(this.currentSimpleMode)){
        return `Add Task(s)`
      }
      return `Add ${oxygenUtil.config.attachmentsTitle}`
    },
    allButtonsStyle() {
      return { color: oxygenUtil.defaultIconColor }
    },
    geolocation() {
      return window.LivingScript_0070.globalContext.geolocation;
    },
    initialContextEmails() {
      let parsedContext, emails = [];
      if(this.client.InitialContext && (parsedContext = oxygenUtil.tryParseJSON(this.client.InitialContext))) {
        if (parsedContext.Email) {
          emails = Array.isArray(parsedContext.Email) ? parsedContext.Email : [parsedContext.Email];
        }
      }
      return emails;
    },
    initialContextPhones() {
      let parsedContext, phoneNumbers = [];
      if(this.client.InitialContext && (parsedContext = oxygenUtil.tryParseJSON(this.client.InitialContext))) {
        if(parsedContext.PhoneNumber) {
          phoneNumbers = Array.isArray(parsedContext.PhoneNumber) ? parsedContext.PhoneNumber : [parsedContext.PhoneNumber];

        }
      }
      return phoneNumbers;
    },
    replyOptions() {
      return [
        {
          icon: this.iconIds.replyRecipients,
          title: 'To List',
          callback: (data)=>{
            //console.log('replyOptions-callback', 'replyRecipients');
            this.setReplyIcon('replyRecipients');
            /*
            this.$refs.settingsRibbon.updateIconInfo(
                "reply",
                { type: "css", classes: `${this.iconIds.replyRecipients} ${this.iconIds.selected}`}
            );

             */
            this.componentData.currentReplyIcon = `${this.iconIds.replyRecipients} ${this.iconIds.selected}`;
          },
          path: '000-to-list',
          menuParams: {
            selected: this.componentData.replyFlags['replyRecipients']
          }
        },
        {
          icon: this.iconIds.replySelect,
          title: 'Select Recipients From',
          callback: (data, dataRow, index, menuTable)=>{
            //this.setReplyIcon('replySelect');
            menuTable.folderClick(dataRow, index);
          },
          path: '000-select',
          hideMenu: false
        },
        {
          icon: `far fa-address-book`,
          title: 'Contacts',
          callback: ()=>{
            this.selectOptionClicked('showContacts', '000-select/contacts', 'replySelectContacts');
            /*
            this.$refs.settingsRibbon.updateIconInfo(
                "reply",
                { type: "css", classes: `${this.iconIds.replySelect} ${this.iconIds.selected}`}
            );

             */
            this.componentData.currentReplyIcon = `${this.iconIds.replySelect} ${this.iconIds.selected}`;
          },
          path: '000-select/contacts',
          menuParams: {
            selected: this.componentData.replyFlags['replySelectContacts']
          }
        },
        {
          icon: `fal fa-inbox-in`,
          title: 'Inbox',
          callback: ()=>{
            this.selectOptionClicked('showInbox', '000-select/inbox', 'replySelectInbox');
            /*
            this.$refs.settingsRibbon.updateIconInfo(
                "reply",
                { type: "css", classes: `${this.iconIds.replySelect} ${this.iconIds.selected}`}
            );

             */
            this.componentData.currentReplyIcon = `${this.iconIds.replySelect} ${this.iconIds.selected}`;
          },
          path: '000-select/inbox',
          menuParams: {
            selected: this.componentData.replyFlags['replySelectInbox']
          }
        },
        {
          icon: `far fa-folder`,
          title: oxygenUtil.config.attachmentsTitle,
          callback: ()=>{
            this.componentData.attachmentsSelectionFlag = false;
            this.selectOptionClicked('showAttachments', '000-select/attachments', 'replySelectAttachments');
            /*
            this.$refs.settingsRibbon.updateIconInfo(
                "reply",
                { type: "css", classes: `${this.iconIds.replySelect} ${this.iconIds.selected}`}
            );

             */
            this.componentData.currentReplyIcon = `${this.iconIds.replySelect} ${this.iconIds.selected}`;
          },
          path: '000-select/attachments',
          menuParams: {
            selected: this.componentData.replyFlags['replySelectAttachments']
          }
        }
      ];
      /*
      [
                    this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
                    this.iconIds.replyAll,
                    "replyAll",
                    this.setReplyIcon.bind(this, 'replyAll'),
                    "replyAll",
                    {},
                    this.$refs.settingsRibbon,
                    {
                        menuIcon: true,
                        group: this.replyOptionsList
                    }
                ],
                [
                    this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
                    this.iconIds.replyRole,
                    "replyRole",
                    this.setReplyIcon.bind(this, 'replyRole'),
                    "replyRole",
                    {},
                    this.$refs.settingsRibbon,
                    {
                        menuIcon: true,
                        group: this.replyOptionsList
                    }
                ],
                [
                    this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
                    this.iconIds.replySelf,
                    "replySelf",
                    this.setReplyIcon.bind(this, 'replySelf'),
                    "replySelf",
                    {},
                    this.$refs.settingsRibbon,
                    {
                        menuIcon: true,
                        group: this.replyOptionsList
                    }
                ],
                [
                    this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
                    this.iconIds.replyBot,
                    "",
                    this.setReplyIcon.bind(this, 'replyBot'),
                    "replyBot",
                    {},
                    this.$refs.settingsRibbon,
                    {
                        menuIcon: true,
                        group: this.replyOptionsList
                    }
                ],
                [
                    this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
                    this.iconIds.replySelect,
                    "replySelect",
                    this.setReplyIcon.bind(this, 'replySelect'),
                    "replySelect",
                    {},
                    this.$refs.settingsRibbon,
                    {
                        showFolder: true,
                        group: this.replyOptionsList
                    }
                ],
                [
                    this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
                    this.iconIds.replyRecipients,
                    "replyRecipients",
                    this.setReplyIcon.bind(this, 'replyRecipients'),
                    "replyRecipients",
                    {},
                    this.$refs.settingsRibbon,
                    {
                        menuIcon: true,
                        group: this.replyOptionsList
                    }
                ],
       */

    },
    addTasksOptions() {
      return [
        {
          icon: `fal fa-list-check`,
          title: `Create New Task`,
          callback: ()=>{
            this.createNewTaskClicked();
          },
          path: '000-new-task'
        },
        {
          icon: `fal fa-list-check`,
          title: `Select Existing Task(s)`,
          callback: ()=> {
            if(this.client.childViewports && this.client.childViewports.showTasks) {
              this.componentData.attachmentsSelectionFlag = true;
              this.client.childViewports.showTasks();
            }
          },
          path: '001-existing-task'
        },
      ];
    },

    addAttachmentOptions() {
      return [
        {
          icon: `far fa-upload`,
          title: `Upload ${oxygenUtil.config.attachmentTitle}(s)`,
          callback: ()=>{
            //this.showUploadViewport();
            if(!this.client.fileUploadEvent) {
              //this.setupFileUploadEvent()
            }
            this.showUploadViewport();
          },
          path: '000-upload'
        },
        {
          icon: `far fa-folder`,
          title: `Select Existing ${oxygenUtil.config.attachmentTitle}(s)`,
          callback: ()=> {
            if(this.client.childViewports && this.client.childViewports.showAttachments) {
              this.componentData.attachmentsSelectionFlag = true;
              this.client.childViewports.showAttachments();
            }
          },
          path: '001-attachments'
        },
      ];
    },
    componentData() {
      /*
      if(!window._clientData) {
        window._clientData = {};
      }
      if(!window._clientData[this.client.Client]) {
        window._clientData[this.client.Client] = {}
      }
      if(!window._clientData[this.client.Client].componentData) {
        window._clientData[this.client.Client].componentData = this._componentData;
      }


      return window._clientData[this.client.Client].componentData;

       */
      if(!this.client.componentData) {
        this.client.componentData = this._componentData;
      }
      return this.client.componentData;
    },
    client() {
      let client = window.devStore ? window.devStore.clients.find(e => (e.Client === this.ClientID)) : { Client: oxygenUtil.getGUID()};
      return client;
    },
    clientContext() {
      let context = {};
      if(this.client && this.client.ClientContext) {
        context = JSON.parse(this.client.ClientContext);
      }
      return context;
    },
    meetingContext() {
      let context = {};
      if(this.client && this.client.MeetingContext) {
        context = JSON.parse(this.client.MeetingContext);
      }
      return context;
    },
    viewport() {
      return window.devStore ? window.devStore.viewPorts.find(e => (e.viewportID === this.viewportID)) : { viewportID: oxygenUtil.getGUID()};
    },
    actualContextPE() {
      return this.client ? oxygenUtil.createSimpleOES([this.client.ClientLeftRole, this.client.ClientLeft, this.client.ClientRightRole, this.client.ClientRight]) : '';
    },
    contextPE() {
      return this.client ?
          ( (window.LivingScript_0070.context.credentialId === this.client.ClientRight) ?
              ( oxygenUtil.createSimpleOES([this.client.ClientRightRole, this.client.ClientRight, this.client.ClientRightRole, this.client.ClientRight]) ):
              oxygenUtil.createSimpleOES([this.client.ClientLeftRole, this.client.ClientLeft, this.client.ClientRightRole, this.client.ClientRight]) ):
          oxygenUtil.createSimpleOES(['admin', '_FFFFFFFFFFFFFF00001567723986493004_', 'admin', '_FFFFFFFFFFFFFF00001567723986493004_']);
    },
    parsedContextPE() {
      return oxygenUtil.parseOES(this.contextPE).segments;
    },
    optionsStyle() {
      return {
        'color': 'black',
        'background-color': 'white'
      }
    },
    backgroundColor() {
      return 'white';
    },
    fontColor() {
      return 'grey';
    },
    envelopeByPE() {

      return this.componentData.priorityConfig.ByPE || (this.parsedContextPE[2] === this.trainerRole) ?
          oxygenUtil.createSimpleOES([this.trainerRole, this.parsedContextPE[3], this.trainerRole, this.parsedContextPE[3]])  : this.contextPE;
    },
    showMessageBoxAttachmentsList() {
      return this.componentData.showMessageBoxAttachmentsList || this.componentData.showMessageBoxAttachmentsInputBox;
    },
    meetingLinkChecked() {
      return this.componentData.meetingLinkClass['fa-check-square'];
    },
    modeButtonStyles() {
      return {
        bgColor: 'white',
        color: '#0072C5',
        selectedBgColor: 'rgba(0, 0, 0, 0.15)',
        selectedColor: '#0072C5',
        selectedBorder: 'solid 1px black'
      };
    },
    GatewayPE() {
      return  this.gatewayGrant ? this.gatewayGrant.GrantPE : oxygenUtil.createSimpleOES(['admin',oxygenUtil.Cookies.get('credentialId'), 'admin', oxygenUtil.Cookies.get('credentialId')]);
    },
    GatewayGrantId() {
      return this.gatewayGrant ? this.gatewayGrant.GrantID : '';
    },
    CredentialPE() {
      //Cookies.get(this.parent.config.cookies.names.credentialPE);

      return this.attributionRecord ? this.attributionRecord.CredentialPE : oxygenUtil.createSimpleOES(['admin', oxygenUtil.Cookies.get('credentialId'), 'admin', oxygenUtil.Cookies.get('credentialId')]);
    },
    AgentOfPE() {
      return this.attributionRecord ? this.attributionRecord.AgentOfPE :  oxygenUtil.createSimpleOES(['admin', oxygenUtil.Cookies.get('credentialId'), 'admin',oxygenUtil.Cookies.get('credentialId')]);
    },
    mainPanel() {
      return {
        componentData: this.componentData,
        GatewayPE: this.GatewayPE,
        GatewayGrantId: this.GatewayGrantId,
        AgentOfPE: this.AgentOfPE,
        atComponent: this.componentData.atComponent,
        asComponent: this.componentData.asComponent
      };
    },
    selectedMode() {
      return Object.keys(this.componentData.messageBoxModes).find(
          e => this.componentData[e]
      );
    },
    selectedModeButton() {
      return this.messageBoxModeAllButtons.find(e => e.selected);
    },
    messageBoxModeAllButtons() {
      //return [].concat(this.componentData.messageBoxModeButtons, this.componentData.messageBoxModeButtons2)
      return this.componentData.messageBoxModeButtons;
    }
  },
  created() {
    if(window.DevMgr) {
      window.DevMgr.addMessageBox(this.viewportID, this);
    }
    else {
      this.viewport.MessageBox = this;
    }

    if(!window._simpliaEvent) {
      window._simpliaEvent = true;
      oxygenUtil.createScriptTag('/simplia/serverfilepath/Code/github/OxygenWidgets-0026/SimpliaEvent/index.js');
    }

    setTimeout(async ()=>{
      if(!this.componentData.asComponent) {
        //console.log('messagebox-mounted - doing fetches');
        this._componentData.propagatorId = oxygenUtil.getGUID();
        this.setupPropagator();
        this._componentData.asComponent = await oxygenUtil.getComponent(this.parsedContextPE[1]);
        this._componentData.atComponent = await oxygenUtil.getComponent(this.parsedContextPE[3]);
        this._componentData.contextPEGrant = await oxygenUtil.getGrantFromPE(this.contextPE);
        this._componentData.currentComponentDialogues = ( this._componentData.atComponent.CurrentContext && this._componentData.atComponent.CurrentContext.OpenAIDialogues ) || [];
      }
      this.attributionRecord = await oxygenUtil.getAttributionRecord(this.client.Attribution);
      if(this.attributionRecord) {
        this.gatewayGrant = await oxygenUtil.getGrantFromPE(this.attributionRecord.GatewayPE);
      }
      else {
        this.gatewayGrant = await oxygenUtil.getGrantFromPE(this.GatewayPE);
      }

    },0);
    this.addButtons();
    if(!window.oxygenUtil) {
      window.oxygenUtil = oxygenUtil;
    }
    //this.templateAttachmentSecondRowComponent = this.createTemplateAttachmentSecondRowComponent();
    /*
    if (!this.uiMenu) {
      this.createMainUIMenu(() => {
      });
    }
    if (!this.replyOptionsUIMenu) {
      this.createReplyOptionsUIMenu(() => {
      });
    }

     */
    this.accountRoles.push(
        {role: 'holder', selected: false},
        {role: 'admin', selected: true},
        {role: 'bot', selected: false}
    );

    /*
this.getReplyAllRecipients((error, recipients)=>{
this.replyAllRecipients = recipients;
});

*/
    this.recipientsListTextboxProps.placeholder = 'Name, Phone or Email';
    this.textareaProps.messageBoxComponent = this.recipientsListTextboxProps.messageBoxComponent =
        this.initialTextboxProps.messageBoxComponent =
        this.subjectTextboxProps.messageBoxComponent =
            this.agreementTitleTextboxProps.messageBoxComponent = this;
    this.textareaProps.placeholder = this.componentData.textareaPlaceholder;

    //console.log('messagebox-created - done');
    if(!this.client.fileUploadCallbacks) {
      this.client.fileUploadCallbacks = {};
    }
  },
  mounted() {
    //window.messageBox = this;
    //window.oxygenUtil = oxygenUtil;
    if(!window.messageBoxes) {
      window.messageBoxes = {};
    }
    window.messageBoxes[`id${oxygenUtil.getUUID()}`] = this;

    document.getElementById(this.viewportID).querySelector('div[name="oxygen-footer"]').style['border-top'] = '1px solid lightgrey';

    this.$nextTick(function () {
      this.$nextTick(function () {


        if (!this.componentData.messageBoxScheduleTableInitialized) {
          this.componentData.messageBoxScheduleTableInitialized = true;
          //this.initializeScheduleTable();
        }

      });

      if(!this.currentSimpleMode && this.componentData.modeArgs.length) {
        this.selectModeLocally(...this.componentData.modeArgs);
      }
      /*
      this.parent.createSelectionRoleMenu('messageBoxRoleMenu', (error, roleMenu) => {
        this.roleMenu = roleMenu;
      });

       */
      this.setTextareaEvents();
      //this.bodyComponent = this.createBodyComponent();
      //this.DTComponent = this.createDTComponent();
      //this.timezoneComponent = this.createTimezoneSelectionComponent();
      if(!this.eventsAdded) {
        this.eventsAdded = true;
        this.addEventListeners();
      }


      oxygenUtil.setupMessageBoxFnCallReturnListener(this.viewportID, {
        'setSessionBotMode': this.setSessionBotMode.bind(this),
        'addEmail': this.addEmail.bind(this),
        'addPhone': this.addPhone.bind(this),
        'addRecipientPE': this.addRecipientPE.bind(this),
        'removeRecipientPE': this.removeRecipientPE.bind(this),
        'setupSend': this.setupSend.bind(this),
        'setupCall': this.setupCall.bind(this),
        'setupSMS': this.setupSMS.bind(this),
        'setupEmail': this.setupEmail.bind(this),
        'setForeignBot': this.setForeignBot.bind(this),
        'setupBot': this.setupBot.bind(this),
        'setupShareSchedule': this.setupShareSchedule.bind(this),
        'setCurrentForwardedMessage': this.setCurrentForwardedMessage.bind(this),
        'setupForward': this.setupForward.bind(this),
        'setupLink': this.setupLink.bind(this),
        'setupMessage': this.setupMessage.bind(this),
        'setupOffer': this.setupOffer.bind(this),
        'setupMeet': this.setupMeet.bind(this),
        'setupShareMessage': this.setupShareMessage.bind(this),
        'setupNewMessage': this.setupNewMessage.bind(this),
        'setupReplaceMessage': this.setupReplaceMessage.bind(this),
        'setupReply': this.setupReply.bind(this),
        'selectModeLocally': this.selectModeLocally.bind(this),
        'selectMode': this.selectMode.bind(this),
        'resetMessageBox': this.resetMessageBox.bind(this),
        'resetMessageBoxLocally': this.resetMessageBoxLocally.bind(this),
        'setMessage': this.setMessage.bind(this),
        'getMessage': this.getMessage.bind(this),
        'setMessageBoxVisibility': this.setMessageBoxVisibility.bind(this),
        'getCredentialData': this.getCredentialData.bind(this),
        'setReplyIcon': this.setReplyIcon.bind(this),
        'handleCommandMessages': this.handleCommandMessages.bind(this),
        'cancelButtonClicked': this.cancelButtonClicked.bind(this),
        'resetRetryInterval': this.resetRetryInterval.bind(this),
        'newContentButtonClick': this.newContentButtonClick.bind(this),
        'setBodyComponentContent': this.setBodyComponentContent.bind(this),
        'getBodyComponentContent': this.getBodyComponentContent.bind(this)
      })

      this.$nextTick(async ()=>{
        let roles = await this.getRoles('', null, ['owner']);
        if(Array.isArray(roles) && roles.length) {
          this.mainPanel.componentData.homepageRoles = Object.values(roles)[0].map(e => e.role);
        }
      });
      this.$nextTick(async ()=>{
        //this.componentData.openAIDialogues = await oxygenUtil.getComponentOpenAIDialogues(this.parsedContextPE[3]).dialogues;
        if(!this.componentData.clientCommandsSetup) {
          this.componentData.clientCommandsSetup = true;
          this.setupClientCommands();
        }
      });
      let initContext;
      //console.log('NewMessageBox-mounted', 'client:',this.client);
      //console.log('NewMessageBox-mounted', 'initContext:',this.client.InitialContext);
      //console.log('NewMessageBox-mounted', 'initContext:', oxygenUtil.tryParseJSON(this.client.InitialContext));
      if(this.client && this.client.InitialContext && (initContext = oxygenUtil.tryParseJSON(this.client.InitialContext))) {
        if(initContext.InitializeDeskMode) {
          //console.log('NewMessageBox-mounted', 'calling toggleDeskMode, viewportID:', this.viewportID);
          let intervalId = setInterval(()=>{
            if(window.top.oxygenUtil.isViewportHeaderFnCallEventReady(this.viewportID)) {
              clearInterval(intervalId);
              window.top.oxygenUtil.callViewportHeaderFnWithReturn(this.viewportID, 'toggleDeskMode', [true]);
            }
          }, 200);

        }
      }
    });
  },
  watch: {
    'componentData.messageBoxText': function(newVal) {
      this.$refs.textarea.inputVal = newVal;
    },
    'componentData.initialInputText': async function(newVal) {
      //console.log('watch-componentData.initialInputText', 'newVal:', newVal, ' - val:', this.$refs.initialInput.$el.value);
      let ua = navigator.userAgent;
      if(/Chrome/i.test(ua) && /Android/i.test(ua)) {
        if(newVal.trim() === '/') {
          this.handleInitialInputKeyupEvent({ keyCode: 191 });
        }

      }
    },
    'mainPanel.componentData.conversationMode': function(newVal) {
      oxygenUtil.generateMessageBoxDataEvent(this.viewportID, { conversationMode: newVal });
    },
    'mainPanel.componentData.botMode': function(newVal) {
      oxygenUtil.generateMessageBoxDataEvent(this.viewportID, { botMode: newVal });
    },
    'mainPanel.componentData.minimalData': function(newVal) {
      if(newVal) {

      }
      else {

      }
    },
    'componentData.showTextarea': function(newVal) {

      if(newVal) {
        this.$refs.textarea.$el.parentElement.style.display = '';
      }
      else {
        this.$refs.textarea.$el.parentElement.style.display = 'none';
      }
    },
    'mainPanel.componentData.showInitialInput': function(newVal) {
      if(newVal) {
        this.$refs.initialInput.$el.parentElement.style.display = '';
      }
      else {
        this.$refs.initialInput.$el.parentElement.style.display = 'none';
      }
    },
    'mainPanel.componentData.homepageRole': async function(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.$refs.menuTable.resetTable();
        let mode = {
          'assign_homepage': this.assignRoleSelected.bind(this),
          'remove_homepage': this.removeRoleSelected.bind(this)
        }
        if(mode[this.currentSimpleMode]) {
          await mode[this.currentSimpleMode](newVal);
        }
      }
    },
    'componentData.textareaPlaceholder': function(newVal) {
      console.log('watch-componentData.textareaPlaceholder', 'val:', newVal);
      this.textareaProps.placeholder = this.$refs.textarea.placeholder = newVal;
    },
    'client': {
      deep: true,
      handler: function(newVal) {
        this.mainPanel.componentData.clientContactsMode = this.client.contactsMode;
      }
    },
    'mainPanel.componentData.clientContactsMode': function(newVal, oldVal) {
      //console.log('watch-clientContactsMode', 'newVal:', newVal, ' - oldVal:', oldVal);

      if(newVal === 'meeting' && oldVal !== 'meeting' && this.viewportID === this.mainPanel.componentData.currentContactsModeViewport ) {

        //console.log('watch-clientContactsMode', 'setting up send');
        this.setupSend();
        //this.addMeetingRecipients();
      }
    },
    'mainPanel.componentData.showMessageBoxSchedule': function(newVal) {
        if(newVal) {
          //console.log('watch', 'startTime:', this.$refs.startTime.$el);
          this.$refs.startTime.$el.querySelector('.dp__pointer').style['font-size'] = '12px';
          this.$refs.endTime.$el.querySelector('.dp__pointer').style['font-size'] = '12px';
          //$(this.$refs.startTime.$el).find('.dp__pointer').css({'font-size':'12px'});
          //$(this.$refs.endTime.$el).find('.dp__pointer').css({'font-size':'12px'});
        }
    },
    'currentSimpleMode': function(newVal) {
      if(newVal) {
        this.$refs.settingsRibbon.hideRibbonIcon('help_message');
        this.$refs.settingsRibbon.hideRibbonIcon('open_inbox');
      }
      else {
        if(this.simpleModeOptions.filter(e => e[7]).length === 1) {
          this.$refs.settingsRibbon.showRibbonIcon('help_message');
          this.$refs.settingsRibbon.showRibbonIcon('open_inbox');
        }


      }
    },
    'mainPanel.componentData.showMessageBoxRecipientsTable': function(newVal) {
      if(newVal) {
        this.mainPanel.componentData.messageBoxRecipientsTableStyle.display = 'block';
        this.mainPanel.componentData.messageBoxRecipientsTableStyle.overflow = 'auto';
      }
      else {
        this.mainPanel.componentData.messageBoxRecipientsTableStyle.display = 'none';
        this.mainPanel.componentData.messageBoxRecipientsTableStyle.overflow = 'none';
      }
    },
    'componentData.currentReplyIcon': {
      handler(newVal) {
        //console.log('componentData.currentReplyIcon', 'newVal:', newVal);
        if(this.$refs.settingsRibbon) {
          //this.settingsOptions.find(e => (e[2] === 'reply'))[1].classes = `${newVal} ${this.iconIds.selected}`;
          /*
          this.$refs.settingsRibbon.updateIconInfo(
              "reply",
              { type: "css", classes: `${newVal}`}
          );
          this.$refs.settingsRibbon.updateIconAttributes("reply", { tooltip: '' })

           */
        }
      },
      immediate: true
    },
    'componentData.replyFlags': {
      handler(newVal) {
        //console.log('watch-componentData.replyFlags', 'called');
        //if(this.componentData.viewportSelectEnabled)
        this.componentData.viewportSelectEnabled = Object.entries(this.componentData.replyFlags).some(e => (e[0].startsWith('replySelect') && e[1]));
        this.componentData.showMessageBoxRecipientsList = !(this.componentData.clientContactsMode === 'meeting') &&
            !this.componentData.minimalMode && this.componentData.replyFlags['replyRecipients'];
        if(this.$refs.settingsRibbon) {
          Object.entries(this.componentData.replyFlags).forEach((e)=>{
            if (this.componentData.replyFlags[e[0]]) {
              //console.log('watch-componentData.replyFlags', 'true flag:', e[0]);
              this.selectReplyIcon(e[0])
            } else {
              this.unselectReplyIcon(e[0]);

            }
          });
        }

      },
      deep: true
    },
    'mainPanel.componentData.messageBoxRecipientsTableData.dataRows.length': function (newVal) {
      this.setAttachmentsList();
    },
    'mainPanel.componentData.showMessageBoxAttachmentsInputBox': function (newVal) {
      /*
      if (newVal) {
        this.$refs.attachmentsMenuTable.showRow(this.recipientTextboxPath);
      } else {
        this.$refs.attachmentsMenuTable.hideRow(this.recipientTextboxPath);
      }

       */
    },
    'selectedMode': {
      handler(newVal) {
        if (newVal === 'meetingMode') {
          this.componentData.meetingLinkDisplayed = false;
        } else {
          this.componentData.meetingLinkDisplayed = false;
        }
      },
      immediate: true
    },
    'meetingLinkChecked': function (newVal) {
      if (!this.componentData.meetingLinkFetched) {
        if (newVal) {
          this.componentData.meetingLink = 'Meeting link will be generated once meeting starts.'
        } else {
          this.componentData.meetingLink = 'Select the checkbox to create meeting link';
        }
      }
    },
    'mainPanel.componentData.offerGuestAccountEnabled': function (newVal) {
      if (newVal) {
        this.optionsMenu.unhideMenuItem("Reset Offer");
        this.optionsMenu.hideMenuItem("Offer Guest Account");
      } else {
        this.optionsMenu.hideMenuItem("Reset Offer");
        this.optionsMenu.unhideMenuItem("Offer Guest Account");
      }
    },
    'mainPanel.componentData.requestGuestAccountEnabled': function (newVal) {
      if (newVal) {
        this.optionsMenu.unhideMenuItem("Reset Request");
        this.optionsMenu.hideMenuItem("Request Guest Account");
      } else {
        this.optionsMenu.hideMenuItem("Reset Request");
        this.optionsMenu.unhideMenuItem("Request Guest Account");
      }
    },
    'selectionEnabled': {
      handler(newVal) {
        /*
        console.log('watch-selectionEnabled', 'newVal:', newVal);
        if (newVal && !this.parent._selectionEventsSet) {
          this.parent.searchComponent.$refs.menuTable.$on('row-selected', (dataRow) => {
            if (this.selectionEnabled) {
              console.log('watch-selectionEnabled', 'dataRow:', dataRow);

              let PE = this.parent.getSelectedChatRecipient(dataRow);
              console.log('watch-selectionEnabled', 'PE:', PE);
              this.addRecipientPE(PE, dataRow, this.parent.searchComponent);
            }
          });
          this.parent.searchComponent.$refs.menuTable.$on('row-deselected', (dataRow) => {
            if (this.selectionEnabled) {
              let PE = this.parent.getSelectedChatRecipient(dataRow);
              this.removeRecipientPE(PE);
            }
          });
          this.$nextTick(function () {
            this.parent.container.$emit('messagebox-selection-enabled');
          })
          this.parent._selectionEventsSet = true;
          this._selectionEventsSet = true;
        }

         */
      },
      immediate: true
    },
    'mainPanel.componentData.showMessageBoxRecipientsList': function (newVal) {
      //console.log('watch-showMessageBoxRecipientsList', 'val:', newVal);
      if (newVal) {
        //this.$refs.menuTable.showRow(this.recipientTextboxPath);
      } else {
        //this.$refs.menuTable.hideRow(this.recipientTextboxPath);
      }
    },
    'ribbonMenuInitialized': function (newVal) {
      //console.log('watch-ribbonMenuInitialized', 'newVal:', newVal);
//if(newVal === 3) {
      if (newVal === 1) {
        this.addSettingsRibbonIcons();

        //this.hideSettingsRibbonIcons();
//this.addModeRibbonIcons();
        this.setReplyWatchers();
        /*
        this.$nextTick(function () {
          this.$nextTick(function () {
            this.$nextTick(function () {
              this.postMountTasks.forEach(e => e());
              this.postMountTasks = [];
              this.$nextTick(function () {
                //this.mainPanel.container.$emit('messagebox-component-ready');
              })
            });
          });



          this.replyOptionsList.forEach((e) => {
            this.$refs.settingsRibbon.hideRibbonIcon(e);
          });


        });

         */

      }
    },
    'mainPanel.componentData.showMeetingLinkOptionFlag': {
      handler(newVal) {
        /*
        console.log('watch-showMeetingLinkOptionFlag', 'newVal:', newVal);
        if (newVal) {
          if (this.optionsMenu) {
            this.optionsMenu.unhideMenuItem("Create Meeting Link");
          } else {
            this.postActionMenuActions.push(() => {
              this.optionsMenu.unhideMenuItem("Create Meeting Link");
            });
          }
          this.getMeetingLink();
        } else {
          if (this.optionsMenu) {
            this.optionsMenu.hideMenuItem("Create Meeting Link");
          } else {
            this.postActionMenuActions.push(() => {
              this.optionsMenu.hideMenuItem("Create Meeting Link");
            });
          }
          this.componentData.meetingLinkFetched = false;
        }*/
      },
      immediate: true
    },
    'messageBoxModeAllButtons': {
      handler: function (newVal) {
        this.unwatchFns.forEach(e => e());
        this.setModeWatchers();
        if (this.selectedMode) {
          this.messageBoxModeAllButtons.forEach(e => this.unselectModeButton(e));
          let modeButton = this.messageBoxModeAllButtons.find(
              e => (e.id === this.componentData.messageBoxModes[this.selectedMode].default)
          );
//this.updateModeMenuItems();
          if (modeButton) {
            this.selectModeButton(modeButton);
          }
        }
      },
      immediate: true
    },
    'mainPanel.componentData.messageBoxAttachmentsFlag': function (newVal) {
      /*
      if (newVal) {
        this.$refs.settingsRibbon.selectIcon('attach');
      } else {
        this.$refs.settingsRibbon.unselectIcon('attach');
      }

       */
    }
    /*'mainPanel.componentData.messageBoxModalMode': {
handler(newVal) {
if (newVal) {
if(this.$refs.settingsRibbon.hideRibbonIcon) {
this.$refs.settingsRibbon.hideRibbonIcon('replySelect');
}
else {
this.ribbonOpsQueue.push({fn: this.$refs.settingsRibbon.hideRibbonIcon.bind(this.$refs.settingsRibbon, 'replySelect')})
}

} else {
if(this.$refs.settingsRibbon.showRibbonIcon) {
this.$refs.settingsRibbon.showRibbonIcon('replySelect');
}
else {
this.ribbonOpsQueue.push({fn: this.$refs.settingsRibbon.showRibbonIcon.bind(this.$refs.settingsRibbon, 'replySelect')})
}
}
},
immediate: true
}*/
  },
  methods: {
    setupClientCommands() {
      window.BotServices.addClientCommand({Client : this.client.Client, Command : 'pullPE' }, this.pullPE.bind(this));
      window.BotServices.addClientCommand({Client : this.client.Client, Command : 'openChildPanel' }, this.openChildPanel.bind(this));
      window.BotServices.addClientCommand({Client : this.client.Client, Command : 'inviteToMeeting' }, this.inviteToMeeting.bind(this));
      window.BotServices.addClientCommand({Client : this.client.Client, Command : 'callBotConnect' }, this.callBotConnect.bind(this));
      window.BotServices.addClientCommand({Client : this.client.Client, Command : 'loginSimplia' }, this.loginSimplia.bind(this));
    },
    async callBotConnect(data, callback) {
      console.log('callBotConnect', 'data:', data);
      await window.oxygenUtil.doBotConnect(this.client.Client, data.toPE);
      callback();
    },
    inviteToMeeting(data, callback) {
      let params = {
        ClientID: this.ClientID,
        to: {
          tope: data.tope || [],
          componentid: data.componentid || [],
          email: data.email || [],
          phone: data.phone || []
        },
        thread: this.componentData.asComponent.Node,
        subject: this.componentData.atComponent.Node,
        message: data.inviteMessage || '',
        bype: this.envelopeByPE,
        schedule: {
          start: '',
          end: ''
        },
        mode: data.mode || 'invite'
      }
      window.BotServices.callManagerExec(params, () => {
        callback();
      });
    },
    async pullPE(data, callback) {
      await window.oxygenUtil.pullPE(
          {
            ByClientID : this.client.Client,
            InitialContext : Object.assign({
              ByClientID : this.client.Client

            }, data.InitialContext || {}),
            OpenPE : data.GrantPE
          },
          data,
          async (err) => {
            callback();
          }
      );

      //await oxygenUtil.addRecent(data.GrantPE, data.GrantLeftDN, data.GrantRightDN);

    },
    openChildPanel(data, callback) {
      console.log('openChildPanel', 'data:', data, ' - callback:', callback);
      let panelName = {
        'RelatedLinks': () => {
          this.showChildViewport('showAttachments');
        },
        'AccountInfo': () => {
          this.showChildViewport('showAccountInfo');
        }
      }
      data && data.panelName && panelName[data.panelName] && panelName[data.panelName]();
      callback();
    },
    loginSimplia(data, callback) {
      console.log('loginSimplia', 'data:', data);
      callback();
    },
    getAttributeMatch(list, attr) {
      return list.find((e)=>{
        return e.toLowerCase().includes(attr);
      })
    },
    async uploadRecipientList() {
      //this.showUploadViewport();
      if(this.client.childViewports && this.client.childViewports['showFiles']) {
        this.client.ignoreAttachmentCreation = true;
        let uploadId = oxygenUtil.getUUID();
        let uploadViewportId = this.client.childViewports['showFiles']();
        console.log('uploadRecipientList', 'uploadViewportId:', uploadViewportId);

        this.client.fileUploadCallbacks[uploadId] = async (uploadData) => {
          console.log('addUploadContactsOption', 'fileUploadCallbacks', ' uploadData:', uploadData);
          let data = await oxygenUtil.callCommonServiceAPI('csv-file-parser','parseFile', { filePath: uploadData.detail.filePath });
          let records = data.records;
          //console.log('addUploadContactsOption', 'getCSVData', ' records:', records);
          this.client.ignoreAttachmentCreation = false;
          let responses = [];
          await async.each(records, async (record)=>{
            let phone, component;
            console.log('record:', record);
            let emailAttribute = this.getAttributeMatch(Object.getOwnPropertyNames(record), 'email'),
                phoneAttribute = this.getAttributeMatch(Object.getOwnPropertyNames(record), 'phone') || this.getAttributeMatch(Object.getOwnPropertyNames(record), 'ph'),
                componentAttribute = this.getAttributeMatch(Object.getOwnPropertyNames(record), 'component');

            if(emailAttribute && (this.currentSimpleMode !== 'sms') && oxygenUtil.isEmail(record[emailAttribute]) ) {
              await this.addEmail(record[emailAttribute]);
            }

            if(phoneAttribute && (this.currentSimpleMode !== 'email') && (phone = oxygenUtil.parsePhone(record[phoneAttribute]))) {
              await this.addPhone(phone);
            }

            if(componentAttribute && (component = await oxygenUtil.getComponentByDisplayName(record[componentAttribute]))) {
              let allRoles = await oxygenUtil.getAllComponentsRoles(
                  [
                    {
                      id: component.Node,
                      defaultRole: Array.from( new Set((this.defaultRole ? [this.defaultRole] : []).concat('admin', 'holder', 'visitor')))
                    }
                  ],
                  [{componentId: component.Node, role: 'visitor'}, {componentId: component.Node, role: 'bot'}],
                  []
              );
              this.addValidatedPE(component, allRoles[component.Node]);
            }

            //console.log('addUploadContactsOption', 'addProviderSearchData', ' response:', response);
          });
          delete this.client.fileUploadCallbacks[uploadId];
          console.log('addUploadContactsOption', 'deleting uploadId', uploadId);
          window.DevMgr.closeViewPort(uploadViewportId);
        };

        //console.log('addUploadContactsOption', 'uploadViewportId:', uploadViewportId);
        await this.$nextTick();
        await this.$nextTick();
        await this.$nextTick();
        let counter = 0;
        let intervalID = setInterval(()=>{
          let wc = document.querySelector(`iframe-container[data-viewportID="${uploadViewportId}"]`);
          //console.log('addUploadContactsOption', 'wc:', wc);
          if(counter > 10) {
            clearInterval(intervalID);
          }
          else if(wc && wc.shadowRoot && wc.shadowRoot.getElementById(wc.id) && wc.shadowRoot.getElementById(wc.id).contentWindow.uppy) {
            //console.log('addUploadContactsOption', 'uppy:', wc.shadowRoot.getElementById(wc.id).contentWindow.uppy);
            wc.shadowRoot.getElementById(wc.id).contentWindow.uppy.setOptions({
              restrictions: {
                allowedFileTypes: ['.csv', '.txt']
              }
            });
            wc.shadowRoot.getElementById(wc.id).contentWindow.uppy.on('upload-success', async (file, response) => {
              //console.log('upload-success', 'file:', file);
              //Call API to upload data to Master Provider
              //Do openPE on the list component template
            });
            clearInterval(intervalID);
          }
          else {
            counter++;
          }

        },200);
        return true;
      }
    },
    async createSmartLink(historyItem) {
      let steps = {
        'start': this.startSmartLinkFlow.bind(this),
        'print': this.printSmartLinkFlow.bind(this)
      };

      await steps[this.componentData.nextCommandStep](historyItem);
    },
    async startSmartLinkFlow(historyItem) {
      this.componentData.replyMode = true;
      this.componentData.nextCommandStep = 'print';

      let envelope = {
        ToPE: historyItem.ByPE,
        ByPE: historyItem.ToPE
      }
      let historyMessage = await this.postHistoryMessage(Object.assign({
            PK: oxygenUtil.getGUID(),
            TaskID: oxygenUtil.getGUID(),
            TaskTemplateID: this.standardTaskTemplateId,
            SessionId: oxygenUtil.Cookies.get('sessionId'),
            CausingEventLabel: 'Reply',
            CausingEventID: historyItem.PK,
            RootEventID: historyItem.RootEventID,
            Note: JSON.stringify({ String: `I would help you in creating a Smart Link with the visitor role. Can you provide me with a 6-digit passcode?`, Link: ''}),
            ArgJSON: JSON.stringify({expandByDefault: true})
          },
          envelope,
          this.getLocationData(),
          this.getCredentialData(),
          this.getEventTemplateData(),
      ));
      this.setupReply();
      this.componentData.textareaPlaceholder = 'Passcode';
      this.componentData.currentInboxFocusedMessage = { data: historyMessage, path: historyMessage.PK };
      let cb = () => {
        console.log('callback', 'calling setReplyMessageId:', historyMessage.PK);

        let counter = 0;

        let intervalId = setInterval(async ()=>{
          let inbox;
          counter++;
          await this.$nextTick();
          if(((inbox = window.devStore.viewPorts.find(e => ((this.viewport.ClientID === e.ClientID)) && e.isInbox)) && console.log('callback', 'refs:', window.top.inboxRefs) &&
                  window.top.inboxRefs[inbox.viewportID] && window.inboxRefs[inbox.viewportID].exposed.fullyMounted)   ||
              (counter > 20)) {
            clearInterval(intervalId);
            await this.$nextTick();
            if(inbox) {
              console.log('callback', 'inbox found - setReplyMessageId being called');
              this.callInboxFn('setReplyMessageId', [historyMessage.PK]);
            }
          }
        },200);


      };
      return cb;

    },
    async printSmartLinkFlow(historyItem) {
      this.componentData.nextCommandStep = 'done';
      let note = oxygenUtil.tryParseJSON(historyItem.Note), passcode = note && note.String;

      let smartLink = await oxygenUtil.createSmartLink('visitor', this.client.ClientRight, null, passcode),
      message = `Here is the Smart Link that you can share with others:<br/><br/> ${smartLink}`;


      let envelope = {
        ToPE: historyItem.ByPE,
        ByPE: historyItem.ToPE
      }
      await this.postHistoryMessage(Object.assign({
            PK: oxygenUtil.getGUID(),
            TaskID: oxygenUtil.getGUID(),
            TaskTemplateID: this.standardTaskTemplateId,
            SessionId: oxygenUtil.Cookies.get('sessionId'),
            CausingEventLabel: 'Reply',
            CausingEventID: historyItem.PK,
            RootEventID: historyItem.RootEventID,
            Note: JSON.stringify({ String: message, Link: '', CopyString: smartLink}),
            ArgJSON: JSON.stringify({expandByDefault: true})
          },
          envelope,
          this.getLocationData(),
          this.getCredentialData(),
          this.getEventTemplateData(),
      ));
    },
    async createComponentCommand(historyItem) {
      let steps = {
        'start': this.startCreateComponentFlow.bind(this),
        'templateName': this.chooseTemplateNameFlow.bind(this)
      };

      return await steps[this.componentData.nextCommandStep](historyItem);
    },
    async startCreateComponentFlow(historyItem) {
      this.componentData.replyMode = true;
      this.componentData.nextCommandStep = 'templateName';
      let chooseTemplateMessage = `What template would you like to use to create the new component? Please choose one from the list.`;

      let envelope = {
        ToPE: historyItem.ByPE,
        ByPE: historyItem.ToPE
      }
      let historyMessage = await this.postHistoryMessage(Object.assign({
            PK: oxygenUtil.getGUID(),
            TaskID: oxygenUtil.getGUID(),
            TaskTemplateID: this.standardTaskTemplateId,
            SessionId: oxygenUtil.Cookies.get('sessionId'),
            CausingEventLabel: 'Reply',
            CausingEventID: historyItem.PK,
            RootEventID: historyItem.RootEventID,
            Note: JSON.stringify({ String: chooseTemplateMessage, Link: ''}),
            ArgJSON: JSON.stringify({expandByDefault: true})
          },
          envelope,
          this.getLocationData(),
          this.getCredentialData(),
          this.getEventTemplateData(),
      ));
      this.setupReply();
      this.componentData.textareaPlaceholder = 'Component Name';
      this.componentData.currentInboxFocusedMessage = { data: historyMessage, path: historyMessage.PK };
      let cb = () => {
        console.log('callback', 'calling setReplyMessageId:', historyMessage.PK);

        let counter = 0;

        let intervalId = setInterval(async ()=>{
          let inbox;
          counter++;
          await this.$nextTick();
          if(((inbox = window.devStore.viewPorts.find(e => ((this.viewport.ClientID === e.ClientID)) && e.isInbox)) && console.log('callback', 'refs:', window.top.inboxRefs) &&
                  window.top.inboxRefs[inbox.viewportID] && window.inboxRefs[inbox.viewportID].exposed.fullyMounted)   ||
              (counter > 20)) {
            clearInterval(intervalId);
            await this.$nextTick();
            if(inbox) {
              console.log('callback', 'inbox found - setReplyMessageId being called');
              this.callInboxFn('setReplyMessageId', [historyMessage.PK]);
            }
          }
        },200);


      };
      return cb;

    },
    async chooseTemplateNameFlow(historyItem) {
      this.componentData.nextCommandStep = 'componentName';
      let note, DNPrefix = (note = oxygenUtil.tryParseJSON(historyItem.Note)) && note.String;
      let appComponent = await oxygenUtil.createTipFromTemplate(
          this.AIAppTemplate,
          DNPrefix,
          this.contextPE,
          this.gatewayGrant,
          this.contextPE,
          this.componentData.contextPEGrant.GrantID
      );
      this.componentData.nextCommandStep = 'done';


      let botPE = oxygenUtil.createSimpleOES(['bot', appComponent.Node, 'bot', appComponent.Node]);

      let startMessage = `This is a preamble to create an app. In what follows I will be instructing you to behave as if you are an app which follows the spec in our following conversation.
          Please reply to this message by greeting me and telling me that this is an App creation tool and I can define its specification using plain English by replying to the message`,
          mainPK = oxygenUtil.getGUID();
      let historyParams = Object.assign({
            ToPE: botPE,
            ByPE: oxygenUtil.createSimpleOES(['bot', this.parsedContextPE[1], 'bot', appComponent.Node]),
            PK: mainPK,
            TaskID: oxygenUtil.getGUID(),
            TaskTemplateID: this.standardTaskTemplateId,
            SessionId: oxygenUtil.Cookies.get('sessionId'),

            Note: JSON.stringify({ String: startMessage, Link: ''}),
            ArgJSON: JSON.stringify({expandByDefault: true, FinalToPE: appComponent.grants.adminGrant.GrantPE})
          },
          this.getLocationData(),
          this.getCredentialData(),
          this.getEventTemplateData(),
      );

      let PK = oxygenUtil.getGUID();
      let componentLink = `<span style="cursor:pointer;color:#0072c5;"
class="grant-link"
data-pe="${appComponent.grants.adminGrant.GrantPE}"
data-open-inbox="true"
data-inbox-params='${JSON.stringify({initializereplymode: "true", replymessagerootid: mainPK})}'
>[${appComponent.DisplayName}]</span>`
      let envelope = {
        ToPE: historyItem.ByPE,
        ByPE: historyItem.ToPE
      }, message = `<div><span>The App has been provisionally created. Please click the following link to finish developing the App:</span><br/><br/>${componentLink}</div>`
      await this.postHistoryMessage(Object.assign({
            PK,
            TaskID: oxygenUtil.getGUID(),
            TaskTemplateID: this.standardTaskTemplateId,
            SessionId: oxygenUtil.Cookies.get('sessionId'),
            CausingEventLabel: 'Reply',
            CausingEventID: historyItem.PK,
            RootEventID: historyItem.RootEventID,
            Note: JSON.stringify({ String: message, Link: ''}),
            ArgJSON: JSON.stringify({expandByDefault: true, postLinkClick: { postHistory: historyParams}})
          },
          envelope,
          this.getLocationData(),
          this.getCredentialData(),
          this.getEventTemplateData(),
      ));



    },
    async createLabelledAnonymousSmartLink(historyItem) {
      this.componentData.smartLinkType = 'anonymous';
      let steps = {
        'start': this.startCreateLabelledSmartLinkFlow.bind(this),
        'userIdentity': this.createLabelledSmartLinkFlow.bind(this),
        'linkLabel': this.finishLabelledSmartLinkFlow.bind(this)
      };

      return await steps[this.componentData.nextCommandStep](historyItem);
    },
    async createLabelledSmartLink(historyItem) {
      this.componentData.smartLinkType = 'normal';
      let steps = {
        'start': this.startCreateLabelledSmartLinkFlow.bind(this),
        'userIdentity': this.createLabelledSmartLinkFlow.bind(this),
        'linkLabel': this.finishLabelledSmartLinkFlow.bind(this)
      };

      return await steps[this.componentData.nextCommandStep](historyItem);
    },
    async createSimpleTable(historyItem) {
      let steps = {
        'start': this.startSimpleTableFlow.bind(this),
        'tableName': this.createSimpleTableComponentFlow.bind(this)
      };

      return await steps[this.componentData.nextCommandStep](historyItem);
    },
    async startSimpleTableFlow(historyItem) {

      this.componentData.replyMode = true;
      this.componentData.nextCommandStep = 'tableName';

      let envelope = {
        ToPE: historyItem.ByPE,
        ByPE: historyItem.ToPE
      }
      let historyMessage = await this.postHistoryMessage(Object.assign({
            PK: oxygenUtil.getGUID(),
            TaskID: oxygenUtil.getGUID(),
            TaskTemplateID: this.standardTaskTemplateId,
            SessionId: oxygenUtil.Cookies.get('sessionId'),
            CausingEventLabel: 'Reply',
            CausingEventID: historyItem.PK,
            RootEventID: historyItem.RootEventID,
            Note: JSON.stringify({ String: this.createSimpleTableMessage, Link: ''}),
            ArgJSON: JSON.stringify({expandByDefault: true})
          },
          envelope,
          this.getLocationData(),
          this.getCredentialData(),
          this.getEventTemplateData(),
      ));
      this.setupReply();
      this.componentData.textareaPlaceholder = 'Simple Table Name';
      this.componentData.currentInboxFocusedMessage = { data: historyMessage, path: historyMessage.PK };
      let cb = () => {
        console.log('callback', 'calling setReplyMessageId:', historyMessage.PK);

        let counter = 0;

        let intervalId = setInterval(async ()=>{
          let inbox;
          counter++;
          await this.$nextTick();
          if(((inbox = window.devStore.viewPorts.find(e => ((this.viewport.ClientID === e.ClientID)) && e.isInbox)) && console.log('callback', 'refs:', window.top.inboxRefs) &&
                  window.top.inboxRefs[inbox.viewportID] && window.inboxRefs[inbox.viewportID].exposed.fullyMounted)   ||
              (counter > 20)) {
            clearInterval(intervalId);
            await this.$nextTick();
            if(inbox) {
              console.log('callback', 'inbox found - setReplyMessageId being called');
              this.callInboxFn('setReplyMessageId', [historyMessage.PK]);
            }
          }
        },200);


      };
      return cb;

    },
    async createSimpleTableComponentFlow(historyItem) {
      let note, DNPrefix = (note = oxygenUtil.tryParseJSON(historyItem.Note)) && note.String;

      let CreateRTableParams = {
        componentId: '_FFFFFFFFFFFFFF00001713960477110008_',
        command: "CreateTable",
        data: { "currentContext": this.CurrentContext, "DisplayNamePrefix": DNPrefix, "TemplateOID": "_FFFFFFFFFFFFFF00001725036611854048_"},
        Type: 'BotApi'
      }
      window.BotServices.callComponent(CreateRTableParams, async (err, result) => {
            //console.log("CreateTable Got : ", result);
              if(result && result.GrantItem) {
                let PK = oxygenUtil.getGUID();
                let componentLink = `<span style="cursor:pointer;color:#0072c5;"
class="grant-link"
data-pe="${result.GrantItem.GrantPE}"

>[${result.GrantItem.GrantRightDN}]</span>`
                let envelope = {
                  ToPE: historyItem.ByPE,
                  ByPE: historyItem.ToPE
                }, message = `<div><span>The Simple Table has been created. Please click the following link to open it:</span><br/><br/>${componentLink}</div>`
                await this.postHistoryMessage(Object.assign({
                      PK,
                      TaskID: oxygenUtil.getGUID(),
                      TaskTemplateID: this.standardTaskTemplateId,
                      SessionId: oxygenUtil.Cookies.get('sessionId'),
                      CausingEventLabel: 'Reply',
                      CausingEventID: historyItem.PK,
                      RootEventID: historyItem.RootEventID,
                      Note: JSON.stringify({ String: message, Link: ''}),
                      ArgJSON: JSON.stringify({expandByDefault: true})
                    },
                    envelope,
                    this.getLocationData(),
                    this.getCredentialData(),
                    this.getEventTemplateData(),
                ));

              }
            });
        this.componentData.nextCommandStep = 'done';

    },
    async createDeepSeekApp(historyItem) {
      let steps = {
        'start': this.startCreateAIAppFlow.bind(this),
        'appName': (historyItem) => {
          this.createAppComponentFlow(historyItem, this.DeepSeekAppTemplate)
        }
      };
      return await steps[this.componentData.nextCommandStep](historyItem);
    },
    async createOpenAIApp(historyItem) {
      let steps = {
        'start': this.startCreateAIAppFlow.bind(this),
        'appName': (historyItem) => {
          this.createAppComponentFlow(historyItem, this.OpenAIAppTemplate)
        }
      };
      return await steps[this.componentData.nextCommandStep](historyItem);
    },
    async createAIApp(historyItem) {
      let steps = {
        'start': this.startCreateAIAppFlow.bind(this),
        'appName': (historyItem) => {
          this.createAppComponentFlow(historyItem, this.AIAppTemplate)
        }
      };

      return await steps[this.componentData.nextCommandStep](historyItem);
    },
    async createAppComponentFlow(historyItem, templateId) {
      let note, DNPrefix = (note = oxygenUtil.tryParseJSON(historyItem.Note)) && note.String;
      let appComponent = await oxygenUtil.createTipFromTemplate(
          templateId,
          DNPrefix,
          this.contextPE,
          this.gatewayGrant,
          this.contextPE,
          this.componentData.contextPEGrant.GrantID
      );
      this.componentData.nextCommandStep = 'done';


      let botPE = oxygenUtil.createSimpleOES(['bot', appComponent.Node, 'bot', appComponent.Node]);

      let startMessage = `This is a preamble to create a Smart Agent. In what follows I will be instructing you to behave as if you are a Smart Agent which follows the spec in our following conversation.
          Please reply to this message by greeting me and telling me that this is a Smart Agent creation tool and I can define its specification using plain English by replying to the message`,
      mainPK = oxygenUtil.getGUID();
      let historyParams = Object.assign({
            ToPE: botPE,
            ByPE: oxygenUtil.createSimpleOES(['bot', this.parsedContextPE[1], 'bot', appComponent.Node]),
            PK: mainPK,
            TaskID: oxygenUtil.getGUID(),
            TaskTemplateID: this.standardTaskTemplateId,
            SessionId: oxygenUtil.Cookies.get('sessionId'),

            Note: JSON.stringify({ String: startMessage, Link: ''}),
            ArgJSON: JSON.stringify({expandByDefault: true, FinalToPE: appComponent.grants.adminGrant.GrantPE})
          },
          this.getLocationData(),
          this.getCredentialData(),
          this.getEventTemplateData(),
      );

            let PK = oxygenUtil.getGUID();
            let componentLink = `<span style="cursor:pointer;color:#0072c5;"
class="grant-link"
data-pe="${appComponent.grants.adminGrant.GrantPE}"
data-open-inbox="true"
data-inbox-params='${JSON.stringify({initializereplymode: "true", replymessagerootid: mainPK})}'
>[${appComponent.DisplayName}]</span>`
            let envelope = {
              ToPE: historyItem.ByPE,
              ByPE: historyItem.ToPE
            }, message = `<div><span>The Smart Agent has been provisionally created. Please click the following link to finish developing the Smart Agent:</span><br/><br/>${componentLink}</div>`
            await this.postHistoryMessage(Object.assign({
                  PK,
                  TaskID: oxygenUtil.getGUID(),
                  TaskTemplateID: this.standardTaskTemplateId,
                  SessionId: oxygenUtil.Cookies.get('sessionId'),
                  CausingEventLabel: 'Reply',
                  CausingEventID: historyItem.PK,
                  RootEventID: historyItem.RootEventID,
                  Note: JSON.stringify({ String: message, Link: ''}),
                  ArgJSON: JSON.stringify({expandByDefault: true, postLinkClick: { postHistory: historyParams}})
                },
                envelope,
                this.getLocationData(),
                this.getCredentialData(),
                this.getEventTemplateData(),
            ));



    },
    async createLabelledSmartLinkFlow(historyItem) {
      console.log('createLabelledSmartLinkFlow', 'historyItem:', historyItem);
      this.componentData.nextCommandStep = 'linkLabel';
      this.componentData.currentCommandData.recipientIdentity = oxygenUtil.tryParseJSON(historyItem.Note).String;

      let message = `Can you provide a label for the Smart Link?`;


      let envelope = {
        ToPE: historyItem.ByPE,
        ByPE: historyItem.ToPE
      }
      await this.postHistoryMessage(Object.assign({
            PK: oxygenUtil.getGUID(),
            TaskID: oxygenUtil.getGUID(),
            TaskTemplateID: this.standardTaskTemplateId,
            SessionId: oxygenUtil.Cookies.get('sessionId'),
            CausingEventLabel: 'Reply',
            CausingEventID: historyItem.PK,
            RootEventID: historyItem.RootEventID,
            Note: JSON.stringify({ String: message, Link: ''}),
            ArgJSON: JSON.stringify({expandByDefault: true})
          },
          envelope,
          this.getLocationData(),
          this.getCredentialData(),
          this.getEventTemplateData(),
      ));

      this.componentData.textareaPlaceholder = 'Label';
    },
    async finishLabelledSmartLinkFlow(historyItem) {
      let note = oxygenUtil.tryParseJSON(historyItem.Note), identity, type;
      if(this.componentData.currentCommandData.recipientIdentity) {
        let identities = this.componentData.currentCommandData.recipientIdentity.split(",");
        console.log('finishLabelledSmartLinkFlow', 'identities:', identities);
        await async.each(identities, async (identity) => {
          if((oxygenUtil.isEmail(identity = identity.trim()) && (type = 'email')) ||
              ((identity = oxygenUtil.parsePhone(identity.trim())) && (type = 'phone'))) {
            console.log('finishLabelledSmartLinkFlow', 'identity:', identity);
            this.callInboxFn('generateDeepLinkMessage', [ identity, type, (note && note.String) || 'Test', this.componentData.smartLinkType]);

          }

        });
        let message = `The Smart Link has been sent to the recipient.`;


        let envelope = {
          ToPE: historyItem.ByPE,
          ByPE: historyItem.ToPE
        }
        await this.postHistoryMessage(Object.assign({
              PK: oxygenUtil.getGUID(),
              TaskID: oxygenUtil.getGUID(),
              TaskTemplateID: this.standardTaskTemplateId,
              SessionId: oxygenUtil.Cookies.get('sessionId'),
              CausingEventLabel: 'Reply',
              CausingEventID: historyItem.PK,
              RootEventID: historyItem.RootEventID,
              Note: JSON.stringify({ String: message, Link: ''}),
              ArgJSON: JSON.stringify({expandByDefault: true})
            },
            envelope,
            this.getLocationData(),
            this.getCredentialData(),
            this.getEventTemplateData(),
        ));
        this.cancelButtonClicked();

      }

      else {
        //indicate the user identity was invalid
      }

    },
    async startCreateLabelledSmartLinkFlow(historyItem) {
      //console.log('startCreateLabelledSmartLinkFlow', 'item:', historyItem);
      this.componentData.replyMode = true;
      this.componentData.nextCommandStep = 'userIdentity';

      let envelope = {
        ToPE: this.contextPE,
        ByPE: oxygenUtil.createSimpleOES(['bot', this.parsedContextPE[1], this.parsedContextPE[2], this.parsedContextPE[3]])
      }
      let historyMessage = await this.postHistoryMessage(Object.assign({
            PK: oxygenUtil.getGUID(),
            TaskID: oxygenUtil.getGUID(),
            TaskTemplateID: this.standardTaskTemplateId,
            SessionId: oxygenUtil.Cookies.get('sessionId'),
            Note: JSON.stringify({ String: "I can help you with creating a Smart Link. Can you provide the recipient's phone number(s) or email(s)? For multiple recipients, separate them with a ','", Link: ''}),
            ArgJSON: JSON.stringify({expandByDefault: true})
          },
          envelope,
          this.getLocationData(),
          this.getCredentialData(),
          this.getEventTemplateData(),
      ));
      this.callInboxFn('setReplyMessageId', [historyMessage.PK]);
      //this.cancelButtonClicked()
      await this.$nextTick();
      await this.$nextTick();
      await this.$nextTick();
      this.setupReply();
      this.setReplyIcon('replyBot');
      //this.componentData.showMessageBoxSubjectInput = false;
      this.componentData.textareaPlaceholder = 'Phone Number/Email';
      this.componentData.currentInboxFocusedMessage = { data: historyMessage, path: historyMessage.PK };
      /*
      let cb = () => {
        console.log('callback', 'calling setReplyMessageId:', historyMessage.PK);

        let counter = 0;

        let intervalId = setInterval(async ()=>{
          let inbox;
          counter++;
          await this.$nextTick();
          if(((inbox = window.devStore.viewPorts.find(e => ((this.viewport.ClientID === e.ClientID)) && e.isInbox)) && console.log('callback', 'refs:', window.top.inboxRefs) &&
                  window.top.inboxRefs[inbox.viewportID] && window.inboxRefs[inbox.viewportID].exposed.fullyMounted)   ||
              (counter > 20)) {
            clearInterval(intervalId);
            await this.$nextTick();
            if(inbox) {
              console.log('callback', 'inbox found - setReplyMessageId being called');
              this.callInboxFn('setReplyMessageId', [historyMessage.PK]);
            }
          }
        },200);


      };

       */
      return ()=>{};

    },
    async startCreateAIAppFlow(historyItem) {
      console.log('startCreateAIAppFlow', 'item:', historyItem);
      this.componentData.replyMode = true;
      this.componentData.nextCommandStep = 'appName';

      let envelope = {
        ToPE: historyItem.ByPE,
        ByPE: historyItem.ToPE
      }
      let historyMessage = await this.postHistoryMessage(Object.assign({
            PK: oxygenUtil.getGUID(),
            TaskID: oxygenUtil.getGUID(),
            TaskTemplateID: this.standardTaskTemplateId,
            SessionId: oxygenUtil.Cookies.get('sessionId'),
            CausingEventLabel: 'Reply',
            CausingEventID: historyItem.PK,
            RootEventID: historyItem.RootEventID,
            Note: JSON.stringify({ String: this.createAIAppMessage, Link: ''}),
            ArgJSON: JSON.stringify({expandByDefault: true})
          },
          envelope,
          this.getLocationData(),
          this.getCredentialData(),
          this.getEventTemplateData(),
      ));
      this.setupReply();
      this.componentData.textareaPlaceholder = 'App Name';
      this.componentData.currentInboxFocusedMessage = { data: historyMessage, path: historyMessage.PK };
      let cb = () => {
        console.log('callback', 'calling setReplyMessageId:', historyMessage.PK);

        let counter = 0;

        let intervalId = setInterval(async ()=>{
          let inbox;
          counter++;
          await this.$nextTick();
          if(((inbox = window.devStore.viewPorts.find(e => ((this.viewport.ClientID === e.ClientID)) && e.isInbox)) && console.log('callback', 'refs:', window.top.inboxRefs) &&
                  window.top.inboxRefs[inbox.viewportID] && window.inboxRefs[inbox.viewportID].exposed.fullyMounted)   ||
              (counter > 20)) {
            clearInterval(intervalId);
            await this.$nextTick();
            if(inbox) {
              console.log('callback', 'inbox found - setReplyMessageId being called');
              this.callInboxFn('setReplyMessageId', [historyMessage.PK]);
            }
          }
        },200);


      };
      return cb;

    },
    addMeetingRecipients() {
      let members = window.botStore.getMembers(this.meetingContext.MeetingParentId);
      console.log('addMeetingRecipients', 'members:', members);
      if(Array.isArray(members) && members.length) {
        members.forEach((e)=>{
          let meetingContext = JSON.parse(e.MeetingContext);

          //Shouldn't we allow a person to leave a message in the meeting for himself?
          //if(meetingContext.MeetingRole === 'Moderator' && e.PE !== this.contextPE && e.PE !== this.actualContextPE) {
          if((e.PE !== this.contextPE) && (e.PE !== this.actualContextPE)) {
            console.log('addMeetingRecipients', 'recipient:', e.PE);
            this.addRecipientPE(e.PE);
          }
        });
      }

    },
    async showSavedMessagesList() {
      this.multipleFormsContainerTitle = "Saved Messages";
      this.multipleFormsRows.length = 0;

      this.multipleFormsRows.push(
          {
            type: "input",
            name: "TemplateName",
            label: "Name",
            readOnly: false,
            value: ''
          },
          {
            type: "textarea",
            name: "TemplateText",
            label: "Message",
            readOnly: false,
            value: ''
          }
      );

      let data = await oxygenUtil.callCommonServiceAPI("simplia-api","getMessageTemplates", { ClientId:  this.client.Client });
      this.initialMultipleFormsData.length = 0;


      this.initialMultipleFormsData.push( ...((this.currentMessageTemplates = data.results).map((e) => {
        return { TemplateText: e.TemplateText, TemplateName: e.TemplateName }
      })));

      this.multipleFormsButtons.length = 0;
      this.multipleFormsButtons.push(
        { id: 'hide', html: 'Hide', callback: ()=>{
            this.$refs.multipleFormsContainer.hide();
          }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}},
          { id: 'save', html: 'Save', callback: async ()=>{
              await this.saveMessageTemplates();
              this.$refs.multipleFormsContainer.hide();
            }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}},
        { id: 'use', html: 'Use', callback: ()=>{
            /*console.log('use-callback', 'templateTextItem:',  this.$refs.multipleFormsContainer.formInstance.getItem('TemplateText'),
            'val:', this.$refs.multipleFormsContainer.formInstance.getItem('TemplateText').getValue());*/
            this.setMessage(this.$refs.multipleFormsContainer.formInstance.getItem('TemplateText').getValue());
            this.$refs.multipleFormsContainer.hide();
          }, disabled: false, show: true, orientation: 'right', style: { 'background-color': '#0072C5', 'color': 'white'}},
      );

      this.$refs.multipleFormsContainer.showContainerAlignedToElementInViewport(
          document.getElementById(this.viewportID).querySelector(".main-panel-header-title"),
          'bottom',
          document.getElementById(this.viewportID).getBoundingClientRect()
      );
      await this.$nextTick();
      document.getElementById(this.viewportID).querySelector(".main-panel-header-title").focus();
    },
    async textareaMounted() {
      await this.$nextTick();
      //console.log('textareaMounted', 'parent:', this.$refs.textarea.$el.parentElement);
      if(!this.componentData.showTextarea) {
        this.$refs.textarea.$el.parentElement.style.display = 'none';
      }

    },
    getCommands(input, callback) {
      callback(null, Object.keys(this.messageCommands).filter(e => (e !== '/create Labeled Smart Link') && (e !== '/create Labeled Anonymous Smart Link')));
    },
    getDeskChannels(input, callback) {
      //Extract the channel names from this.DeskContext;
      //console.log('getDeskChannels', 'context:', this.DeskContext);
      let channels = (this.DeskContext.Node && this.DeskContext.Node.Condition && (this.DeskContext.Node.Condition.toLowerCase() === 'active') && Array.isArray(this.DeskContext.Node.ArgJSON.Results) && this.DeskContext.Node.ArgJSON.Results.map(e => `@${e}`)) || [];
      callback(null, channels);
    },
    getServiceFn(name) {
      let fn = {
        'bot': this.setLocalBot.bind(this),
        'editor': this.setEditor.bind(this),
        'aichat': this.setAIChat.bind(this),
        'resumeranking': this.setResumeRanking.bind(this)
      }
      return fn[name] || null;
    },

    async handleSubjectInputKeyupEvent(e) {

      if(this.$refs.subjectInput.$el.value.trim() === '@') {



        this.componentData.channelMessageSet = true;
        if(this.$refs.subjectInput.inputEntered) {

          this.$refs.subjectInput.inputEntered();
        }

      }
    },
    async handleTextareaKeyupEvent() {

      //console.log('watch-componentData.messageBoxText', 'newVal:', this.componentData.messageBoxText, ' - val:', this.$refs.textarea.$el.value);
      if(this.$refs.textarea.$el.value.trim() === '/offer') {
        await this.resetMessageBox();
        this.setupAgreementOffer();
        this.setReplyIcon('replyRecipients');
        await this.$nextTick();
        await this.$nextTick();
        this.$refs.textarea.$el.value = '';
        this.mainPanel.componentData.messageBoxText = '';
      }
      else if(this.$refs.textarea.$el.value.trim() === '/request') {
        await this.resetMessageBox();
        this.setupAgreementRequest();
        this.setReplyIcon('replyRecipients');
        await this.$nextTick();
        await this.$nextTick();
        this.$refs.textarea.$el.value = '';
        this.mainPanel.componentData.messageBoxText = '';
      }
      else if(this.$refs.textarea.$el.value.trim() === '/agree') {
        this.$refs.textarea.$el.value = '';
        this.mainPanel.componentData.messageBoxText = '';
        //Check if others have already agreed
        //If not, then mark the current sender as agreed
        //If yes, then generate an agreement
        let otherParty = (this.componentData.currentInboxFocusedMessage.data.ByPE === (this.envelopeByPE || this.contextPE) ?
            this.componentData.currentInboxFocusedMessage.data.ToPE :  this.componentData.currentInboxFocusedMessage.data.ByPE );

        let agreedEvents = await oxygenUtil.searchHistory(
            this.client.Client,
            this.clientContext.GrantID,
            {
              where: [
                { name: 'RootEventID', value: this.componentData.currentInboxFocusedMessage.data.RootEventID },
                { name: 'EventLabel', value: 'Agreed' },
                { name: 'ByPE', value: otherParty }
              ]
            }
        );
        if(agreedEvents.length === 1) {
          let event = await this.postHistoryMessage(Object.assign({
                    PK: oxygenUtil.getGUID(),
                    CausingEventID: this.componentData.currentInboxFocusedMessage.data.PK,
                    RootEventID: this.componentData.currentInboxFocusedMessage.data.RootEventID,
                    ToPE: otherParty ,
                    Note: JSON.stringify({ String: 'I agree', Link: ''}),
                    EventLabel: 'Agreed',
                    EventTemplate: this.setSendEventTemplate(),
                    NoteTemplate: "MessageNoteTemplate-0056",
                    NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
                    TaskID: oxygenUtil.getGUID(),
                    TaskTemplateID: this.standardTaskTemplateId,
                    SessionId: oxygenUtil.Cookies.get('sessionId')
                  },
                  this.getSenderEnvelope(),
                  this.getLocationData() )
          );

          let leafNodes = await oxygenUtil.callCommonServiceAPI("graph-search", "getLeafEdges", { ID: this.componentData.currentInboxFocusedMessage.data.RootEventID});

          await this.postHistoryMessage(Object.assign({
              PK: oxygenUtil.getGUID(),
              CausingEventID: event.PK,
                CausingEventIDs: leafNodes.map(e => e._source.RightID),
                RootEventID: this.componentData.currentInboxFocusedMessage.data.RootEventID,
              ToPE: otherParty ,
              Note: JSON.stringify({ String: 'An agreement has been reached', Link: ''}),
              EventLabel: 'Agreement',
              EventTemplate: this.setSendEventTemplate(),
              NoteTemplate: "MessageNoteTemplate-0056",
              NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
              TaskID: oxygenUtil.getGUID(),
              TaskTemplateID: this.standardTaskTemplateId,
              SessionId: oxygenUtil.Cookies.get('sessionId')
            },
            this.getSenderEnvelope(),
            this.getLocationData() )
          );
        }
        else {
          await this.postHistoryMessage(Object.assign({
                    PK: oxygenUtil.getGUID(),
                    CausingEventID: this.componentData.currentInboxFocusedMessage.data.PK,
                    RootEventID: this.componentData.currentInboxFocusedMessage.data.RootEventID,
                    ToPE: otherParty ,
                    Note: JSON.stringify({ String: 'I agree', Link: ''}),
                    EventLabel: 'Agreed',
                    EventTemplate: this.setSendEventTemplate(),
                    NoteTemplate: "MessageNoteTemplate-0056",
                    NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
                    TaskID: oxygenUtil.getGUID(),
                    TaskTemplateID: this.standardTaskTemplateId,
                    SessionId: oxygenUtil.Cookies.get('sessionId')
                  },
                  this.getSenderEnvelope(),
                  this.getLocationData() )
          );
        }
      }

    },
    async handleInitialInputKeyupEvent(e) {
      //console.log('input', 'e:', e, ' - key:', e.key, ' - code:', e.keyCode);
      if(( (e.keyCode === 191) || (e.keyCode === 111) ) && (this.$refs.initialInput.$el.value.trim() === '/')) {
        this.mainPanel.componentData.initialInputText = '';

        this.setupSend();
        await this.$nextTick();

        this.setMessage('/');
        await this.$nextTick();
        await this.$nextTick();
        await this.$nextTick();
        //this.componentData.channelMessageSet = true;
        this.componentData.commandMode = true;
        if(this.$refs.textarea.inputEntered) {
          this.$refs.textarea.inputEntered();
        }
        this.setReplyIcon('replyBot');
        this.componentData.showMessageBoxSubjectInput = false;
      }
      else if(e.keyCode === 13) {
        await this.checkForInput(
            this.$refs.initialInput.$el.value,
            this.$refs.initialInput.$el.dataset.awesompleteVal,
            async () => {
              await this.$nextTick();
              await this.$nextTick();
              this.$refs.initialInput.$el.value = '';
              this.mainPanel.componentData.initialInputText = '';
            },
            this.$refs.initialInput.$el.dataset.awesompleteRole && this.$refs.initialInput.$el.dataset.awesompleteRole.split(",")
        );
      }
    },
    async checkForInput(text, awesompleteVal, postFn, roles) {
      //console.log('checkForInput', 'text:', text);
      let matches, component, isBot, isQuill, isService, msgRecipient;
      roles = roles || [];

      if((matches = /^((?:hello)|(?:reload))\s+@(.+)$/i.exec(text)) &&
          (component = await oxygenUtil.callCommonServiceAPI("simplia-api","getComponentByDisplayName", { componentDN: matches[2]}))) {
        //console.log('checkForInput', 'calling setForeignBot');
        await this.setForeignBot(component.Node, matches[1].toLowerCase() === 'reload');
        await postFn();
        return true;
      }
      else if((matches = /^@(.+)$/.exec(text)) &&
          (msgRecipient = awesompleteVal.slice(1).split('/'))) {
        //console.log('checkForInput', 'calling ')
        //Sending a message to a specific user
        let message = text.substring(awesompleteVal.length).trimStart();
        this.componentData.minimalMode = true;
        let recipientComps = await async.parallel({
          thread: async () => { return await oxygenUtil.getComponentByDisplayName(msgRecipient[0]); },
          subject: async () => { return !msgRecipient[1] ? null : await oxygenUtil.getComponentByDisplayName(msgRecipient[1]); }
        });
        let defaultRole = 'admin';
        let conversationPE = this.componentData.conversationPE = oxygenUtil.createSimpleOES([roles[0] || defaultRole, recipientComps.thread.Node,
          roles[1] || roles[0] || defaultRole, (recipientComps.subject ? recipientComps.subject.Node : recipientComps.thread.Node)]);

        this.componentData.conversationMode = !this.componentData.conversationMode ? true : oxygenUtil.getUUID();
        await this.sendHistoryMessage(conversationPE, message);
        await this.setInboxRecipient(conversationPE,
            { fn: ['setupSend' ], fnParams: [[]]});
        await postFn();
        return true;
      }
      else if(!this.currentSimpleMode) {
        let botPE = oxygenUtil.createSimpleOES(['sessionbot', this.componentData.atComponent.Node, 'sessionbot', this.componentData.atComponent.Node]);
        let historyMessage = await this.sendHistoryMessage(botPE, text.trim());
        this.componentData.currentInboxFocusedMessage = { data: historyMessage, path: historyMessage.PK };
        this.componentData.minimalMode = true;
        this.componentData.replyMode = true;
        await this.setInboxRecipient(botPE,
            { fn: ['setupSend' ], fnParams: [[]]});

        return true;
      }
      else {
        //await this.sendHistoryMessage(oxygenUtil.createSimpleOES(['bot', this.componentData.atComponent.Node, 'bot', this.componentData.atComponent.Node]), text.trim());
        //return true;
        return false;
        //console.log('handleInitialInputKeyupEvent', 'sending to bot');
        //this.mainPanel.componentData.botMode = true;
        //await this.setInboxRecipient('', { fn: ['setupSend', 'sendBotMode'], fnParams: [[],[this.$refs.initialInput.$el.value]]});

        //this.setupSend();
        //this.sendBotMode();
        //this.$refs.initialInput.$el.value = '';
        //this.mainPanel.componentData.initialInputText = '';
      }

    },
    async setSessionBotMode() {
      let botPE = oxygenUtil.createSimpleOES(['sessionbot', this.componentData.atComponent.Node, 'sessionbot', this.componentData.atComponent.Node]);
      this.componentData.minimalMode = true;
      this.componentData.replyMode = true;
      await this.setInboxRecipient(botPE,
          { fn: ['setupSend' ], fnParams: [[]]});

    },
    getSenderEnvelope() {
      return Object.assign({
        ByPE: this.envelopeByPE || this.contextPE,
        FromPE: this.mainPanel.GatewayPE,
        CredentialPE: this.CredentialPE,
        AgentOfPE: this.mainPanel.AgentOfPE || this.mainPanel.GatewayPE,
        GatewayPE: this.mainPanel.GatewayPE
      },(
          this.attributionRecord ? {
            AttributionId: this.attributionRecord.ID
          } : {}
      ))
    },
    async sendHistoryMessage(ToPE, message, PK) {
      return await this.postHistoryMessage(Object.assign({
            PK: PK || oxygenUtil.getGUID(),
            ToPE,
            Note: JSON.stringify({ String: message, Link: ''}),
            EventLabel: this.setSendEventLabel(),
            EventTemplate: this.setSendEventTemplate(),
            NoteTemplate: "MessageNoteTemplate-0056",
            NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
            TaskID: oxygenUtil.getGUID(),
            TaskTemplateID: this.standardTaskTemplateId,
            SessionId: oxygenUtil.Cookies.get('sessionId')
          },
          this.getSenderEnvelope(),
          this.getLocationData() )
      );
    },
    getEditorWCNote() {
      return {
        String: `<quill-editor nodeid="zJ_rmooBc95huQ37fFFB" contextPE="11admin1_FFFFFFFFFFFFFF00001567723986493004_1holder1_FFFFFFFFFFFFFF00001567723986493005_">
      <p>This is child content</p>
    </quill-editor>`,
        LinkMeta: `Module`,
        Link: `/simplia/dist/js/quill-editor.js`
      }
    },
    async setupEditor() {
      let PEs = await this.getChatRecipientPEs();

      await this.postHistoryMessage(Object.assign({
            PK: oxygenUtil.getGUID(),
            ByPE: this.contextPE,
            ToPE: PEs[0].row.data.PE,
            FromPE: this.mainPanel.GatewayPE,
            CredentialPE: this.CredentialPE,
            AgentOfPE: this.mainPanel.AgentOfPE || this.mainPanel.GatewayPE,
            GatewayPE: this.mainPanel.GatewayPE,
            //TransactionId: this.lastTransactionId,
            Note: JSON.stringify(this.getEditorWCNote()),
            EventLabel: this.setSendEventLabel(),
            EventTemplate: this.setSendEventTemplate(),
            NoteTemplate: "MessageNoteTemplate-0056",
            NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
            TaskID: oxygenUtil.getGUID(),
            TaskTemplateID: this.standardTaskTemplateId,
            SessionId: oxygenUtil.Cookies.get('sessionId')
          }, (
              this.attributionRecord ? {
                AttributionId: this.attributionRecord.ID
              } : {}
          ),
          this.getLocationData()));
    },
    async setEditor() {
      this.mainPanel.componentData.botMode = true;
      await this.setInboxRecipient(
          oxygenUtil.createSimpleOES(['bot', this.client.ClientRight, 'bot', this.client.ClientRight]),
          { fn: 'setupEditor' }
      );

    },
    async assignRoleSelected(role) {
      let results = await oxygenUtil.runDBQuery(
          `select distinct ToRightDN, ToPE from OxygenDatabase.Grants where GrantRightID = ? and GrantRightR = ? and GrantType = ?`,
          [this.parsedContextPE[3], role, 'Grant']
      );
      if(results && results.length) {
        this.mainPanel.componentData.homepageCurrentRoleAccounts = [].concat({ label: '', value: '' },results.map((e)=>{
          return {
            label: oxygenUtil.formatDN(e.ToRightDN),
            value: e.ToPE
          }
        }));
      }

    },
    async removeRoleSelected(role) {
      let results = await oxygenUtil.runDBQuery(
          `select * from OxygenDatabase.AttributionBookmarks where ContextPE like ?`,
          [`%${oxygenUtil.createPartialOESSegments(
              [{encoding: oxygenUtil.defaultSegmentEncoding, segment: role}, {
            encoding: oxygenUtil.defaultSegmentEncoding, segment: this.parsedContextPE[3]}])}%`]
      );
      if(results && results.length) {
        let componentIds = results.reduce((acc, cur, index)=>{
          let id = oxygenUtil.parseOES(cur.ContextPE).segments[1];
          acc[id] = id;
          return acc;
        },{});

        let {components} = await oxygenUtil.callCommonServiceAPI("simplia-api","getMultipleComponents", { componentIds });

        this.mainPanel.componentData.homepageCurrentRoleAccounts = [].concat({ label: '', value: '' },results.map((e)=>{
          let contextPE = oxygenUtil.parseOES(e.ContextPE).segments;
          let accountPE = oxygenUtil.createSimpleOES([contextPE[0], contextPE[1], contextPE[0], contextPE[1]]);
          this.mainPanel.componentData.homepageAccountsMap[accountPE] = e;
          return {
            label: oxygenUtil.formatDN(components[contextPE[1]].DisplayName),
            value: accountPE,
          }
        }));
      }

    },
    addHomepageRoleRecipient() {
      let mode = {
        'assign_homepage': this.addAssignHomepageRoleRecipient.bind(this),
        'remove_homepage': this.addRemoveHomepageRoleRecipient.bind(this)
      }
      if(mode[this.currentSimpleMode]) {
        mode[this.currentSimpleMode]();
      }
    },
    addAssignHomepageRoleRecipient() {
      let path = `${this.recipientPathPrefix}${this.mainPanel.componentData.homepageCurrentRoleAccount}`;
      if(!this.$refs.menuTable.getRow(path)) {
        this.addRecipientPE(this.mainPanel.componentData.homepageCurrentRoleAccount);
      }
    },
    addRemoveHomepageRoleRecipient() {
      let path = `${this.recipientPathPrefix}${this.mainPanel.componentData.homepageCurrentRoleAccount}`;
      if(!this.$refs.menuTable.getRow(path)) {
        this.addRecipientPE(this.mainPanel.componentData.homepageCurrentRoleAccount );
      }
    },
    createNewTaskClicked() {
      if(this.client.childViewports && this.client.childViewports.showTasks) {

        this.client.childViewports.showTasks();


        let counter = 10, intervalId;
        intervalId = setInterval(() => {
          let tasks;
          counter++;

          if ((tasks = window.devStore.viewPorts.find(e => ((this.viewport.ClientID === e.ClientID) && e.isTasks))) || (counter < 9)) {
            clearInterval(intervalId);
            if (tasks) {
              this.lastTasksViewportId = tasks.viewportID;
              window.tasksRefs[tasks.viewportID].exposed.openPEInitialContext.value = {refererViewportId: this.viewportID};
              window.tasksRefs[tasks.viewportID].exposed.searchCoord.value.filterTable.unselectAllCategories();
              window.tasksRefs[tasks.viewportID].exposed.searchCoord.value.filterTable.selectCategory("All", "Templates");
              window.tasksRefs[tasks.viewportID].exposed.searchCoord.value.refreshData();
            }
          }
        }, 200);
      }
    },
    addEventListeners() {
      window.addEventListener(`${this.viewportID}-new-task-created`, async (ev)=>{
        this.addComponentAsAttachment(ev.detail.componentId);
        if(this.lastTasksViewportId) {
          window.DevMgr.closeViewPort(this.lastTasksViewportId);
        }
      });


      window.addEventListener(`${this.client.Client}-contactsMode-change`,(ev)=>{
        //console.log('event-contactsMode-change', 'ev:', ev);
        this.mainPanel.componentData.clientContactsMode = ev.detail.CurrentMode;
        this.mainPanel.componentData.currentContactsModeViewport = ev.detail.ViewportID;
      });

      window.addEventListener(`${this.viewportID}-set-inbox-recipient`, async (ev)=>{

        let counter = 0;
        let intervalId = setInterval(async ()=>{

          counter++;
          //console.log('setInboxRecipient', 'inbox:', inbox, ' - MessageBox:', inbox ? inbox.MessageBox : '', '- counter:', counter, ' - isTrue:', (counter > 10));
          await this.$nextTick();
          if(( this.$refs.settingsRibbon && this.$refs.menuTable) ||
              (counter > 10)) {
            clearInterval(intervalId);
            if(counter <= 10) {
              //console.log('set-inbox-recipient-listener', ' menuTable:', this.$refs.menuTable);

              await this.$nextTick();
              this.setMessage('');
              this.setupSend();
              //console.log('set-inbox-recipient-listener', 'detail:', ev.detail);
              if(ev.detail.recipientPE) {
                await this.addRecipientPE(ev.detail.recipientPE, null, null);
              }

              //console.log('set-inbox-recipient-listener', 'detail:', ev.detail);
              this.componentData.botCommunicationMode = true;

              //console.log('set-inbox-recipient-listener', 'detail:', ev.detail, ' - fn:', ev.detail && ev.detail.fn && this[ev.detail.fn]);
              if(Array.isArray(ev.detail.fn)) {
                ev.detail.fn.forEach((e,i)=>{
                  if(this[e]) {
                    let params = ev.detail.fnParams[i] || [];
                    this[e](...params);
                  }
                })
              }
              if(ev.detail.fn && this[ev.detail.fn]) {
                this[ev.detail.fn]();
              }

              //await this.sendAppInitMessage( ev.detail.recipientPE);
            }

          }
        },200);
      });

      window.addEventListener(`${this.viewportID}-messagebox-set-component-data`, async (ev)=>{
        //console.log('event', 'messagebox-set-component-data  - detail:', ev.detail);
        ev.detail && ev.detail.name && (typeof this.componentData[ev.detail.name] !== "undefined") && (this.componentData[ev.detail.name] = ev.detail.value) ;
        //console.log('event', 'name:', ev.detail.name, ' - val:', this.componentData[ev.detail.name]);
      });

    },
    async sendAppInitMessage(recipientPE) {
      /*this.postHistoryMessage(Object.assign({
            PK: oxygenUtil.getGUID(),
            FromPE: this.mainPanel.GatewayPE,
            CredentialPE: this.CredentialPE,
            AgentOfPE: this.mainPanel.AgentOfPE || this.mainPanel.GatewayPE,
            GatewayPE: this.mainPanel.GatewayPE,
            //TransactionId: this.lastTransactionId,
            Note: JSON.stringify({ String: this.componentData.currentForwardedMessage ? this.createForwardedMessage() : this.getFullMessage(), Link: ''}),
            EventLabel: this.setSendEventLabel(),
            EventTemplate: this.setSendEventTemplate(),
            NoteTemplate: "MessageNoteTemplate-0056",
            NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
            TaskID: taskId,
            TaskTemplateID: this.standardTaskTemplateId,
            ToPE: recipientPE,
            ByPE: this.envelopeByPE || this.contextPE
          }, (
              this.attributionRecord ? {
                AttributionId: this.attributionRecord.ID
              } : {}
          ),

          ( this.geolocation && this.geolocation.location) ? {
            Lat: this.geolocation.location.latitude,
            Long: this.geolocation.location.longitude,
            IPAddress: this.geolocation.traits.ip_address,
            City: this.geolocation.city.names.en,
            State: this.geolocation.postal.code,
            Country: this.geolocation.country.names.en,
            GeoIPLocation: JSON.stringify(this.geolocation),
            SessionId: oxygenUtil.Cookies.get('sessionId')
          } : {} ));*/
      //console.log('sendAppInitMessage', 'viewportID:', this.viewportID);
      let counter = 0, inbox;
      let intervalId = setInterval(async ()=>{
        await this.$nextTick();
        counter++;
        if(((inbox = window.inboxRefs[this.viewportID]) && inbox.exposed.fullyMounted.value) ||
            (counter > 10)) {
          clearInterval(intervalId);
          await this.$nextTick();
          if(inbox) {
            //console.log('sendAppInitMessage', 'clearing interval - inbox:', inbox);

            let event = new CustomEvent(`${this.viewportID}-fn-call`, {
              detail: {
                fnName: 'setIframeViewData',
                args: [{ URL: '/WhiteBoard-0052/tldraw/index.html', frameAttrs: { 'data-recipientPE': recipientPE}, frameStyle:{height: '450px', border: 'none'} } ]
              }
            });
            window.dispatchEvent(event);
          }
        }
      },200);



    },
    setCurrentForwardedMessage(message) {
      this.componentData.currentForwardedMessage = message;
    },
    async getRoles(defaultRole, addRoles, ignoreRoles) {
      let parsedPE = oxygenUtil.parseOES(this.contextPE).segments;
      let args = [ [{ id: parsedPE[3], defaultRole: defaultRole || parsedPE[2] }], (addRoles && addRoles.map(e => ({componentId: parsedPE[3], role: e}))) || null , ignoreRoles || []];

      return await oxygenUtil.getAllComponentsRoles(...args);
    },
    setupFileUploadEvent(uploadViewportId) {
      this.fileUploadLogs = [];
      this.uploadViewportId = uploadViewportId;
      //if(!this.fileuploadEventSet) {
        //this.fileuploadEventSet = true;
        let counter = 0;
        let intervalID = setInterval(()=>{
          let wc = document.querySelector(`iframe-container[data-viewportID="${this.uploadViewportId}"]`);
          //console.log('addUploadContactsOption', 'wc:', wc);
          if(counter > 10) {
            clearInterval(intervalID);
          }
          else if(wc && wc.shadowRoot && wc.shadowRoot.getElementById(wc.id) && wc.shadowRoot.getElementById(wc.id).contentWindow.uppy) {
            wc.shadowRoot.getElementById(wc.id).contentWindow.uppy.on('upload-success', async (...args) => {
              if(args[1].body && (args[1].body.PanelID === this.uploadViewportId)) {
                this.fileUploadLogs.push(args[1].body);
              }
              console.log('upload-success', 'args:', args);
              //Call API to upload data to Master Provider
              //Do openPE on the list component template
            });
            clearInterval(intervalID);
          }
          else {
            counter++;
          }

        },200);

      //}
      this.setupFileUploadEventOld();
    },
    setupFileUploadEventOld() {
      this.uploadFileEventGUID = this.uploadFileEventGUID || oxygenUtil.getUUID();
      this.client.fileUploadCallbacks[this.uploadFileEventGUID] || (this.client.fileUploadCallbacks[this.uploadFileEventGUID] = (e) => {
        console.log('setupFileUploadEventOld-callback', 'id:', this.uploadFileEventGUID, ' - uploadId:', this.uploadViewportId, ' - event:', e);
        //let filesViewport = window.devStore.viewPorts.reverse().find(e => e.PanelTitle === 'Files');
        //console.log('setupFileUploadEventOld-callback', 'filesViewport:', filesViewport && filesViewport.viewportID, ' - event:', e);
        //if(filesViewport && (e.detail.PanelID === filesViewport.viewportID)) {
        if(e.detail.PanelID === this.uploadViewportId) {
          async.each(this.fileUploadLogs, async (log) => {

            if(e.detail.filePath === log.filePath) {
              this.addComponentAsAttachment(e.detail.componentId);
            }
            else {
              let fileEx = /^.+\/(.+)$/;
              let results = fileEx.exec(log.filePath);
              if (results) {
                let guid = oxygenUtil.getGUID();
                let component = await oxygenUtil.createComponent("2016-11-08T21:52:39.289240Z000-0000Z", {
                  Data: {
                    fileUrl: log.filePath
                  }
                }, {
                  Node: guid,
                  DNPrefix: results[1],
                  toPE: log.ContextPE
                });
                this.addComponentAsAttachment(guid);
              }
            }
          })


          //delete this.client.fileUploadCallbacks[this.uploadFileEventGUID];
          //window.DevMgr.closeViewPort(filesViewport.viewportID);
          window.DevMgr.closeViewPort(this.uploadViewportId);
        }
      })

      console.log('setupFileUploadEvent', 'fileUploadCallbacks:', this.client.fileUploadCallbacks);

      /*
      if(window.SimpliaEvent) {
        this.client.fileUploadEvent = window.SimpliaEvent.addEventListener('fileImported', async (e) => {

          let filesViewport = window.devStore.viewPorts.find(e => e.PanelTitle === 'Files');
          if(filesViewport && e.detail.PanelID === filesViewport.viewportID) {

            console.log('fileImported-Event', 'e:', e);
            console.log('fileImported-Event', 'filePath:', e.detail.filePath);

            let fileEx = /^.+\/(.+)$/;
            let results = fileEx.exec(e.detail.filePath);
            if (results) {
              let guid = oxygenUtil.getGUID();
              let component = await oxygenUtil.createComponent("2016-11-08T21:52:39.289240Z000-0000Z", {
                Data: {
                  fileUrl: e.detail.filePath
                }
              }, {
                Node: guid,
                DNPrefix: results[1],
                toPE: e.detail.ContextPE
              });

              window.dispatchEvent(new CustomEvent('importedFileAttached', {detail: Object.assign(e.detail, {componentId: guid})}));
            }
          }
        });

      }

       */
    },
    addInitialContextRecipients() {
      //console.log('addInitialContextRecipients', 'parsedContext:', oxygenUtil.tryParseJSON(this.client.InitialContext));
      let parsedContext;
      if(this.client.InitialContext && (parsedContext = oxygenUtil.tryParseJSON(this.client.InitialContext))) {
        if(parsedContext.Email) {
          let emails = Array.isArray(parsedContext.Email) ? parsedContext.Email : [parsedContext.Email];
          //console.log('addInitialContextRecipients', 'emails:', emails);
          emails.forEach(e => this.addEmail(e));
        }
        if(parsedContext.PhoneNumber) {
          let phoneNumbers = Array.isArray(parsedContext.PhoneNumber) ? parsedContext.PhoneNumber : [parsedContext.PhoneNumber];
          //console.log('addInitialContextRecipients', 'phoneNumbers:', phoneNumbers);
          phoneNumbers.forEach(e => this.addPhone(oxygenUtil.parsePhone(e)));
        }
      }
    },
    showChildViewport(fnName, callback) {
      //console.log('childViewportFnName', 'fn:', this.client.childViewports[fnName]);
      if(this.client.childViewports && this.client.childViewports[fnName]) {
        return this.client.childViewports[fnName](callback);
      }
      return false;
    },
    showUploadViewport() {
      let viewportId;
      if(viewportId = this.showChildViewport('showFiles')) {
        console.log('showUploadViewport', 'viewportId:', viewportId);
        //this.setupImportedFileEventListener();
        this.setupFileUploadEvent(viewportId);
      }
    },
    setupImportedFileEventListener() {
      window.addEventListener('importedFileAttached', e => {
        let filesViewport = window.devStore.viewPorts.find(e => e.PanelTitle === 'Files');
        if(filesViewport && e.detail.PanelID === filesViewport.viewportID) {
          window.DevMgr.closeViewPort(filesViewport.viewportID);
          this.addComponentAsAttachment(e.detail.componentId)
        }
      }, { once: true});
    },
    addComponentAsAttachment(componentId, preferredDefaultRole, addSubAccount) {
      console.log('addComponentAsAttachment', 'addSubAccount:', addSubAccount);
      let defaultRolesList = ["admin", "holder", "visitor"];
      if(preferredDefaultRole) {
        let index;
        if((index = defaultRolesList.findIndex((e) => e === preferredDefaultRole)) !== -1) {
          defaultRolesList.splice(index, 1);
        }
        defaultRolesList.unshift(preferredDefaultRole);
      }

      async.waterfall([
        async () => {
          let component = await oxygenUtil.getComponent(componentId);
          //console.log('addComponentAsAttachment', 'component:', component);
          return component;
        },
        async (component) => {
          //console.log('addComponentAsAttachment', 'after-fn: component:', component);
          let allRoles = await oxygenUtil.getAllComponentsRoles(
              [
                {
                  id: component.Node,
                  defaultRole: defaultRolesList
                }
              ],
              [{componentId: component.Node, role: "visitor"}, {componentId: component.Node, role: "admin"}, {componentId: component.Node, role: "bot"}],
              ['owner']);
          console.log('addComponentAsAttachment', 'allRoles:', allRoles);
          return {allRoles, component};
        },
        (params, callback) => {
          this.addValidatedPE(params.component, params.allRoles[params.component.Node], this.$refs.attachmentsMenuTable, addSubAccount);
          callback();
        }
      ],(error)=>{
        this.componentData.showMessageBoxAttachmentsList = true;
      });
    },
    setupPropagator() {
      try {
        oxygenUtil.setupPropagator(
            this.componentData.propagatorId,
            {
            },
            ()=>{
              //console.log('callback');
            }
        );
      }
      catch(e) {
        setTimeout(()=>{
          this.setupPropagator();
        },1000);
      }
    },
    getSelectedMode() {
      return Object.keys(this.componentData.messageBoxModes).find(
          e => this.componentData[e]
      );
    },
    addButtons() {
      this.componentData.messageBoxHomepageAssignModeButtons = [
        this.createModeButton('assign_homepage', 'Assign'),
        this.createModeButton('remove_homepage', 'Remove'),
      ];

      this.componentData.messageBoxSendModeButtons = [
        this.createModeButton('send', 'Send'),
        this.createModeButton('email', 'Email'),
        this.createModeButton('sms', 'SMS'),
        this.createModeButton('forward', 'Forward'),
        this.createModeButton('link', 'Link'),
        this.createModeButton('share_message', 'Share'),
        this.createModeButton('reply', 'Reply'),
        this.createModeButton('new', 'New'),
        this.createModeButton('replace', 'Replace'),
        this.createModeButton('train', 'Train'),
        this.createModeButton('bot', 'Bot'),
        this.createModeButton('schedule', 'Send Schedule')
      ];

      this.componentData.messageBoxAgreementModeButtons = [
        this.createModeButton('agreement_offer', 'Offer'),
        this.createModeButton('agreement_request', 'Request')
      ];

      this.componentData.messageBoxShareModeButtons = [
        this.createModeButton('offer', 'Offer'),
        this.createModeButton('request', 'Request'),
        this.createModeButton('offer_task', 'Offer Task'),
        this.createModeButton('request_task', 'Request Task'),
        this.createModeButton('share', 'Share'),
        this.createModeButton('requestLock', 'Request Lock')
        //this.createModeButton('alert', 'Alert')
      ];

      this.componentData.messageBoxMeetingModeButtons = [
        this.createModeButton('send', 'Message'),
        this.createModeButton('invite', 'Call'),
        this.createModeButton('page', 'Page'),
        this.createModeButton('join', 'Join'),
        this.createModeButton('meet', 'Meet'),

        this.createModeButton('barge', 'Barge'),
        this.createModeButton('whisper', 'Whisper'),
        this.createModeButton('spy', 'Spy'),
        this.createModeButton('show', 'Show'),
        this.createModeButton('watch', 'Watch'),
        this.createModeButton('draw', 'Draw')
      ];

      this.componentData.messageBoxPromiseModeButtons = [
        this.createModeButton('promise', 'Promise'),
      ]

      this.componentData.messageBoxContactsModeButtons = [
        this.createModeButton('request_contact', 'Request'),
        this.createModeButton('offer_contact', 'Offer'),
        this.createModeButton('share_contact', 'Share'),
      ]
    },
    createModeButton(id, html) {
      return { id, html, selected: false, disabled: false, show: true,
        style: { "flex-grow": 1, "background-color": 'white',  'color': '#0072C5'} };
    },
    scheduleButtonClick() {
      this.mainPanel.componentData.showMessageBoxSchedule = !this.mainPanel.componentData.showMessageBoxSchedule;
    },
    schedulerButtonClick() {
      this.mainPanel.componentData.showMessageBoxScheduler = !this.mainPanel.componentData.showMessageBoxScheduler;
    },
    pictureButtonClick() {
      if(!this.client.fileUploadEvent) {
        //this.setupFileUploadEvent()
      }
      this.showUploadViewport();
      //Need to move to webcam
    },
    pictureButtonClickOld() {
//this.mainPanel.showNamedChildPanel("cameraPanel","CameraPanel", { panelTitle: "Camera Panel"},(panel)=>{});
      this.parent.showFileBrowserPanel({}, {}, (panel) => {
        let doCallback = () => {
          let row;
          if (row = panel.rightMenu.menuTable.getRow('Import Files')) {
            panel.addFrameLoadCB('webcam', () => {
              panel.removeFrameLoadCB('webcam');
              if (panel.panel.$refs.bodyComponent.$refs.frame.contentWindow.uppy) {
                panel.panel.$refs.bodyComponent.$refs.frame.contentWindow.uppy.reset();
              }
              panel.panel.$refs.bodyComponent.$refs.frame.contentDocument.getElementsByClassName('uppy-DashboardTab-btn')[1].click();

            });
            row.data.callback();
          }
          window.addEventListener('importedFileAttached', e => {

            panel.close();
            if (e.detail.PanelID === panel.__panelName) {
              async.waterfall([
                this.mainPanel.getComponent.bind(this.mainPanel, e.detail.componentId),
                (component, callback) => {
                  this.parent.getAllComponentsRoles(
                      [
                        {
                          id: component.Node,
                          defaultRole: ['admin', 'holder', 'visitor']
                        }
                      ],
                      [{componentId: component.Node, role: 'visitor'}],
                      [],
                      (error, allRoles) => {
                        callback(error, component, allRoles);
                      });
                },
                (component, allRoles, callback) => {
                  this.addValidatedPE(component, allRoles[component.Node], this.$refs.attachmentsMenuTable)
                  callback();
                }
              ], (error) => {
                this.componentData.showMessageBoxAttachmentsList = true;
              });
            }
          }, {once: true});
        }
        if (panel.rightMenu.menuTable) {
          doCallback();
        } else {
          panel.container.$on('action-menu-table-mounted', (menu) => {
            if (menu === panel.rightMenu) {
              doCallback();

            }
          });
        }
      });
    },
    setHTMLContentButtonValue(enabled) {
      this.newContentButtonClass['fa-plus'] = !enabled;
      this.newContentButtonClass['fa-minus'] = enabled;

    },
    newContentButtonClick() {
      //this.savedTemplateClicked(this.$refs.newContentButton);
      this.showBodyComponent = !this.showBodyComponent;
      if(this.showBodyComponent) {
        this.setHTMLContentButtonValue(true);
      }
      else {
        this.setHTMLContentButtonValue(false);
      }
    },
    recordButtonClick() {
      this.componentData.recordingState = !this.componentData.recordingState;
      this.componentData.recordButtonClass['far-microphone'] = !this.componentData.recordingState;
      this.componentData.recordButtonClass['far-microphone-slash'] = this.componentData.recordingState;
    },
    attachButtonClick() {
      //this.attachmentMenu.showAdjacent(this.$refs.attachButton, this.parent);
      if(['offer_task','request_task'].includes(this.currentSimpleMode)){
        this.containerTitle = `Add Tasks(s)`;
      }
      else {
        this.containerTitle = `Add ${oxygenUtil.config.attachmentTitle}(s)`;

      }
      this.options.length = 0;
      this.menuWidth = '350px';
      if(['offer_task','request_task'].includes(this.currentSimpleMode)) {
        this.options.push(...this.addTasksOptions);
      }
      else {
        this.options.push(...this.addAttachmentOptions);
      }

      this.$refs.newOptionsMenu.showMenuAlignedToElement(this.$refs.attachButton, 'right', 'top');
    },
    replyIconClick(...args) {
      this.containerTitle = 'Reply Options';
      //console.log('args:', args, ' - options:', this.replyOptions);
      this.menuWidth = '300px';
      this.options.length = 0;
      this.options.push(...this.replyOptions);
      this.$refs.newOptionsMenu.showMenuAlignedToElement(this.$refs.settingsRibbon.$el, 'left', 'top');
    },
    hideSettingsRibbonIcons() {
      if (this.parent._isInbox) {
        this.$refs.settingsRibbon.hideRibbonIcon("show_inbox");
      } else if (this.parent === this.mainPanel) {
        this.$refs.settingsRibbon.hideRibbonIcon("show_threadsubject");
      }
    },
    createTemplateAttachmentSecondRowComponent() {
      return {
        template: `
          <div>
          Action:
          <v-select class="simplia-select" style="width:300px;" label="text" v-model="dataRow.selectedAction"
                    :options="dataRow.allActions"></v-select>
          Result:
          <v-select class="simplia-select" style="width:300px;" label="text" v-model="dataRow.selectedResult"
                    :options="dataRow.allResults"></v-select>
          State:
          <v-select class="simplia-select" style="width:300px;" label="text" v-model="dataRow.selectedState"
                    :options="dataRow.allStates"></v-select>
          </div>`,
        props: ['dataRow', 'tableData'],
        data: () => {
          return {}
        },
        computed: {},
        methods: {}
      };
    },
    recipientsTableMounted() {
      //console.log('recipientsTableMounted', 'called');
      this.$nextTick(function () {
        this.recipientsListTextboxProps.menuTable = this.$refs.menuTable;
        if (!this.componentData.messageBoxRecipientsTableInitialized) {
          this.componentData.messageBoxRecipientsTableInitialized = true;
          this.initializeRecipientsList();
          //this.addInitialContextRecipients();
        }

//this.$refs.menuTable.setNormalView();
        //$(this.$refs.menuTable.$el).find('.v-data-table__wrapper').css('overflow', 'visible');
//this.parent.container.$emit('recipients-table-mounted');
      });
    },
    async subjectTableMounted() {
      await this.$nextTick();
      this.subjectTextboxProps.menuTable = this.$refs.subjectMenuTable;
    },
    attachmentsTableMounted() {
      //console.log('attachmentsTableMounted', 'called');
      this.$nextTick(function () {
        if (!this.componentData.messageBoxAttachmentsTableInitialized) {
          this.componentData.messageBoxAttachmentsTableInitialized = true;
          this.initializeAttachmentsTable();
        }

        //$(this.$refs.attachmentsMenuTable.$el).find('.v-data-table__wrapper').css('overflow', 'visible');
      });
    },
    requestGuestAccountAttSelected(value) {
      this.addAttachment({data: value.data});
    },
    meetingLinkCheckboxClicked() {
      Object.entries(this.componentData.meetingLinkClass).forEach((e) => {
        this.componentData.meetingLinkClass[e[0]] = !e[1];
      });
    },
    createDTComponent() {
      return  {
        template: `
          <table style="table-layout: fixed;">
          <colgroup>
            <col style="width:5.5em">
            <col style="width:auto">
          </colgroup>
          <td style="padding-left: 0px; font-size: inherit; font-weight: bold; vertical-align: middle;">{{title}}</td>
          <td style="padding-left: 0px; font-size: inherit;  vertical-align: middle;">
            <flat-pickr
                :config="config"
                v-model="dataRow.dateTime"
                :placeholder="placeholder"
            ></flat-pickr>
          </td>
          </table>`,
        props: {
          dataRow: Object,
          tableData: Object,
          title: String,
          placeholder: String
        },
        data: () => {
          return {
            config: {
              enableTime: true,
              dateFormat: "Y-m-d H:i",
            }
          }
        },
        mounted() {
          this.$nextTick(function () {
            //$(this.$el).find('input').css('width', '100%');
          });
        },
        computed: {},
        methods: {}
      };
    },
    createTimezoneSelectionComponent() {
      return {
        template: `
          <table style="table-layout: fixed;">
          <colgroup>
            <col style="width:5.5em">
            <col style="width:auto">
          </colgroup>
          <td style="padding-left: 0px; font-size: inherit; font-weight: bold; vertical-align: middle;">{{title}}</td>
          <td style="padding-left: 0px; font-size: inherit;  vertical-align: middle;">
            <v-select class="simplia-select" label="text" v-model="dataRow.selectedTimezone"
                      :options="mainPanel.config.timezones"></v-select>
          </td>
          </table>`,
        props: {
          dataRow: Object,
          tableData: Object,
          title: String,
          placeholder: String
        },
        data: () => {
          return {
            mainPanel: that.mainPanel
          }
        },
        mounted() {
          this.$nextTick(function () {
            //$(this.$el).find('input').css('width', '100%');
            //$(this.$el).closest('.v-data-table__wrapper').css('overflow', 'visible');
          });
        },
        computed: {},
        methods: {}
      };
    },
    removeRecipientPE(PE) {
      this.$refs.menuTable.deleteRow(`${this.recipientPathPrefix}${PE}`);
    },
    async addRecipientPE(PE, dataRow, source, allowRemoval) {
      console.log('addRecipientPE', 'PE:', PE, ' - allowRemoval:', allowRemoval);
      allowRemoval = (typeof allowRemoval !== "undefined") ? allowRemoval : (this.componentData.botMode ? false : true);
      let parsedPE = oxygenUtil.parseOES(PE).segments;
      let fromInbox = (source === "inbox");
      //console.log('addRecipientPE', 'refs:', this.$refs, ' - menuTable:', this.$refs.menuTable);

      await async.waterfall([
        async () => {
          return await oxygenUtil.callCommonServiceAPI("simplia-api","getMultipleComponents", { componentIds: {asComponent: parsedPE[1], atComponent: parsedPE[3]} });
        },
        async ({components}) => {
          let DNPrefix = oxygenUtil.getDNPrefix(components.atComponent.DisplayName);

          if (oxygenUtil.isEmail(DNPrefix) && (parsedPE[0] !== 'bot') && (parsedPE[0] !== 'sessionbot') ) {
            await this.addEmail(DNPrefix, this.$refs.menuTable, dataRow, fromInbox, parsedPE[2], allowRemoval);
            return '';

          } else if (oxygenUtil.isValidPhone(DNPrefix.replace('/Personal Account', ''))) {
            await this.addPhone(DNPrefix.replace('/Personal Account', ''), this.$refs.menuTable, dataRow, fromInbox, parsedPE[2], allowRemoval);
            return '';
          }
          else {
            return components;
          }
        },
        async (components) => {
          //console.log('addRecipientPE', 'adding row');
          if(components) {

            this.$refs.menuTable.addRow(Object.assign({
              cols: [
                /*{
                  html: `<span class="fal fa-share-alt"/>`,
                  callback: (dataRow, index, ev) => {
                    this.lastRoleClickEvent = ev;
                    this.showRoleMenu(dataRow.roles, {singleSelect: true});
                  }
                },*/
                {
                  html: `<span class="table-icon fas fa-question" style="color: lightgrey; font-size:13px; padding-bottom: 6px; padding-left:5px; padding-right: 5px;"/>`,
                  tooltip: 'Show Details',
                  callback: (...args) => {
                    this.showRecipientDetails(...args);
                  }
                },
                {
                  html: `<span style="font-size:${oxygenUtil.config.fontSize};">${oxygenUtil.encodeHTMLEntities(oxygenUtil.formatDN(components.asComponent.DisplayName))}</span>`,
                  tooltip: `${oxygenUtil.encodeHTMLEntities(components.asComponent.DisplayName)}`,
                  type: 'html'
                },
                {

                  html: `<span class="${this.iconIds.recipient}"/>`,
                  callback: (dataRow, index, ev) => {
                  },
                  styleObj: {
                    'color': 'black'
                  }
                }
              ],
              backgroundColor: 'white',
              hideCheckbox: true,
              showFolder: false,
              originalDataRow: dataRow,
              fromInbox: !!fromInbox,
              //searchComponent,
              data: {components, PE},
              path: `${this.recipientPathPrefix}${PE}`,
              type: this.rowTypes.PE,
              roles: [{role: parsedPE[2], selected: true}],

            }, allowRemoval ? {folderCol: {
                alt: {
                  html: `<span class="${this.iconIds.remove}"/>`,
                  callback: (dataRow) => {
                    this.$refs.menuTable.deleteRow(dataRow.path);
                  }
                }
              }} : {}), 0);
            await this.$nextTick();
            if(components.atComponent.Node !== components.asComponent.Node) {
              this.$refs.subjectMenuTable.addRow(Object.assign({
                cols: [
                  /*{
                    html: `<span class="fal fa-share-alt"/>`,
                    callback: (dataRow, index, ev) => {
                      this.lastRoleClickEvent = ev;
                      this.showRoleMenu(dataRow.roles, {singleSelect: true});
                    }
                  },*/
                  {
                    html: `<span class="table-icon fas fa-question" style="color: lightgrey; font-size:13px; padding-bottom: 6px; padding-left:5px; padding-right: 5px;"/>`,
                    tooltip: 'Show Details',
                    callback: (...args) => {
                      this.showRecipientDetails(...args);
                    }
                  },
                  {
                    html: `<span style="font-size:${oxygenUtil.config.fontSize};">${oxygenUtil.encodeHTMLEntities(oxygenUtil.formatDN(components.atComponent.DisplayName))}</span>`,
                    tooltip: `${oxygenUtil.encodeHTMLEntities(components.atComponent.DisplayName)}`,
                    type: 'html'
                  },
                  {

                    html: `<span class="${this.iconIds.recipient}"/>`,
                    callback: (dataRow, index, ev) => {
                    },
                    styleObj: {
                      'color': 'black'
                    }
                  }
                ],
                backgroundColor: 'white',
                hideCheckbox: true,
                showFolder: false,
                originalDataRow: dataRow,
                fromInbox: !!fromInbox,
                //searchComponent,
                data: {components, PE},
                path: `${this.recipientPathPrefix}${PE}`,
                type: this.rowTypes.PE,
                roles: [{role: parsedPE[2], selected: true}],

              }, allowRemoval ? {folderCol: {
                  alt: {
                    html: `<span class="${this.iconIds.remove}"/>`,
                    callback: (dataRow) => {
                      this.$refs.subjectMenuTable.deleteRow(dataRow.path);
                      this.componentData.showMessageBoxSubjectInput = true;
                      this.componentData.showMessageBoxSubjectTable = false;
                    }
                  }
                }} : {}), 0);
              this.componentData.showMessageBoxSubjectInput = false;
              this.componentData.showMessageBoxSubjectTable = true;
              await this.$nextTick();
            }
            this.componentData.showMessageBoxRecipientsTable = !(this.componentData.clientContactsMode === 'meeting') && !this.componentData.minimalMode && true;
            if (dataRow && dataRow.EventPath) {
              this.componentData.eventSubjectPlaceholder = EventPath;
            }
          }
        }
      ]);
      //console.log('addRecipientPE', 'done');

    },
    getMessageAttachment() {
      let rows = this.$refs.attachmentsMenuTable.tableData.dataRows;
      let filteredRows = rows.filter(e => (e.path !== this.recipientTextboxPath));
      if (filteredRows.length) {
        return filteredRows;
      }
      return null;
    },
    updateModeMenuItems() {
      this.currentButtonMenuItems.forEach(e => this.uiMenu.removeMenuItem(e));
      this.currentButtonMenuItems = [];
      async.series([
        (callback) => {
          if (!this.uiMenu) {
            this.createMainUIMenu(callback);
          } else {
            callback();
          }
        },
        (callback) => {
          this.messageBoxModeAllButtons.forEach((e) => {
            /*
console.log('updateModeMenuItems', 'e.html:', e.html);
this.uiMenu.addMenuItem(
`<span>${e.html}</span>`,
e.id,
e,
(dataRow)=>{ this.toggleModeButton(dataRow.data); this.uiMenu.hide();},
()=>{},
()=>{},
{
showCheckbox: false
});

*/
            this.currentButtonMenuItems.push(e.id);
          });
          callback();
        }
      ], () => {
      });
    },
    createReplyOptionsUIMenu(callback) {
      this.replyOptionsUIMenu = new UIMenu(this.parent.Y, {
        parentPanel: this.parent, parent: this.parent, onTableMounted: () => {
          //console.log('onTableMounted', 'called');
          this.$nextTick(function () {
            this.ribbonMenuInitialized++;
          })
        }
      });
      this.parent.standardMenus['messageBoxReplyOptionsUIMenu'] = this.replyOptionsUIMenu;
      this.replyOptionsUIMenu.init(() => {
        this.replyOptionsUIMenu.menuTable.$on('row-deselected', (dataRow) => {
//console.log('deselected-row', 'path:', dataRow.path);
          if (Object.keys(this.componentData.replyFlags).some(e => ((dataRow.path !== e) && this.componentData.replyFlags[e]))) {
            this.componentData.replyFlags[dataRow.path] = false;
          } else {
            this.componentData.replyFlags[dataRow.path] = true;
          }

          this.replyOptionsUIMenu.hide();

        });
        this.replyOptionsUIMenu.menuTable.$on('row-selected', (dataRow) => {
//console.log('deselected-row', 'path:', dataRow.path);
          this.componentData.replyFlags[dataRow.path] = true;
          this.replyOptionsUIMenu.hide();
        });

        this.replyOptionsUIMenu.tableContainer.$on('table-mounted', () => {
//this.setInitialSettings();
          this.$nextTick(function () {
//this.setReplyIcon('replyAll');
          })

        });

        if (callback) {
          callback();
        }
      });
    },
    createMainUIMenu(callback) {
      this.uiMenu = new UIMenu(this.parent.Y, {
        parentPanel: this.parent, parent: this.parent, onTableMounted: () => {
          //console.log('onTableMounted', 'called');
          this.$nextTick(function () {
            this.ribbonMenuInitialized++;
          })
        }
      });
      this.parent.standardMenus['messageBoxUIMenu'] = this.uiMenu;
      this.uiMenu.init(() => {
        this.uiMenu.menuTable.$on('row-deselected', (dataRow) => {
//console.log('deselected-row', 'path:', dataRow.path);
//this.componentData.replyFlags[dataRow.path] = true;
          this.uiMenu.hide();

        });
        this.uiMenu.menuTable.$on('row-selected', (dataRow) => {
//console.log('deselected-row', 'path:', dataRow.path);
//this.componentData.replyFlags[dataRow.path] = true;
          this.uiMenu.hide();
        });

        this.uiMenu.tableContainer.$on('table-mounted', () => {
//this.setInitialSettings();
          this.$nextTick(function () {
//this.setReplyIcon('replyAll');
          })

        });

        if (callback) {
          callback();
        }
      });
    },
    ribbonMenuRowSelected(dataRow, index) {
      this.$refs.settingsRibbon.showRibbonIcon(dataRow.data.id);
      if(this.currentSimpleMode) {
        this.settingsOptions.find(e => e[2] === dataRow.data.id)[8] = true;
      }
      else {
        //console.log('ribbonMenuRowSelected', 'selectedRow:', this.simpleModeOptions.find(e => e[2] === dataRow.data.id));
        this.simpleModeOptions.find(e => e[2] === dataRow.data.id)[7] = true;
        //if(this.$refs.ribbonMenu.menuTable.getSelectedRows().length) {

        if(this.$refs.ribbonMenu.menuTable.getSelectedRows().length > 1) {
          this.$refs.settingsRibbon.hideRibbonIcon('help_message');
          this.$refs.settingsRibbon.hideRibbonIcon('open_inbox');
        }
        //}
      }
    },
    ribbonMenuRowDeselected(dataRow) {
      this.$refs.settingsRibbon.hideRibbonIcon(dataRow.data.id);

      if(this.currentSimpleMode) {
        this.settingsOptions.find(e => e[2] === dataRow.data.id)[8] = false;
      }
      else {
        this.simpleModeOptions.find(e => e[2] === dataRow.data.id)[7] = false;
        //console.log('ribbonMenuRowDeselected', 'selectedRows:', this.$refs.ribbonMenu.menuTable.getSelectedRows().length);
        if(this.$refs.ribbonMenu.menuTable.getSelectedRows().length === 1) {
          this.$refs.settingsRibbon.showRibbonIcon('help_message');
          this.$refs.settingsRibbon.showRibbonIcon('open_inbox');
        }
      }
    },
    showUIMenu(item, event) {
      //console.log('showUIMenu', 'item:', item, ' - event:', event);
      //this.uiMenu.showAdjacent($(event.target).hasClass('ribbon-icon') ? event.target : $(event.target).parents('.ribbon-icon')[0], this.parent);
//$(this.uiMenu.windowElement).find('.content').css({'width': '413px'});
      this.ribbonOptions.length = 0;


      if(this.currentSimpleMode) {
        this.settingsOptions.forEach((e,i) => {
          //this.uiMenu.addRegisteredIconItem(...e)
          this.ribbonOptions.push({
            icon: e[1].type === 'css' ? e[1].classes : e[1],
            id: e[2],
            title: e[7],
            callback: e[3],
            path: e[0],
            hideMenu: !!e[9],
            checkboxSync: true,
            menuParams: {
              //selected: this.$refs.settingsRibbon.getIcon(e[2]).show
              selected: e[8]
            }
          });
        });
      }
      else {
        this.simpleModeOptions.forEach((e,i) => {
          //this.uiMenu.addRegisteredIconItem(...e)
          if(e[2] !== "help_message") {
            this.ribbonOptions.push({
              icon: e[1],
              id: e[2],
              title: oxygenUtil.capitalizeFirstLetter(e[2]),
              callback: e[3],
              path: `0000${i}`,
              menuParams: {
                selected: this.$refs.settingsRibbon.getIcon(e[2]).show
              }
            });
          }
        });
      }

      this.$refs.ribbonMenu.showMenuAlignedToElement(event.target, 'left', 'top');
    },
    showReplyOptionsUIMenu(event) {
      //this.replyOptionsUIMenu.showAdjacent($(event.target).hasClass('ribbon-icon') ? event.target : $(event.target).parents('.ribbon-icon')[0], this.parent);
//$(this.uiMenu.windowElement).find('.content').css({'width': '413px'});
    },
    meetingLinkCopied() {
      navigator.clipboard.writeText(this.componentData.meetingLink);
    },
    disableMeetingButtons() {

    },
    getMeetingLink() {
      if (!this.componentData.meetingLinkFetched) {
//Fetch the link
        this.mainPanel.getMeetingUrl({}, (error, link) => {
          this.componentData.meetingLink = link;
          this.componentData.meetingLinkFetched = true;
        });
      }
    },
    settingsRibbonMounted() {
      //console.log('settingsRibbonMounted - called');
      /*
while(this.ribbonOpsQueue.length) {
let op = this.ribbonOpsQueue.shift();
op.fn();
}

*/
      this.ribbonMenuInitialized++;
    },
    modeRibbonMounted() {
      this.ribbonMenuInitialized++;
    },
    buttonRibbonMounted() {
      while (this.buttonOpsQueue.length) {
        let opObj = this.buttonOpsQueue.shift();
        this.$refs.buttonRibbon1[opObj.op](opObj.button);
      }
    },
    createBodyComponent() {
      return {
        template: `
          <div :id="bodyComponentDivId"></div>`,
        props: [],
        data: () => {
          return {
            bodyComponentDivId: this.bodyComponentDivId
          }
        },
        computed: {},
        methods: {},
        watch: {}
      };
    },
    selectedRowsChanged() {

    },
    subjectSelectedRowsChanged() {

    },
    setAttachmentsList() {
      if (this.componentData.requestGuestAccountEnabled) {
        let recipientVals = [];
        //console.log('setAttachmentsList', 'rows:', this.$refs.menuTable.tableData.dataRows.filter(e => (e.path !== this.recipientTextboxPath)));
        this.mainPanel.runDBQuery({
          sql: `select * from OxygenDatabase.Grants where (${ this.$refs.menuTable.tableData.dataRows.filter(e => (e.path !== this.recipientTextboxPath)).reduce((acc, cur, index)=>{
            //console.log('setAttachmentsList', 'cur:', cur);
            let selectedRole = cur.roles.find(i => i.selected).role, leftID = cur.data.GrantLeftID || cur.data.component.Node,
                rightID = cur.data.GrantRightID || e.data.component.Node;

            let leftRole = cur.data.GrantLeftR || selectedRole;
            let clause = `${index ? ' OR ': ''} (ToRightID = ? and ToRightR = ? and ((ToLeftID = ? and ToLeftR = ?) or (ToLeftID = ? and ToLeftR = ?) ) )`;
            recipientVals.push(rightID, selectedRole, leftID, leftRole, rightID, selectedRole);
            return acc + clause;

          }, '') }) and GrantRightR  = ?`,
          vals: recipientVals.concat([this.mainPanel.config.roles.admin])
        }, (error, results) => {
          if (!error && results.length) {
            this.componentData.requestGuestAccountAttList.length = 0;
            results.forEach((e) => {
              this.componentData.requestGuestAccountAttList.push({label: e.GrantRightDN, data: e});
            });
          }
        });
      }

    },
    attachmentSelected() {
//console.log('attachmentSelected', 'selectedRows.length:', this.$refs.attachmentsMenuTable.getSelectedRows().length);
    },
    selectedAttachmentsRowsChanged(selectedRows) {

      //console.log('selectedAttachmentsRowsChanged', 'selectedRows.length:', selectedRows.length);
      if (selectedRows.length) {
        this.componentData.messageBoxAttachmentsFlag = true;
//this.$refs.settingsRibbon.selectIcon('attach');
      } else {
        this.componentData.messageBoxAttachmentsFlag = false;
//this.$refs.settingsRibbon.unselectIcon('attach');
      }
    },
    messageBoxModeButtonSelected(e, i) {

      //console.log(`watch-mainPanel.componentData.messageBoxModeButtons[${i}].selected`, 'id:', this.messageBoxModeAllButtons[i].id);
      //console.log(`watch-mainPanel.componentData.messageBoxModeButtons[${i}].selected`, 'selectedMode:', this.selectedMode);
      let selectedModeFn = {
        'shareMode.request': () => {
          this.optionsMenu.unhideMenuItem("Request Guest Account");
          this.optionsMenu.hideMenuItem("Offer Guest Account");
          this.componentData.showMessageBoxAttachmentsInputBox = true;
        },
        'shareMode.offer': () => {
          this.optionsMenu.hideMenuItem("Request Guest Account");
          this.optionsMenu.unhideMenuItem("Offer Guest Account");
        }
      }
//console.log(`watch-mainPanel.componentData.messageBoxModeButtons[${i}].selected`, 'selectedModeFn:', `${this.selectedMode}.${this.messageBoxModeAllButtons[i].id}`, ' fn:',
//    selectedModeFn[`${this.selectedMode}.${this.messageBoxModeAllButtons[i].id}`]);

      if (selectedModeFn[`${this.selectedMode}.${this.messageBoxModeAllButtons[i].id}`]) {
        selectedModeFn[`${this.selectedMode}.${this.messageBoxModeAllButtons[i].id}`]();
      } else {
        //this.optionsMenu.hideMenuItem("Request Guest Account");
        //this.optionsMenu.hideMenuItem("Offer Guest Account");
        this.componentData.showMessageBoxAttachmentsInputBox = false;
      }


      let actions = {
        [`shareMode/${this.componentData.messageBoxShareModes.request}`]: () => {
          if (this.componentData.requestGuestAccountEnabled) {
            let iconIds = ['reply', 'replyAll', 'replyBot', 'replySelect', 'attach', 'replyRecipients', 'replyRole'];
            this.showIcons(iconIds);
            this.hideIcons(this.allIcons.filter(e => (!iconIds.includes(e))));
          } else {
            let hideIcons = ['reply', 'replyAll', 'replySelf', 'replyBot', 'replySelect', 'replyRecipients']
            this.hideIcons(hideIcons);
            this.showIcons(this.allIcons.filter(e => (!hideIcons.includes(e))));
          }

        },
        [`shareMode/${this.componentData.messageBoxShareModes.requestLock}`]: () => {
          this.hideIcons(this.allIcons);

        }
      }
      if (typeof actions[`${this.selectedMode}/${this.messageBoxModeAllButtons[i].id}`] !== "undefined") {
        actions[`${this.selectedMode}/${this.messageBoxModeAllButtons[i].id}`]();
      } else {
        this.showIcons(this.allIcons);
      }
    },
    showIcons(iconIds) {
      iconIds.forEach(e => this.$refs.settingsRibbon.showRibbonIcon(e));
      iconIds.forEach(e => this.uiMenu.showMenuItem(e))
    },
    hideIcons(iconIds) {
      iconIds.forEach(e => this.$refs.settingsRibbon.hideRibbonIcon(e));
      iconIds.forEach(e => this.uiMenu.hideMenuItem(e));
    },

    setModeWatchers() {
      this.messageBoxModeAllButtons.forEach((e, index) => {
        e.callback = e.callback || this.toggleModeButton.bind(this);
        e['selected'] = false;
        ((i) => {
          this.unwatchFns.push(this.$watch(() => {
            return this.messageBoxModeAllButtons[i].selected;
          }, (newVal) => {
            //console.log(`watch-mainPanel.componentData.messageBoxModeButtons[${i}].selected`, 'val:', newVal);
            if (newVal) {
              /*
              if (this.ribbonMenuInitialized == 2) {
                this.messageBoxModeButtonSelected(e, i);
              } else {
                this.postMountTasks.push(() => {
                  this.messageBoxModeButtonSelected(e, i);
                });
              }

               */
            }
          }));
        })(index);
      });
    },
    initializeScheduleTable() {
      this.$refs.scheduleMenuTable.addRow({
        cols: [
          {
            html:``,
            callback: () => {
            }
          },
          {
            type: 'component',
            componentName: this.DTComponent,
            props: {title: 'Start Time', placeholder: 'Click here to select time'},

          },
          {
            html: ``,
            callback: (dataRow, index, ev) => {
            }
          }

        ],
        showCheckbox: false,
        showFolder: false,
        path: this.startTimePath,
        backgroundColor: 'white',
      });
      this.$refs.scheduleMenuTable.addRow({
        cols: [
          {
            html:``,
            callback: () => {
            }
          },
          {
            type: 'component',
            componentName: this.DTComponent,
            props: {style: 'background-color: white', title: 'End Time', placeholder: 'Click here to select time'}
          },
          {
            html:``,
            callback: (dataRow, index, ev) => {
            }
          }

        ],
        showCheckbox: false,
        showFolder: false,

        path: this.endTimePath,
        backgroundColor: 'white',
      });
      this.$refs.scheduleMenuTable.addRow({
        cols: [
          {
            html:``,
            callback: () => {
            }
          },
          {
            type: 'component',
            componentName: this.timezoneComponent,
            props: {title: 'Timezone', style: 'background-color: white'},
            styleObj: {'overflow': 'visible'}
          },
          {
            html:``,
            callback: (dataRow, index, ev) => {
            }
          }

        ],
        backgroundColor: 'white',
        showCheckbox: false,
        showFolder: false,
        selectedTimezone: '',
        path: this.timezonePath
      });
    },
    initializeAttachmentsTable() {
      let data = {name: ''};
      this.$refs.attachmentsMenuTable.setNormalView();

      this.$refs.attachmentsMenuTable.addRow({
        checkboxCol: {
          alt: {
            componentName: InputString,
            type: 'component',
            value: data.name,
            props: {
              style: 'background-color: white',
              placeholder: 'Attachment',
              value: data.name,
              parent: this.parent,
              menuTable: this.$refs.menuTable,
              messageBoxComponent: this,
              mainPanel: this.mainPanel
            },
            styleObj: {overflow: 'visible'},
            colspan: 5
          }
        },
        cols: [
          /*{
registrantId: this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
iconId: '_FFFFFFFFFFFFFF00001579202909427002_',
callback: ()=>{}
},*/
          /*{
componentName: this.simpleStringRowComponent,
type: 'component',
value: data.name,
props: { placeholder: 'Recipients', value: data.name, parent: this.parent, menuTable: this.$refs.menuTable, messageBoxComponent: this, mainPanel: this.mainPanel },
styleObj: { overflow: 'visible' },
colspan: 3
}*//*,
{
registrantId: this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
iconId: this.iconIds.blank,
callback: (dataRow, index, ev)=> {
}
}*/

        ],
        backgroundColor: 'white',
        noFolderCol: true,
        showCheckbox: false,

        data: data,
        path: this.recipientTextboxPath,
        type: this.rowTypes.string,
        show: this.componentData.showMessageBoxAttachmentsInputBox
      });
      this.$nextTick(function () {
//this.$refs.menuTable.selectRow(this.recipientTextboxPath);
        //$(this.$refs.menuTable.$refs.tableRow0).css({'overflow': 'visible'});
//this.expandRootRow(rootFolderPath);
      });
    },
    initializeRecipientsList() {
      let data = {name: ''};
      //console.log('initializeRecipientsList', 'setting normal view');
      this.$refs.menuTable.setNormalView();
      window.menuTable = this.$refs.menuTable;


      /*this.$refs.menuTable.addRow({
        checkboxCol: {
          alt: {
            componentName: InputString,
            type: 'component',
            value: data.name,
            props: this.recipientsListTextboxProps,
            styleObj: {overflow: 'visible'},
            colspan: 5
          }
        },
        cols: [

        ],
        backgroundColor: 'white',
        noFolderCol: true,
        showCheckbox: false,
//showFolder: false,
        data: data,
        path: this.recipientTextboxPath,
        type: this.rowTypes.string,
        show: this.componentData.showMessageBoxRecipientsList
      });*/
      this.$nextTick(function () {
        //this.componentData.showMessageBoxRecipientsTable = true;
//this.$refs.menuTable.selectRow(this.recipientTextboxPath);
        //$(this.$refs.menuTable.$refs.tableRow0).css({'overflow': 'visible'});
//this.expandRootRow(rootFolderPath);
      });
    },
    setTextareaEvents() {

      ['keyup', 'paste', 'input'].forEach((event)=>{
        window.addEventListener(event, ()=>{
          if(!this.currentSimpleMode && this.viewport.isInbox && !this.textareaActivityFlag) {
            this.textareaActivityFlag = true;
            let event = new CustomEvent(`${this.viewportID}-fn-call`, {
              detail: {
                fnName: 'generateReply',
                args: [ window.inboxRefs[this.viewportID].exposed.tableData.value.dataRows[0], this.$refs.textarea, this]
              }
            });
            //window.dispatchEvent(event);
            //console.log('dispatchEvent', 'sent');
          }

        })
      });

      /*
      $(this.$refs.textarea).on('input', () => {
        if(!this.currentSimpleMode) {

        }


      });

       */


    },
    async setAIChat() {
      this.mainPanel.componentData.botMode = true;
      this.mainPanel.componentData.botService = 'AIChat';

      await this.setInboxRecipient(oxygenUtil.createSimpleOES(['bot', this.client.ClientRight, 'bot', this.client.ClientRight]), {}, async (inbox)=>{
        await this.$nextTick();
        await this.$nextTick();
        oxygenUtil.callViewportFn(inbox.viewportID, 'setDialogueMode', []);
      });
    },
    async setResumeRanking() {
      this.mainPanel.componentData.botMode = true;
      this.mainPanel.componentData.botService = 'ResumeRanking';

      await this.setInboxRecipient(oxygenUtil.createSimpleOES(['bot', this.client.ClientRight, 'bot', this.client.ClientRight]));

    },
    async setLocalBot() {
      this.mainPanel.componentData.botMode = true;
      this.mainPanel.componentData.botService = 'BusinessBuddy';

      await this.setInboxRecipient(oxygenUtil.createSimpleOES(['bot', this.client.ClientRight, 'bot', this.client.ClientRight]));
    },
    async setForeignBot(componentId, reload, ConversationId, RootConversationId) {
      this.mainPanel.componentData.botMode = true;
      this.mainPanel.componentData.minimalMode = true;
      this.mainPanel.componentData.directBot = true;
      let botPE = oxygenUtil.createSimpleOES(['bot', componentId, 'bot', componentId]);
      this.mainPanel.componentData.conversationPE = botPE;
      if(reload) {
        await this.doBotReload(botPE);
      }
      else {
        await this.doForeignBotConnect(botPE, {ConversationId, RootConversationId});
      }

      await this.setInboxRecipient(botPE,
          { fn: ['setupSend' ], fnParams: [[]]});
    },
    async doForeignBotConnect(botPE, params) {
      let parsedAppPE = oxygenUtil.parseOES(botPE).segments;
      return new Promise((resolve, reject)=>{
            window.BotServices.BotConnect({ClientId: this.client.Client, ComponentId: parsedAppPE[3],
              InitialContext: Object.assign({ CredentialId: window.LivingScript_0070.context.credentialId}, params || {})}, (error)=> {
              if(!error) {
                resolve();
              }
              else {
                reject();
              }
            });
      });
    },
    async setInboxRecipient(recipientPE, eventParams, callback) {
      eventParams = eventParams || {};
      if(this.viewport.isInbox) {
        //console.log('setInboxRecipient', 'starting local flow');
        this.setMessage('');

        if(recipientPE) {
          let params = [recipientPE];

          await this.addRecipientPE(recipientPE);
        }




        //console.log('set-inbox-recipient-listener', 'detail:', ev.detail, ' - fn:', ev.detail && ev.detail.fn && this[ev.detail.fn]);
        if(Array.isArray(eventParams.fn)) {
          eventParams.fn.forEach((e,i)=>{
            if(this[e]) {
              let params = eventParams.fnParams[i] || [];
              this[e](...params);
            }
          })
        }
        if(eventParams.fn && this[eventParams.fn]) {
          this[eventParams.fn]();
        }
      }
      else {
        this.showChildViewport('showInbox');
        await this.$nextTick();
        let counter = 0;

        let intervalId = setInterval(async ()=>{
          let inbox;
          counter++;
          //console.log('setInboxRecipient', 'inbox:', inbox, ' - MessageBox:', inbox ? inbox.MessageBox : '', '- counter:', counter, ' - isTrue:', (counter > 10));
          await this.$nextTick();
          if((inbox = window.devStore.viewPorts.find(e => ((this.viewport.ClientID === e.ClientID)) && e.isInbox))   ||
              (counter > 20)) {
            clearInterval(intervalId);
            await this.$nextTick();
            if(inbox) {
              //console.log('setInboxRecipient', 'clearing interval - inbox:', inbox);

              let ev = new CustomEvent(`${inbox.viewportID}-set-inbox-recipient`, {detail: Object.assign({recipientPE}, eventParams)});
              window.dispatchEvent(ev);
              if(callback) {
                callback(inbox);
              }
            }
          }
        },200);
      }
    },
    setInitialSettings() {
//this.setReplyIcon('replyAll');
      if (!this.componentData.messageBoxStateInitialized) {
        this.$nextTick(function () {
        });
        this.componentData.messageBoxStateInitialized = true;
      }
//this.selectModeButton(this.componentData.messageBoxModeButtons.find(e => (e.id === 'send')));

    },
    setReplyWatchers() {
      //console.log('setReplyWatchers', 'called');
      Object.keys(this.componentData.replyFlags).forEach((e) => {
        ((flagName) => {
//console.log('created', 'setting watch - flagName:', flagName);
          this.$watch(`replyFlags.${flagName}`, (newVal, oldVal) => {

//console.log('watch', 'flagName:', flagName, ' - newVal:', this.componentData.replyFlags[flagName]);
            if (this.componentData.replyFlags[flagName]) {
//this.resetReplyFlags(flagName);
              this.selectReplyIcon(flagName)
            } else {
              this.unselectReplyIcon(flagName);

            }
          }, {immediate: true});
        })(e);
      });
    },
    toggleModeButton(button, noReset) {
      if (this.selectedModeButton && this.selectedModeButton !== button) {
        this.unselectModeButton(this.selectedModeButton, noReset);
      }
      this.selectModeButton(button);
    },
    selectModeButton(button) {
      button['selected'] = true;
      if (this.$refs.buttonRibbon1) {
        this.$refs.buttonRibbon1.selectButton(button);
      } else {
        this.buttonOpsQueue.push({op: 'selectButton', button});
      }

    },
    unselectModeButton(button, noReset) {
      button['selected'] = false;

      if (this.$refs.buttonRibbon1) {
        this.$refs.buttonRibbon1.unselectButton(button);
      } else {
        this.buttonOpsQueue.push({op: 'unselectButton', button});
      }

    },
    createAttachmentMenu(callback) {
      this.attachmentMenu = new ActionMenu(this.parent.Y, {
        menuTitle: 'Add Attachment(s)',
        parentPanel: this.parent,
        parent: this.mainPanel
      });
      this.parent.standardMenus['messageBoxAttachmentMenu'] = this.attachmentMenu;
      this.attachmentMenu.init(() => {
        this.attachmentMenu.addMenuItem(
            `Upload ${oxygenUtil.config.attachmentTitle}(s)`,
            () => {
              this.parent.showFileBrowserPanel({}, {}, (panel) => {
                let doCallback = () => {
                  let row;
                  if (row = panel.rightMenu.menuTable.getRow('Import Files')) {
                    row.data.callback();
                  }

                  if (panel.panel.$refs.bodyComponent &&
                      panel.panel.$refs.bodyComponent.$refs.frame &&
                      panel.panel.$refs.bodyComponent.$refs.frame.contentWindow &&
                      panel.panel.$refs.bodyComponent.$refs.frame.contentWindow.uppy) {
                    panel.panel.$refs.bodyComponent.$refs.frame.contentWindow.uppy.reset();
                  }

                  window.addEventListener('importedFileAttached', e => {

                    panel.close();
                    if (e.detail.PanelID === panel.__panelName) {
                      async.waterfall([
                        this.mainPanel.getComponent.bind(this.mainPanel, e.detail.componentId),
                        (component, callback) => {
                          this.parent.getAllComponentsRoles(
                              [
                                {
                                  id: component.Node,
                                  defaultRole: ["admin", "holder", "visitor"]
                                }
                              ],
                              [{componentId: component.Node, role: "visitor"},{componentId: component.Node, role: "admin"}],
                              ['owner'],
                              (error, allRoles) => {
                                callback(error, component, allRoles);
                              });
                        },
                        (component, allRoles, callback) => {
                          this.addValidatedPE(component, allRoles[component.Node], this.$refs.attachmentsMenuTable)
                          callback();
                        }
                      ], (error) => {
                        this.componentData.showMessageBoxAttachmentsList = true;
                      });
                    }
                  }, {once: true});
                }
                if (panel.rightMenu.menuTable) {
                  doCallback();
                } else {
                  panel.container.$on('action-menu-table-mounted', (menu) => {
                    if (menu === panel.rightMenu) {
                      doCallback();

                    }
                  });
                }
              });
            },
            true,
            null,
            {menuLevel: 1},
            '',
            false,
            {
              hideTooltips: true
            }
        );
        this.attachmentMenu.addMenuItem(
            `Select Existing ${oxygenUtil.config.attachmentTitle}(s)`,
            () => {
              this.attachClicked();
            },
            true,
            null,
            {menuLevel: 1},
            '',
            false,
            {
              hideTooltips: true
            }
        );
        callback();
      });
    },
    createActionMenu(callback) {
      this.optionsMenu = new ActionMenu(this.parent.Y, {
        menuTitle: 'Send Options',
        parentPanel: this.parent,
        parent: this.mainPanel
      });
      this.parent.standardMenus['sendOptionsMenu'] = this.optionsMenu;
      this.optionsMenu.init(() => {
        this.optionsMenu.addMenuItem(
            "Advanced",
            () => {
              this.parent.showAdvancedSendPanel(this.selectedModeButton ? this.selectedModeButton.id : 'send');
            },
            true,
            null,
            {menuLevel: 1},
            '',
            false,
            {
              hideTooltips: true
            }
        );

        if (this.mainPanel.isCredentialsAccount) {
          this.optionsMenu.addMenuItem(
              "Request Guest Account",
              () => {
                this.enableRequestGuestAccount();
              },
              true,
              null,
              {menuLevel: 1},
              '',
              false,
              {
                hideTooltips: true
              }
          );

          this.optionsMenu.addMenuItem(
              "Reset Request",
              () => {
                this.resetRequest();
              },
              true,
              null,
              {menuLevel: 1},
              '',
              false,
              {
                hideTooltips: true
              }
          );
        }

        this.optionsMenu.addMenuItem(
            "Offer Guest Account",
            () => {
              this.enableOfferGuestAccount();
            },
            true,
            null,
            {menuLevel: 1},
            '',
            false,
            {
              hideTooltips: true
            }
        );

        this.optionsMenu.addMenuItem(
            "Reset Offer",
            () => {
              this.resetOffer();
            },
            true,
            null,
            {menuLevel: 1},
            '',
            false,
            {
              hideTooltips: true
            }
        );

        this.optionsMenu.addMenuItem(
            "Save",
            () => {
              this.showSaveOptionsForMessage();
            },
            true,
            null,
            {menuLevel: 1},
            '',
            false,
            {
              hideTooltips: true
            }
        );

        this.optionsMenu.addMenuItem(
            "Create Meeting Link",
            () => {
              this.getMeetingLink();
            },
            true,
            null,
            {menuLevel: 1},
            '',
            false,
            {
              hideTooltips: true
            }
        );
        this.$nextTick(function () {
          this.optionsMenu.hideMenuItem("Request Guest Account");
          this.optionsMenu.hideMenuItem("Reset Request");
          this.optionsMenu.hideMenuItem("Offer Guest Account");
          this.optionsMenu.hideMenuItem("Reset Offer");
          if (!this.componentData.meetingLinkFetched) {
            this.optionsMenu.hideMenuItem("Create Meeting Link");
          }
          if (this.postActionMenuActions.length) {
            this.postActionMenuActions.forEach(e => {
              e();
            });
            this.postActionMenuActions.length = 0;
          }
        });
        callback();
      });
    },
    enableRequestGuestAccount() {
      this.componentData.requestGuestAccountEnabled = true;

      let iconIds = ['reply', 'replyAll', 'replyBot', 'replySelect', 'attach', 'replyRecipients', 'replyRole'];
      this.showIcons(iconIds);
      this.hideIcons(this.allIcons.filter(e => (!iconIds.includes(e))));
      this.setReplyIcon('replyRecipients');
    },
    enableOfferGuestAccount() {
      this.componentData.offerGuestAccountEnabled = true;
    },
    resetRequest() {
      this.componentData.requestGuestAccountEnabled = false;
    },
    resetOffer() {
      this.componentData.offerGuestAccountEnabled = false;
    },
    showSaveOptionsForMessage() {
      this.saveMenu.setParentLink(() => {
        this.saveMenu.hide();
        this.saveMenu.hideParentLink();
        this.optionsMenu.showAdjacent(this.$refs.settingsRibbon.getRibbonIconElement('options'), this.parent);
      });
      this.saveMenu.modifyAction("saveAsTemplate", () => {
        this.parent.showSaveAsTemplateMenu(this.getMessage(), this.$refs.settingsRibbon.getRibbonIconElement('options'), 'Template');
      });
      this.saveMenu.modifyAction("saveAsDraft", () => {
        this.parent.showSaveAsTemplateMenu(this.getMessage(), this.$refs.settingsRibbon.getRibbonIconElement('options'), 'Draft');
      });
      this.saveMenu.disableAction("saveAsFinal");

      this.saveMenu.showAdjacent(this.$refs.settingsRibbon.getRibbonIconElement('options'), this.parent);
    },
    getReplyAllRecipients(callback) {
      let recipients = new Set();
      if (this.mainPanel.grantItem.TransactionID) {
        this.mainPanel.runDBQuery(
            {
              historyDB: true,
              sql: `select * from oxygen_history.${this.mainPanel.config.db.tables.history.tableName} where RootTransactionId = ?`,
              vals: [this.mainPanel.grantItem.TransactionID]
            },
            (error, results) => {
              if (!error && results.length) {
                if (results[0].ByPE !== this.mainPanel.grantItem.GrantPE) {
                  recipients.add(results[0].ByPE);
                }
                results.forEach(e => recipients.add(e.ToPE));
              } else {
                recipients.add(this.mainPanel.grantItem.ByPE);
              }
              callback(null, [...recipients]);
            }
        )
      } else {
        callback(null, [this.mainPanel.grantItem.ByPE]);
      }
    },
    async getChatRecipientPEs() {
      let PEs = await this.getSelectedReplyFlags().reduce(async (acc, cur) => {
        //console.log('getChatRecipientPEs', 'cur:', cur, ' - recipient:', await this.getChatRecipientPE(cur));
        (await this.getChatRecipientPE(cur)).forEach((e) => {
          if (e) {
            acc.push(e);
          }
        });
        return acc;
      }, []);
      //console.log('getChatRecipientPEs', 'first-PEs:', PEs);

      let mode = {
        'sendMode': this.createDefaultReplyRecipientsEnvelope.bind(this),
        'shareMode': this.createDefaultReplyRecipientsEnvelope.bind(this),
        'contactsMode': this.createDefaultReplyRecipientsEnvelope.bind(this),
        'promiseMode': this.createDefaultReplyRecipientsEnvelope.bind(this),
        'homepageAssignMode': this.createDefaultReplyRecipientsEnvelope.bind(this),
        'agreementMode': this.createDefaultReplyRecipientsEnvelope.bind(this)
      }

      let addPEs = await mode[this.lastParentMode]();
      //console.log('getChatRecipientPEs', 'addPEs:', addPEs);
      return PEs.concat(addPEs);
    },
    async getChatRecipientPE(replyFlag) {
      let parsedPE = oxygenUtil.parseOES(this.contextPE).segments;
      let flag = {
        'reply': () => {
          return [this.mainPanel.grantItem.ByPE];
        },
        'replyAll': () => {
//return this.replyAllRecipients;
          return [oxygenUtil.createSimpleOES(['*', parsedPE[3], '*', parsedPE[3]])];
        },
        'replySelf': () => {
          return [this.contextPE];
        },
        'replyRole': () => {
          let role = this.getSelectedRole();
          return [oxygenUtil.createSimpleOES([role, parsedPE[3], role, parsedPE[3]])];
        },
        'replyBot': () => {

          return [oxygenUtil.createSimpleOES(["bot", parsedPE[1], parsedPE[2], parsedPE[3]])];
        },
        'replySelect': () => {
          return this.parent.getSelectedChatRecipients();
        },
        'replyRecipients': async () => {
          let mode = {
            'sendMode': this.createDefaultReplyRecipientsEnvelope.bind(this),
            'shareMode': this.createDefaultReplyRecipientsEnvelope.bind(this),
            'contactsMode': this.createDefaultReplyRecipientsEnvelope.bind(this),
            'meetingMode': this.createMeetingModeReplyRecipientsEvenlope.bind(this),
            'promiseMode': this.createMeetingModeReplyRecipientsEvenlope.bind(this),
            'homepageAssignMode':  this.createDefaultReplyRecipientsEnvelope.bind(this),
          }
          return await mode[this.selectedMode]();
        }
      }
      return await flag[replyFlag]();
    },
    getDetailsInfo(dataRow) {
      if ((dataRow.type === this.rowTypes.email) || (dataRow.type === this.rowTypes.phone)) {
        return {
          PE: dataRow.data.PE,
          roles: dataRow.roles,
          subjectOnly: true,
          dataRow
        }
      }
      else if(dataRow.type === this.rowTypes.attachment) {
        let selectedRole = dataRow.roles.find(e => e.selected).role;
        return {
          PE: oxygenUtil.createSimpleOES([selectedRole, dataRow.data.component.Node, selectedRole, dataRow.data.component.Node]),
          roles: dataRow.roles,
          subjectOnly: true,
          dataRow
        };
      }
      else if (dataRow.type === this.rowTypes.PE){
        return {
          PE: dataRow.data.PE,
          dataRow,
          roles: dataRow.roles
        };
      }
    },
    createMeetingModeReplyRecipientsEvenlope() {
      let reply = {
        email: [], phone: [], tope: []
      };
      this.$refs.menuTable.tableData.dataRows.forEach((e) => {
        if (e.type === this.rowTypes.email) {
          reply.email.push(e.data.emailAddress);
        } else if (e.type === this.rowTypes.phone) {
          reply.phone.push(e.data.phoneNumber);
        } else if (e.type === this.rowTypes.PE) {
          reply.tope.push(e.data.PE);
        } else if (e.type !== this.rowTypes.string) {

          let selectedRole = e.roles.find(e => e.selected).role
          reply.tope.push(oxygenUtil.createSimpleOES([selectedRole, e.data.component.Node, selectedRole, e.data.component.Node]));
        }
      });
      return reply;
    },
    async addMeetingModeRecipients() {
      let client = window.botStore.getClientByID(this.ClientID);
      //console.log('addMeetingModeRecipients', 'client:', client);
      let meetingContext = JSON.parse(client.MeetingContext);
      //console.log('addMeetingModeRecipients', 'context:', meetingContext);
      let meetingPE = oxygenUtil.createSimpleOES(['meeting', meetingContext.MeetingParentId, 'meeting', meetingContext.MeetingParentId]);
      //console.log('addMeetingModeRecipients', 'PE:', meetingPE);
      await this.addRecipientPE(meetingPE);

    },
    async recipientsAdded() {
      return new Promise((resolve)=>{
        let intervalId = window.setInterval(()=>{
          console.log('recipientsAdded', 'length:', this.$refs.menuTable.tableData.dataRows.length);
          if(this.$refs.menuTable.tableData.dataRows.length) {
            clearInterval(intervalId);
            resolve();
          }
        },100);
      })
    },
    async createDefaultReplyRecipientsEnvelope() {
      let subjectInfo = this.getSubjectInfo();
      //console.log('createDefaultReplyRecipientsEnvelope', 'clientContactsMode:', this.mainPanel.componentData.clientContactsMode);
      //if(this.mainPanel.componentData.clientContactsMode === 'meeting') {
      //  await this.addMeetingModeRecipients();
      //}
      if(this.mainPanel.componentData.clientContactsMode === 'meeting') {
        this.addMeetingRecipients();
        await this.recipientsAdded();
        //console.log('createDefaultReplyRecipientsEnvelope', 'length:', this.$refs.menuTable.tableData.dataRows.length);
        //console.log('createDefaultReplyRecipientsEnvelope', 'rows:', this.$refs.menuTable.tableData.dataRows);
        //window.__messageBox = this;
      }

      let bccRows = this.$refs.menuTable.tableData.dataRows.filter(e => e.bccFlag);

      return this.$refs.menuTable.tableData.dataRows.filter(e => (e.type !== this.rowTypes.string) && (e.bccFlag !== true)).map((e) => {
        console.log('getChatRecipientPE', 'selectedRow:', e);
        if ((e.type === this.rowTypes.email) || (e.type === this.rowTypes.phone)) {
          let envelope = Object.assign({
                fromPE: this.mainPanel.GatewayPE,
                fromGrantId: this.mainPanel.GatewayGrantId,
                byPE: this.envelopeByPE || this.contextPE,
                byGrantId: this.componentData.contextPEGrant.GrantID,
                TransactionID: this.lastTransactionId
              }, (this.geolocation && this.geolocation.location) ?
                  {
                    Latitude: this.geolocation.location.latitude,
                    Longitude: this.geolocation.location.longitude,
                  } : {}
          );

          let parsedPE = oxygenUtil.parseOES(e.data.PE).segments,
              roleObj,
              selectedRole = ( (roleObj = e.roles.find(e => e.selected)) && roleObj.role) || 'admin',
              parsedCurrentPE = oxygenUtil.parseOES(this.contextPE).segments,
              scheduleTimes;
          //console.log('getChatRecipientPE', 'selectedRole:', selectedRole);
          if (this.isScheduleSet()) {
            scheduleTimes = this.getScheduleTimes();
          }

          if (e.type === this.rowTypes.email) {
            this.emailMessages.push(Object.assign({
              bccEmails: bccRows.map(e => e.data.emailAddress),
              threadRole: parsedCurrentPE[0],
              threadId: parsedCurrentPE[1],
              subjectRole: parsedCurrentPE[2],
              subjectId: parsedCurrentPE[3],
              subject: this.mainPanel.atComponent.DisplayName,
              emailRow: e,
              envelope,
              fullMessage: (this.componentData.currentForwardedMessage &&  !Array.isArray(this.componentData.currentForwardedMessage))? this.createForwardedMessage(true) : this.getFullMessage(),
              noteMessage: this.getMessage(),
              htmlBodyTip: this.htmlBodyTip/*,
              domain: this.supportDomain*/
            }, scheduleTimes ? {scheduleTimes} : {}));
          } else {
            this.phoneMessages.push({
              threadRole: parsedCurrentPE[0],
              threadId: parsedCurrentPE[1],
              subjectRole: parsedCurrentPE[2],
              subjectId: parsedCurrentPE[3],
              subject: this.mainPanel.atComponent.DisplayName,
              phoneRow: e,
              envelope,
              fullMessage: this.getFullMessage(),
              noteMessage: this.getMessage(),
              htmlBodyTip: this.htmlBodyTip
            });
          }
          let returnObj = {
            row: e, emailRow: (e.type === this.rowTypes.email), phoneRow: (e.type === this.rowTypes.phone),
          }
          if (selectedRole === "admin") {
            return Object.assign(returnObj, {data: {PE: oxygenUtil.createSimpleOES([parsedPE[0], parsedPE[1],
                  (subjectInfo && subjectInfo.subjectRole) || parsedPE[0], (subjectInfo && subjectInfo.subjectId) || parsedPE[1]])}});
          } else if (selectedRole === "holder") {
            //return Object.assign(returnObj, {data: {PE: oxygenUtil.createSimpleOES([parsedPE[2], parsedPE[3], parsedPE[2], parsedPE[3]])}});
            return Object.assign(returnObj, {data: (subjectInfo && { PE: oxygenUtil.createSimpleOES([parsedPE[0], parsedPE[1],
                      (subjectInfo && subjectInfo.subjectRole) || parsedPE[2], (subjectInfo && subjectInfo.subjectId) || parsedPE[3]]) }) ||
                  {PE: e.data.PE}});
          }
          else {
            return Object.assign(returnObj, {data: (subjectInfo && { PE: oxygenUtil.createSimpleOES([parsedPE[0], parsedPE[1],
                      (subjectInfo && subjectInfo.subjectRole) || parsedPE[2], (subjectInfo && subjectInfo.subjectId) || parsedPE[3]]) }) ||
                  {PE: e.data.PE}});
          }

        }
        else if (e.type === this.rowTypes.attachment) {
          let selectedRole = e.roles.find(e => e.selected).role;
          e.data.PE = oxygenUtil.createSimpleOES([
            selectedRole,
            e.data.component.Node,
            (subjectInfo && subjectInfo.subjectRole) || selectedRole,
            (subjectInfo && subjectInfo.subjectId) || e.data.component.Node
          ]);
          return e;
        } else if (e.type === this.rowTypes.PE) {
          let parsedPE = oxygenUtil.parseOES(e.data.PE).segments;
          //if (e.isInbox) {
            e.data.PE = oxygenUtil.createSimpleOES([parsedPE[0], parsedPE[1],
                (subjectInfo && subjectInfo.subjectRole) || parsedPE[2], (subjectInfo && subjectInfo.subjectId) || parsedPE[3]]);
            return e;
            //return e;
          //}
          //return ({ PE: oxygenUtil.createSimpleOES([parsedPE[0], parsedPE[1],
          //    (subjectInfo && subjectInfo.subjectRole) || parsedPE[2], (subjectInfo && subjectInfo.subjectId) || parsedPE[3]]) });
        }
      });
    },
    getTimezoneOffset() {
      let timezoneOffset = '', timezone;
      if (timezone = this.$refs.scheduleMenuTable.getRowAlt(this.timezonePath).selectedTimezone) {
        timezoneOffset = `${parseInt(timezone.offset)}`;
        let fractionalOffset;
        if (fractionalOffset = (timezone.offset % 1)) {
          if (fractionalOffset === 0.5) {
            timezoneOffset += ":30"
          } else if (fractionalOffset === 0.75) {
            timezoneOffset += ":45";
          }
        } else {
          timezoneOffset += ":00"
        }
      }
      return timezoneOffset
    },
    doScheduledOffer(PE, transactionId, callback) {
      let historyRow;
      if (typeof PE === "object") {
        historyRow = PE;
        PE = PE.data.PE;
      }
//let onObject = this.getMessageAttachment() ? this.getMessageAttachment().data.GrantRightID : this.mainPanel.atComponent.Node;
//let onRole = this.getMessageAttachment() ? this.getMessageAttachment().roles.find(e => e.selected).role : this.mainPanel.config.roles.visitor;
      let permissionsArray = this.getMessageAttachment() ? this.getMessageAttachment().map(e => ({
            onObject: e.data.GrantRightID || (e.data.component.Node),
            onRole: e.roles.find(i => i.selected).role
          })) :
          [{onObject: this.mainPanel.atComponent.Node, onRole: this.mainPanel.config.roles.visitor}];

      async.each(permissionsArray, (permission, callback) => {
        this.mainPanel.putOfferGrant(Object.assign({
          onObject: permission.onObject,
          onRole: permission.onRole,
          toPE: PE,
          fromPE: this.mainPanel.GatewayPE,
          fromGrantId: this.mainPanel.GatewayGrantId,
          byPE: this.envelopeByPE || this.contextPE,
          byGrantId: this.componentData.contextPEGrant.GrantID,
          Note: {
            String: this.getMessage(),
            Link: ""
          },
          TransactionID: transactionId
        }, (this.geolocation && this.geolocation.location) ? {
          Latitude: this.geolocation.location.latitude,
          Longitude: this.geolocation.location.longitude
        } : {}, this.getScheduleTimes()), callback);

      }, callback);
    },
    doAlert(PE, transactionId, callback) {

    },
    getScheduleTimes() {
      return {
        T1: this.startTime,
        T2: this.endTime
      }
    },
    getScheduleTimesOld() {
      let timezoneOffset = this.getTimezoneOffset();
      return {
        T1: (new Date(this.$refs.scheduleMenuTable.getRowAlt(this.startTimePath).dateTime + timezoneOffset)).toISOString(),
        T2: (new Date(this.$refs.scheduleMenuTable.getRowAlt(this.endTimePath).dateTime + timezoneOffset)).toISOString()
      };
    },
    async doGrant(PE, transactionId, ...args) {
      //console.log('doGrant', 'PE:', PE);
      //let callback = args[args.length - 1], attachments, selectedMode;
      let attachments, selectedMode, addSubAccount;
      if (args.length > 1) {
        attachments = args[0];
      }
      if (args.length > 2) {
        selectedMode = args[1];
      }
      if (args.length > 3) {
        addSubAccount = args[1];
      }
      console.log('doGrant', 'addSubAccount:', addSubAccount);


      let normalGrants = {
        'offer': "putOfferGrant",
        'send': "putOfferGrant",
        'email': "putOfferGrant",
        'sms': "putOfferGrant",
        'share': "putGrant",
        'forward': 'putOfferGrant',
        'bot': 'putOfferGrant',
        'offer_task': "putOfferGrant",
        'request_task': "putRequestGrant"
      };
      selectedMode = selectedMode || (this.currentSimpleMode === 'invite') ? this.currentSimpleMode : this.selectedModeButton.id;

      let scheduleTimes = this.isScheduleSet() ? this.getScheduleTimes() : {};
      if (Object.keys(normalGrants).includes(selectedMode)) {
        let permissionsArray = attachments || this.getMessageAttachment().map((e) => {
          if (e.isTemplateAttachment) {
            return {
              isTemplateAttachment: true,
              templateRow: e
            }
          } else {
            return {
              onObject: e.data.GrantRightID || (e.data.component.Node),
              onRole: e.roles.find(i => i.selected).role,
              Preference: e.Preference,
              addSubAccount: e.addSubAccount,
              row: e
            }
          }
        });
        await async.each(permissionsArray, async (permission) => {
          console.log('doGrant', 'permission:', permission);
          if (permission.isTemplateAttachment) {
            this.mainPanel.doTemplateAttachmentGrant({
              grantFn: normalGrants[selectedMode],
              threadId: this.mainPanel.atComponent.Node,
              threadRole: this.parent.parseOES(this.mainPanel.GrantPE).segments[2],
              templateFFTTPrefix: this.parent.createSimplePartialOES(this.parent.parseOES(permission.templateRow.originalDataRow.leafRow.OES).segments.slice(0, -1)),
              selectedAction: permission.templateRow.selectedAction,
              selectedResult: permission.templateRow.selectedResult,
              selectedState: permission.templateRow.selectedState,
              envelope: Object.assign({
                toPE: PE,
                fromPE: this.mainPanel.GatewayPE,
                fromGrantId: this.mainPanel.GatewayGrantId,
                byPE: this.envelopeByPE || this.contextPE,
                byGrantId: this.componentData.contextPEGrant.GrantID,
                Note: {
                  String: this.getMessage(),
                  Link: ""
                },
                TransactionID: transactionId
              }, (this.geolocation && this.geolocation.location) ? {
                Latitude: this.geolocation.location.latitude,
                Longitude: this.geolocation.location.longitude
              } : {}, scheduleTimes)
            });
          } else {
            //console.log('doGrant', 'creating grants', ' selectedMode:', selectedMode);
            if(selectedMode === 'request_task') {
              PE = oxygenUtil.createSimpleOES(['admin', permission.onObject, 'admin', permission.onObject]);
            }
            let grant = await oxygenUtil[normalGrants[selectedMode]](Object.assign({
              onObject: permission.onObject,
              onRole: permission.onRole,
              toPE: PE,
              fromPE: this.mainPanel.GatewayPE,
              fromGrantId: this.mainPanel.GatewayGrantId,
              byPE: this.envelopeByPE || this.contextPE,
              byGrantId: this.componentData.contextPEGrant.GrantID,
              Note: {
                String: this.getMessage(),
                Link: ""
              },
              TransactionID: transactionId,
                  SessionId: oxygenUtil.Cookies.get('sessionId')
            }, this.getLocationData(), scheduleTimes,
            permission.Preference ? { Preference: permission.Preference} : {},
                permission.row.smartLinkFlag ? { ArgJSON: { smartLinkFlag: true } } : {}
            ) );
            //console.log('doGrant', 'grant:', grant);

            if(permission.addSubAccount) {
              await this.createSubAccountAttribution(grant);
            }
            return grant;
          }
        });

      } else if (selectedMode === this.componentData.messageBoxShareModes.request) {
        let parsedRolePE = oxygenUtil.parseOES(PE).segments;
        let permissionsArray = this.getMessageAttachment() ? this.getMessageAttachment().map(e => ({
              onObject: e.data.GrantRightID || (e.data.component.Node),
              onRole: e.roles.find(i => i.selected).role
            })) :
            [{
              onObject: parsedRolePE[3],
              onRole: parsedRolePE[2]
            }];


        await async.each(permissionsArray, async (permission) => {
          let toPE = this.componentData.requestGuestAccountEnabled ? PE :
              oxygenUtil.createSimpleOES(["admin", permission.onObject, "admin", permission.onObject]);

          let parsedPE = oxygenUtil.parseOES(this.contextPE).segments;
          return await oxygenUtil.putRequestGrant(Object.assign({
                onObject: permission.onObject,
                onRole: permission.onRole,
                toPE,
                fromPE: this.mainPanel.GatewayPE,
                fromGrantId: this.mainPanel.GatewayGrantId,
                byPE: this.envelopeByPE || this.contextPE,
                byGrantId: this.componentData.contextPEGrant.GrantID,
                Note: {
                  String: this.getMessage(),
                  Link: ""
                },
                TransactionID: transactionId,
                SessionId: oxygenUtil.Cookies.get('sessionId')
              }, this.getLocationData(), scheduleTimes,
              this.componentData.requestGuestAccountEnabled ? {ArgJSON: {GuestAccountRequest: true}} : {}));
        });
      }
    },
     async createSubAccountAttribution (grant) {
      let parsedGrantPE = oxygenUtil.parseOES(grant.GrantPE).segments;
      let credentialId = parsedGrantPE[1];

      await oxygenUtil.callCommonServiceAPI('attribution', 'add', {
        AccountType: 'AgentAccount',
        CredentialPE: oxygenUtil.createSimpleOES(['owner', '_FFFFFFFFFFFFFF00001567790434071286_', 'owner', credentialId]),
        GatewayPE: grant.GrantPE,
        AgentOfPE: grant.FromPE
      });


       /*
       await oxygenUtil.callCommonServiceAPI('attribution', 'addGuestAttribution', {
         GatewayPE: grant.GrantPE,
         AgentOfPE: grant.FromPE
       });

        */
  },
  meetingModeCommit() {
//{to : {tope : [], componentid : [], email : [], phone : []}, thread : , subject : , message :, mode :  }

      let params = {
        ClientID: this.ClientID || 'test-id',
        to: {
          tope: [],
          componentid: [],
          email: [],
          phone: []
        },
        thread: this.componentData.asComponent.Node,
        subject: this.componentData.atComponent.Node,
        message: this.getMessage(),
        bype: this.envelopeByPE,
        schedule: {
          start: '',
          end: ''
        },
        mode: ((this.currentSimpleMode === 'invite') || (this.currentSimpleMode === 'page') || (this.currentSimpleMode === 'meet') || (this.currentSimpleMode === 'promise')) ? this.currentSimpleMode : this.selectedModeButton.id
      }
    if (this.isScheduleSet()) {
      let scheduleTimes = this.getScheduleTimes();

      params.start = scheduleTimes.T1;
      params.end = scheduleTimes.T2;
    }

      //console.log('meetingModeCommit', 'getSelectedReplyFlags:', this.getSelectedReplyFlags());
      this.getSelectedReplyFlags().forEach((replyFlag) => {
        //console.log('meetingModeCommit', 'replyFlag:', replyFlag, ' - getChatRecipientPE:', this.getChatRecipientPE(replyFlag));
        params.to.tope.push(...this.getChatRecipientPE(replyFlag).map(e => ((typeof e === "object") ? e.data.PE : e)));
      });

      let selectedRecipients = this.createMeetingModeReplyRecipientsEvenlope();
      Object.keys(selectedRecipients).forEach((e) => {
        let historyRow;
        if (typeof e === "object") {
          historyRow = e;

          if (!this.componentData.eventSubjectText) {
            if (historyRow && historyRow.originalDataRow.data.EventPath) {
              params.EventPath = historyRow.originalDataRow.data.EventPath;
            }


          } else {
            if (historyRow && historyRow.originalDataRow.data.EventPath) {
              params.EventPath = `${historyRow.originalDataRow.data.EventPath} / `;
            }
            params.EventPath = `${EventPath}${this.componentData.eventSubjectText}`;
          }
          e = e.data.PE;
        }
        //console.log('meetingModeCommit', 'selectedRecipients[e]:', selectedRecipients, ' - e:', e);
        params.to[e].push(...selectedRecipients[e]);
      });

      let subjectRowArray = this.$refs.subjectMenuTable.tableData.dataRows.filter(e => (e.type !== this.rowTypes.string));
      if(subjectRowArray.length) {
        let subjectRow = subjectRowArray[0];


        if((subjectRow.type === this.rowTypes.email) || (subjectRow.type === this.rowTypes.phone)) {
          let parsedPE = oxygenUtil.parseOES(e.data.PE).segments;
          params.subjectId = parsedPE[3];
          params.subjectRole = parsedPE[2];
        }
        else if (subjectRow.type === this.rowTypes.attachment) {
          params.subjectId = subjectRow.data.component.Node;
          params.subjectRole = subjectRow.roles.find(e => e.selected).role;
        }
      }

      //console.log('meetingModeCommit', 'params:', params);
      if(window.BotServices && window.BotServices.callManagerExec) {
        window.BotServices.callManagerExec(params, () => {
          //console.log('meetingModeCommit', 'callback - resetting now');
          this.resetMessageBox();
          this.componentData.showMeetingLinkOptionFlag = true;
//this.$refs.settingsRibbon.showRibbonIcon('meeting_link');
//this.disableMeetingButtons();
        });
      }
      else {
        this.resetMessageBox();
        this.componentData.showMeetingLinkOptionFlag = true;
      }


    },
    async actionButtonClick() {
      if(!( await this.checkForInput(
          this.$refs.textarea.$el.value,
          this.$refs.textarea.$el.dataset.awesompleteVal,
          async () => {
            await this.$nextTick();
            await this.$nextTick();
            this.$refs.textarea.$el.value = '';
            this.mainPanel.componentData.messageBoxText = '';
          },
          this.$refs.initialInput.$el.dataset.awesompleteRole && this.$refs.initialInput.$el.dataset.awesompleteRole.split(",")
      ))) {
        this.sendClicked();
      }

    },
    getSubjectInfo() {
      let subjectRowArray = this.$refs.subjectMenuTable.tableData.dataRows.filter(e => (e.type !== this.rowTypes.string))

      if(subjectRowArray.length) {
        let subjectRow = subjectRowArray[0], subjectId = '', subjectRole = '';


        if((subjectRow.type === this.rowTypes.email) || (subjectRow.type === this.rowTypes.phone)) {
          let parsedPE = oxygenUtil.parseOES(e.data.PE).segments;
          let selectedRole = subjectRow.roles.find(e => e.selected).role;
          subjectId = parsedPE[3];
          if(['admin','holder'].includes(selectedRole)) {
            subjectRole = parsedPE[2];
          }
          else {
            subjectRole = selectedRole;
          }
        }
        else if (subjectRow.type === this.rowTypes.attachment) {
          subjectId = subjectRow.data.component.Node;
          subjectRole = subjectRow.roles.find(e => e.selected).role;
        }
        return { subjectId, subjectRole };
      }
      return null;
    },
    async sendClicked() {
      this.lastTransactionId = oxygenUtil.getGUID();
      let mode = {
        'sendMode': this.sendModeCommit.bind(this),
        'shareMode': this.shareModeCommit.bind(this),
        'meetingMode': this.meetingModeCommit.bind(this),
        'contactsMode': this.contactsModeCommit.bind(this),
        'promiseMode': this.promiseModeCommit.bind(this),
        'homepageAssignMode': this.assignHomepageCommit.bind(this),
        'agreementMode': this.agreementModeCommit.bind(this)
      }
      await mode[this.selectedMode]();
      this.$emit('sendClicked');
    },
    async contactsModeCommit() {
      let PEs = await this.getChatRecipientPEs();
      if (this.selectedModeButton.id === 'offer_contact') {
        this.offerContact(PEs);
      } else if (this.selectedModeButton.id === 'share_contact') {
        this.shareContact(PEs);
      } else if (this.selectedModeButton.id === 'request_contact') {
        this.requestContact(PEs);
      }
    },
    scheduleDataChanged(val) {
      this.startTime = val;
      let endDate = new Date(val);
      endDate.setHours(endDate.getHours() + 1);
      this.endTime = endDate.toISOString();
    },
    isScheduleSet() {
      return this.startTime && this.endTime;
    },
    isScheduleSetOld() {
      let startRow, endRow;
      return (this.componentData.showMessageBoxSchedule &&
          (startRow = this.$refs.scheduleMenuTable.getRowAlt(this.startTimePath)) &&
          startRow.dateTime &&
          (endRow = this.$refs.scheduleMenuTable.getRowAlt(this.endTimePath)) &&
          endRow.dateTime);
    },
    offerContact(PEs) {
      async.each(PEs, (PE, callback) => {
        let historyRow;
        if (typeof PE === "object") {
          historyRow = PE;
          PE = PE.data.PE;
        }

        async.waterfall([

          async () => {

            let BeginTime, EndTime;
            if (this.isScheduleSet()) {
              let scheduleTimes = this.getScheduleTimes();

              BeginTime = scheduleTimes.T1;
              EndTime = scheduleTimes.T2;
            }


            let parsedContextPE = oxygenUtil.parseOES(this.contextPE).segments;

            let historyItem = await this.postHistoryMessage(Object.assign({
                  PK: oxygenUtil.getGUID(),
                  FromPE: this.mainPanel.GatewayPE,
                  CredentialPE: this.CredentialPE,
                  AgentOfPE: this.mainPanel.AgentOfPE,
                  GatewayPE: this.mainPanel.GatewayPE,
                  //TransactionId: this.lastTransactionId,
                  ByPE: this.envelopeByPE,
                  AttributionId: this.attributionRecord.ID,

                  EventTemplate: "_FF07213418413620210218002544809000_",

                  ToPE:PE,
                  EventLabel: 'Offer Contact',

                  NoteTemplate: "MessageNoteTemplate-0056",
                  NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
                  SessionId: oxygenUtil.Cookies.get('sessionId'),
                Note: JSON.stringify({
                  String: this.getMessage(),
                  Link: "",
                  LinkMeta: "ComplexAlert",
                  LinkData: {
                    params: {
                      alertButtons: ["Accept", "Deny"],
                      callbacks: {
                        "Accept": {
                          serverNodeId: oxygenUtil.appId,
                          containerId: window.LivingScript_0070.globalContext.serverId,
                          callbackFn: "putGrant",

                          callbackFnData: Object.assign({
                            onObject: parsedContextPE[3],
                            onRole: 'contact',

                            toPE: PE,
                            fromPE: this.mainPanel.GatewayPE,
                            fromGrantId: this.mainPanel.GatewayGrantId,
                            byPE: this.envelopeByPE || this.contextPE,
                            byGrantId: this.componentData.contextPEGrant.GrantID,
                            Note: {
                              String: this.getMessage(),
                              Link: ""
                            }
                          }, (this.geolocation && this.geolocation.location) ? {
                            Latitude: this.geolocation.location.latitude,
                            Longitude: this.geolocation.location.longitude
                          } : {})
                        },
                        "Deny": {}
                      }
                    }
                  }
                })
                }, (BeginTime ? {BeginTime, EndTime} : {}),
                this.getLocationData() ));
          }
        ], callback);
      }, () => {
        this.resetMessageBox();
      });
    },
    shareContact(PEs) {
      async.each(PEs, (PE, callback) => {
        let historyRow;
        if (typeof PE === "object") {
          historyRow = PE;
          PE = PE.data.PE;
        }

        let parsedCurrentPE = this.parent.parseOES(this.contextPE).segments;
        let parsedPE = this.parent.parseOES(PE).segments;
        this.mainPanel.putGrant(Object.assign({
          onObject: parsedPE[3],
          onRole: parsedPE[2],
//toPE: oxygenUtil.createSimpleOES([parsedCurrentPE[2], parsedCurrentPE[3], parsedPE[0], parsedPE[1]]),
          toPE: this.contextPE,
          fromPE: this.mainPanel.GatewayPE,
          fromGrantId: this.mainPanel.GatewayGrantId,
          byPE: this.envelopeByPE || this.contextPE,
          byGrantId: this.componentData.contextPEGrant.GrantID,
          Note: {
            String: this.getMessage(),
            Link: ""
          }
        }, (this.geolocation && this.geolocation.location) ? {
          Latitude: this.geolocation.location.latitude,
          Longitude: this.geolocation.location.longitude
        } : {}), callback);
      }, () => {
        this.resetMessageBox();
      });
    },
    requestContact(PEs) {
      async.each(PEs, (PE, callback) => {
        let historyRow;
        if (typeof PE === "object") {
          historyRow = PE;
          PE = PE.data.PE;
        }

        let parsedPE = oxygenUtil.parseOES(PE).segments;

        async.waterfall([
          async () => {
            let BeginTime, EndTime;
            if (this.isScheduleSet()) {
              let scheduleTimes = this.getScheduleTimes();

              BeginTime = scheduleTimes.T1;
              EndTime = scheduleTimes.T2;
            }


            let parsedContextPE = oxygenUtil.parseOES(this.contextPE).segments;

            let historyItem = await this.postHistoryMessage(Object.assign({
                  PK: oxygenUtil.getGUID(),
                  FromPE: this.mainPanel.GatewayPE,
                  CredentialPE: this.CredentialPE,
                  AgentOfPE: this.mainPanel.AgentOfPE,
                  GatewayPE: this.mainPanel.GatewayPE,
                  //TransactionId: this.lastTransactionId,
                  ByPE: this.envelopeByPE,
                  AttributionId: this.attributionRecord.ID,

                  EventTemplate: "_FFFFFFFFFFFFFF00001615744024145766_",

                  ToPE:PE,
                  EventLabel: 'Request Contact',

                  NoteTemplate: "MessageNoteTemplate-0056",
                  NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
                  SessionId: oxygenUtil.Cookies.get('sessionId'),
                  Note: JSON.stringify({
                    String: this.getMessage(),
                    Link: "",
                    LinkMeta: "ComplexAlert",
                    LinkData: {
                      params: {
                        alertButtons: ["Accept", "Deny"],
                        callbacks: {
                          "Accept": {
                            serverNodeId: oxygenUtil.appId,
                            containerId: window.LivingScript_0070.globalContext.serverId,
                            callbackFn: "putGrant",

                            callbackFnData: Object.assign({
                              onObject: parsedPE[3],
                              onRole: 'contact',
                              toPE: this.contextPE,
                              fromPE: this.mainPanel.GatewayPE,
                              fromGrantId: this.mainPanel.GatewayGrantId,
                              byPE: this.envelopeByPE || this.contextPE,
                              byGrantId: this.componentData.contextPEGrant.GrantID,
                              Note: {
                                String: this.getMessage(),
                                Link: ""
                              }
                            }, (this.geolocation && this.geolocation.location) ? {
                              Latitude: this.geolocation.location.latitude,
                              Longitude: this.geolocation.location.longitude
                            } : {})
                          },
                          "Deny": {}
                        }
                      }
                    }
                  })
                }, (BeginTime ? {BeginTime, EndTime} : {}),
                this.getLocationData() ));
          }
        ], callback);
      }, () => {
        this.resetMessageBox();
      });
    },
    requestContactOld(PEs) {
      async.each(PEs, (PE, callback) => {
        let historyRow;
        if (typeof PE === "object") {
          historyRow = PE;
          PE = PE.data.PE;
        }
        //console.log('requestContact', 'contextPE:', this.contextPE);
        let parsedCurrentPE = oxygenUtil.parseOES(this.contextPE).segments;
        //console.log('requestContact', 'parsedCurrentPE:', parsedCurrentPE);
        //let parsedPE = oxygenUtil.parseOES(PE).segments;
        async.waterfall([
          async () => {
            //console.log('requestContact', 'PE:', PE);
            return await oxygenUtil.getGrantFromPE(PE);
          },
          async (grantItem) => {
            //console.log('requestContact', 'grantItem:', grantItem);
            //console.log('requestContact', 'parsedCurrentPE:', parsedCurrentPE);
            //console.log('requestContact', 'toPE:', this.envelopeByPE || this.contextPE);
            //console.log('requestContact', 'fromPE:', this.mainPanel.GatewayPE);
            //console.log('requestContact', 'fromGrantId:', this.mainPanel.GatewayGrantId);

            let requestGrant = await oxygenUtil.putRequestGrant(Object.assign({
              onObject: parsedCurrentPE[3],
              onRole: parsedCurrentPE[2],
              toPE: this.envelopeByPE || this.contextPE,
              fromPE: this.mainPanel.GatewayPE,
              fromGrantId: this.mainPanel.GatewayGrantId,
              byPE: PE,
              byGrantId: grantItem.GrantID,
              Note: {
                String: this.getMessage(),
                Link: ""
              },
              ArgJSON: {
                EventTemplate: "_FFFFFFFFFFFFFF00001615744024145766_"
              }
            }, ( this.geolocation && this.geolocation.location) ? {
              Latitude: this.geolocation.location.latitude,
              Longitude: this.geolocation.location.longitude,
            } : {}));
            //console.log('requestContact', 'requestGrant:', requestGrant);

          }
        ], callback);
      }, () => {
        this.resetMessageBox();
      });
    },
    createGrantIfNeeded(PE, toPE, onRole, onObject, callback) {
      this.mainPanel.getGrantFromPE(PE, (error, grantItem) => {
        if (error) {
          return callback(error);
        }
        if (grantItem && !$.isEmptyObject(grantItem)) {
          return callback();
        }
        this.mainPanel.putGrant({
          onObject,
          onRole,
          toPE,
          fromPE: this.mainPanel.GatewayPE,
          fromGrantId: this.mainPanel.GatewayGrantId,
          byPE: this.envelopeByPE || this.contextPE,
          byGrantId: this.componentData.contextPEGrant.GrantID
        }, callback);
      });
    },
    async promiseModeCommit() {
      //console.log('promiseModeCommit', 'client:', this.client);
      if(!this.attributionRecord && this.client.Attribution) {
        this.attributionRecord = await oxygenUtil.getAttributionRecord(this.client.Attribution);
      }

      async.waterfall([
        (callback) => {
          // if (this.bodyComponentProps.component) {
          if(this.showBodyComponent) {
            this.saveBodyComponent(callback)
          } else {
            callback();
          }
        },
        async () => {
          let PEs = await this.getChatRecipientPEs();

          //console.log('promiseModeCommit', 'List of PEs: ', PEs);
//this.mainPanel.TypingChatEvent({data: this.getMessage()});

          let BeginTime, EndTime;
          if (this.isScheduleSet()) {
            let scheduleTimes = this.getScheduleTimes();

            BeginTime = scheduleTimes.T1;
            EndTime = scheduleTimes.T2;
          }

          let insertIds = new Map();
          async.each(PEs, (PE, callback) => {
//if(this.isScheduleSet() &&  this.getMessageAttachment()) {
//    this.doScheduledOffer(PE, this.lastTransactionId, callback);
//}
//else {
            let historyRow, emailRow, phoneRow, EventPath = '', newEventSubject = '', mainRow, sellerEmail, sellerPhoneNumber;

            let isHistoryRow = false;
            async.series([
              (callback) => {
                if (typeof PE === "object") {
                  isHistoryRow = (PE.row && PE.row.fromInbox) || PE.fromInbox;
                  if (PE.fromInbox) {
                    mainRow = historyRow = PE;

                  } else if (PE.emailRow) {
                    mainRow = emailRow = PE.row;
                  } else if (PE.phoneRow) {
                    mainRow = phoneRow = PE.row;
                  }

//Checking if the subject line has been filled or not
                  let realValue;
                  if (!this.componentData.eventSubjectText) {
                    if (historyRow && historyRow.originalDataRow.data.EventPath) {
                      newEventSubject = EventPath = historyRow.originalDataRow.data.EventPath;
                    }
                    PE = PE.data.PE;
                    callback();
                  } else {
                    if (historyRow && historyRow.originalDataRow.data.EventPath) {
                      EventPath = `${historyRow.originalDataRow.data.EventPath} / `;
                    }
                    newEventSubject = EventPath = `${EventPath}${this.componentData.eventSubjectText}`;
                    PE = PE.data.PE;
                    callback();
                  }


                } else {
                  newEventSubject = this.componentData.eventSubjectText;
                  callback();
                }
              },
                async() => {
                  if(PE.emailRow) {
                    sellerEmail = emailRow.data.emailAddress;
                  }
                  else if(PE.phoneRow) {
                    sellerPhoneNumber = phoneRow.data.phoneNumber;
                  }
                },
              async () => {
                if (mainRow && newEventSubject) {
                  mainRow.newEventSubject = newEventSubject;
                }
                if (this.getMessageAttachment()) {
                  await this.doGrant(PE, this.lastTransactionId);
                } else if (BeginTime && EndTime) {
                  async.waterfall([
                    this.mainPanel.createComponent.bind(
                        this.mainPanel,
                        this.parent.config.nodeIds.templates.appointmentTemplate.firsttemplate,
                        {},
                        {
                          DNPrefix: newEventSubject,
                          fromPE: this.mainPanel.FromPE,
                          fromGrantId: this.mainPanel.fromGrantId,
                          byPE: this.contextPE,
                          byGrantId: this.componentData.contextPEGrant.GrantID
                        }
                    ),
                    async (appointmentComponent) => {
                      return await this.doGrant(
                          PE,
                          this.lastTransactionId,
                          [{
                            onObject: appointmentComponent.Node,
                            onRole: "admin"
                          }],
                          this.componentData.messageBoxShareModes.offer
                      );
                    }
                  ], ()=>{});
                } else {
                  //console.log('promiseModeCommit', 'calling postHistoryMessage');
                  //console.log('promiseModeCommit', 'ArgJSON:', this.createPromiseArgJSON({sellerEmail, sellerPhoneNumber}));
                  //console.log('promiseModeCommit', 'EventLabel:', this.$refs.agreementTitleInput._.data.inputVal);

                  /*console.log('promiseModeCommit', 'History-Object:', ({
                    PK: oxygenUtil.getGUID(),
                    FromPE: this.mainPanel.GatewayPE,
                    ToPE: PE,
                    ByPE: this.envelopeByPE || this.contextPE,
                    CredentialPE: this.CredentialPE,
                    AgentOfPE: this.mainPanel.AgentOfPE,
                    GatewayPE: this.mainPanel.GatewayPE,
                    //TransactionId: this.lastTransactionId,
                    ArgJSON: JSON.stringify(this.createPromiseArgJSON({sellerEmail, sellerPhoneNumber})),
                    Note: JSON.stringify({ String: this.getFullMessage(), Link: ''}),
                    EventLabel: this.$refs.agreementTitleInput._.data.inputVal,
                    EventTemplate: "_FFFFFFFFFFFFFF00001664230222489958_",
                    NoteTemplate: "MessageNoteTemplate-0056",
                    NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
                    TaskTemplateID: '_FF10313609901216306869076411514878_'
                  },( this.geolocation && this.geolocation.location) ? {
                    Lat: this.geolocation.location.latitude,
                    Long: this.geolocation.location.longitude,
                    IPAddress: this.geolocation.traits.ip_address,
                    City: this.geolocation.city.names.en,
                    State: this.geolocation.postal.code,
                    Country: this.geolocation.country.names.en,
                    GeoIPLocation: JSON.stringify(this.geolocation)
                  } : {}));*/
                  let historyItem = await this.postHistoryMessage(Object.assign({
                    PK: oxygenUtil.getGUID(),
                    FromPE: this.mainPanel.GatewayPE,
                    ToPE: PE,
                    ByPE: this.envelopeByPE || this.contextPE,
                    CredentialPE: this.CredentialPE,
                    AgentOfPE: this.mainPanel.AgentOfPE,
                    GatewayPE: this.mainPanel.GatewayPE,
                    //TransactionId: this.lastTransactionId,
                    ArgJSON: JSON.stringify(this.createPromiseArgJSON({sellerEmail, sellerPhoneNumber})),
                    Note: JSON.stringify({ String: this.getFullMessage(), Link: ''}),
                    EventLabel: this.$refs.agreementTitleInput._.data.inputVal,
                    EventTemplate: "_FFFFFFFFFFFFFF00001664230222489958_",
                    NoteTemplate: "MessageNoteTemplate-0056",
                    NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
                    TaskTemplateID: '_FF10313609901216306869076411514878_',
                    AttributionId: this.attributionRecord.ID,
                    SegmentTemplate: this.currentSimpleMode === 'promise_offer' ? '_FFFFFFFFFFFFFF00001664391218561255_' :
                        '_FFFFFFFFFFFFFF00001664391218561269_',
                    SessionId: oxygenUtil.Cookies.get('sessionId')
                  },this.getLocationData()));
                  //console.log('results:', historyItem);
                  if (emailRow) {
                    //console.log('promiseModeCommit', 'inserting:', emailRow, ' - val:', historyItem.PK);
                    insertIds.set(emailRow, historyItem.PK);
                  }

                }
              }
            ], callback);

          }, (error) => {

            if (!error) {
              //console.log('promiseModeCommit', 'insertIds:', insertIds);
              this.emailMessages.forEach((e) => {
                let insertId;
                //console.log('promiseModeCommit', 'checking for:', e.emailRow, ' - val:', insertIds.get(e.emailRow));
                if (insertId = insertIds.get(e.emailRow)) {
                  e.causingEventId = insertId;
                }
                if (e.emailRow.newEventSubject) {
                  e.subject = e.emailRow.newEventSubject;
                }
                if (this.getMessageAttachment()) {
                  this.addMessageAttachmentInfo(e);
                }
              });

              async.parallel([
                async () => {
                  await oxygenUtil.sendEmailMessages(this.contextPE, this.emailMessages)
                },
                async () => {

                  await oxygenUtil.sendPhoneMessages(this.contextPE, this.phoneMessages, Object.assign({ ClientID: this.ClientID}, this.componentData.SMSCallParams))
                }
              ], (error) => {
                if (!error) {
                  this.resetMessageBox();
                }
              });
            }

          });
        }
      ])

    },
    createPromiseArgJSON(data) {
      return Object.assign({
        Content: this.getFullMessage()},
          this.attributionRecord ? ( this.currentSimpleMode === 'promise_offer' ?
              {
        SellerName: this.attributionRecord.name,
        SellerEmail: this.attributionRecord.email,
        SellerPhone: this.attributionRecord.phone_number,
            SellerSigned: this.attributionRecord.name
      } : {
                BuyerName: this.attributionRecord.name,
                BuyerEmail: this.attributionRecord.email,
                BuyerPhone: this.attributionRecord.phone_number,
                BuyerSigned: this.attributionRecord.name
              } ) : {},
          this.currentSimpleMode === 'promise_offer' ? {
        BuyerName: '',
        BuyerEmail: data.sellerEmail || '',
        BuyerPhone: data.sellerPhoneNumber || '',
        BuyerSigned: ''
      } : {
            SellerName: '',
            SellerEmail: data.sellerEmail || '',
            SellerPhone: data.sellerPhoneNumber || '',
            SellerSigned: ''
          });
    },
    async assignHomepageCommit() {
      let mode = {
        'assign_homepage': this.assignHomepage.bind(this),
        'remove_homepage': this.removeHomepage.bind(this)
      }
      if(mode[this.currentSimpleMode]) {
        await mode[this.currentSimpleMode]();
      }
    },
    async assignHomepage() {
      await async.waterfall([
          async() => {
            let PEs = await this.getChatRecipientPEs();
            //console.log('assignHomepage', 'PEs:', PEs);
            await async.each(PEs, async (PE) => {
              let historyRow, emailRow, phoneRow, EventPath = '', newEventSubject = '', mainRow;
              let isHistoryRow = false;

              if (typeof PE === "object") {
                isHistoryRow = (PE.row && PE.row.fromInbox) || PE.fromInbox;
                if (PE.fromInbox) {
                  mainRow = historyRow = PE;
                } else if (PE.emailRow) {
                  mainRow = emailRow = PE.row;
                } else if (PE.phoneRow) {
                  mainRow = phoneRow = PE.row;
                }
                PE = PE.data.PE;

                let parsedPE = oxygenUtil.parseOES(PE).segments;
                //console.log('assignHomepage', 'parsedPE:', parsedPE);
                let attribution = await this.getAttributionRecordBySubject(parsedPE[3], parsedPE[2]);
                //console.log('assignHomepage', 'attribution-1:', attribution);
                if(attribution && attribution.GatewayRightID !== attribution.HostRootAccountID) {
                  attribution = await this.getAttributionRecordBySubject(attribution.HostRootAccountID, 'admin');
                  //console.log('assignHomepage', 'attribution-2:', attribution);
                }
                if(attribution) {
                  let parsedAccountPE = oxygenUtil.parseOES(PE).segments,
                  parsedContextPE = oxygenUtil.parseOES(this.contextPE).segments;
                  let contextPE = oxygenUtil.createSimpleOES([parsedAccountPE[2], parsedAccountPE[3], this.componentData.homepageRole, parsedContextPE[3]]);
                  let json = JSON.stringify({Type: 'Parent', MeetingContext: { ContextPE: contextPE}});
                  await oxygenUtil.runDBQuery(
                      `insert into OxygenDatabase.AttributionBookmarks (AttributionID, Type, ArgJSON, ContextPE) values(?,?,?,?)
ON DUPLICATE KEY UPDATE ArgJSON = ?, ContextPE = ?`,
                      [ attribution.AttributionID, 'Homepage', json, contextPE, json, contextPE]
                  );
                }
             }
            });
          }
      ]);
      this.resetMessageBox();
    },
    async removeHomepage() {

      let PEs = await this.getChatRecipientPEs();
      let bookmarkIds = PEs.map((PE)=>{
        let historyRow, emailRow, phoneRow, EventPath = '', newEventSubject = '', mainRow;
        let isHistoryRow = false;

        if (typeof PE === "object") {
          isHistoryRow = (PE.row && PE.row.fromInbox) || PE.fromInbox;
          if (PE.fromInbox) {
            mainRow = historyRow = PE;
          } else if (PE.emailRow) {
            mainRow = emailRow = PE.row;
          } else if (PE.phoneRow) {
            mainRow = phoneRow = PE.row;
          }
          return this.componentData.homepageAccountsMap[PE.data.PE].ID;
        }
      });

      await oxygenUtil.runDBQuery(
          `delete from OxygenDatabase.AttributionBookmarks where ID in (?)`,
          [bookmarkIds]
      );

      this.resetMessageBox();
    },
    async getAttributionRecordBySubject(subjectId, subjectRole) {
      let results = await oxygenUtil.runDBQuery(
          `select * from OxygenDatabase.Attribution where GatewayRightID = ? and GatewayRightR = ?`,
          [subjectId, subjectRole]
      );
      return (results && results.length) ? results[0] : null;
    },
    async getAttributionRecordByPE(PE) {
      let results = await oxygenUtil.runDBQuery(
          `select * from OxygenDatabase.Attribution where GatewayPE = ?`,
          [PE]
      );
      return (results && results.length) ? results[0] : null;
    },
    async agreementModeCommit() {
      await this.sendModeCommitNormal();
    },
    async sendModeCommit() {
      //console.log('sendModeCommit', 'botMode:', this.mainPanel.componentData.botMode);
      //let message = this.getMessage(), matches;
      if(this.$refs.subjectMenuTable.tableData.dataRows.length &&
          this.$refs.subjectMenuTable.tableData.dataRows[0].type === this.rowTypes.channel) {
        await this.sendChannel(this.$refs.subjectMenuTable.tableData.dataRows[0].data.channelName, this.getMessage());
      }
      else if(this.mainPanel.componentData.botMode && !this.mainPanel.componentData.directBot) {
        if(this.mainPanel.componentData.botService === 'AIChat') {
          await this.sendAIChatMessages();
        }
        else {
          await this.sendBotMode();
        }
      }
      /*
      else if(this.selectedModeButton.id === 'forward'){
        await this.sendModeCommitNormal();
      }
      else if(this.selectedModeButton.id === 'new'){
        await this.sendModeCommitNormal();
      }
      else if(this.selectedModeButton.id === 'replace'){
        await this.sendModeCommitNormal();
      }
      else if(this.selectedModeButton.id === 'reply'){
        await this.sendModeCommitNormal();
      }*/
      else {
        await this.sendModeCommitNormal();
      }
    },
    async newMessageModeCommit() {

    },
    async editMessageModeCommit() {

    },
    async forwardModeCommitOld() {
      console.log('forwardModeCommit', 'forwarded Message:', this.componentData.currentForwardedMessage);
      let botPE = oxygenUtil.createSimpleOES(
          ['bot', this.componentData.currentForwardedMessage.data.ToRightId, 'bot', this.componentData.currentForwardedMessage.data.ToRightId]);

      let taskId = oxygenUtil.getGUID();

      async.waterfall([
        async () => {
          let PEs = await this.getChatRecipientPEs();



          let BeginTime, EndTime;
          if (this.isScheduleSet()) {
            let scheduleTimes = this.getScheduleTimes();

            BeginTime = scheduleTimes.T1;
            EndTime = scheduleTimes.T2;
          }
          let insertIds = new Map();
          let lastHistoryItem;
          await this.doBotConnect(
              botPE,
              {
                ConversationId: this.componentData.currentForwardedMessage.data.PK,
                RootConversationId:this.componentData.currentForwardedMessage.data.RootEventID
              }
          );

          async.each(PEs, (PE, callback) => {
            let historyRow, emailRow, phoneRow, EventPath = '', newEventSubject = '', mainRow;
            let isHistoryRow = false;
            let historyItem;
            async.series([
              (callback) => {
                if (typeof PE === "object") {
                  console.log('sendModeCommit', 'PE:', PE);
                  isHistoryRow = (PE.row && PE.row.fromInbox) || PE.fromInbox;
                  console.log('isHistoryRow', 'isHistoryRow:', isHistoryRow);
                  //console.log('sendModeCommit', 'isHistoryRow:', isHistoryRow);
                  if (PE.fromInbox) {
                    mainRow = historyRow = PE;

                  } else if (PE.emailRow) {
                    mainRow = emailRow = PE.row;
                  } else if (PE.phoneRow) {
                    mainRow = phoneRow = PE.row;
                  }

//Checking if the subject line has been filled or not
                  let realValue;
                  if (!this.componentData.eventSubjectText) {
                    if (isHistoryRow && mainRow.originalDataRow.data.EventPath) {
                      newEventSubject = EventPath = mainRow.originalDataRow.data.EventPath;
                    }
                    PE = PE.data.PE;
                    callback();
                  } else {
                    if (isHistoryRow && mainRow.originalDataRow.data.EventPath) {
                      EventPath = `${mainRow.originalDataRow.data.EventPath} / `;
                    }
                    newEventSubject = EventPath = `${EventPath}${this.componentData.eventSubjectText}`;
                    PE = PE.data.PE;
                    callback();
                  }

                  /*
else if(realValue = $(this.$refs.eventSubject).data('realvalue')){

let parsedPE = this.parent.parseOES(PE.data.PE).segments, originalToPE = PE.data.PE;
PE = oxygenUtil.createSimpleOES([parsedPE[2], parsedPE[3], "admin", realValue]);
newEventSubject = $(this.$refs.eventSubject).data('awesomplete-val');
//console.log('sendModeCommit', 'realValue:', realValue, ' - subject: ', newEventSubject);
this.createGrantIfNeeded(PE, originalToPE, "admin", realValue,  callback);

}
else {
this.mainPanel.createComponent(
this.parent.config.nodeIds.templates.justadisplayname.firsttemplate,
{},
{
DNPrefix: this.componentData.eventSubjectText,
toPE: this.envelopeByPE ||  this.contextPE,
byPE: this.envelopeByPE ||  this.contextPE,
byGrantId: this.mainPanel.grantId
},
(error, component) => {
if(error) {
return callback(error);
}
let parsedPE = this.parent.parseOES(PE.data.PE).segments, originalToPE = PE.data.PE;
PE = oxygenUtil.createSimpleOES([parsedPE[2], parsedPE[3], "admin", component.Node]);
console.log('sendModeCommit', 'PE: ', PE, ' - parsedOldPE:', parsedPE);
newEventSubject = component.DisplayName;
this.createGrantIfNeeded(PE, originalToPE, "admin", component.Node,  callback);
}
);
}

*/
                } else {
                  newEventSubject = this.componentData.eventSubjectText;
                  callback();
                }
              },
              async () => {
                if (mainRow && newEventSubject) {
                  mainRow.newEventSubject = newEventSubject;
                }
                if (this.getMessageAttachment()) {
                  await this.doGrant(PE, this.lastTransactionId);
                } else if (BeginTime && EndTime) {
                  async.waterfall([
                    this.mainPanel.createComponent.bind(
                        this.mainPanel,
                        this.parent.config.nodeIds.templates.appointmentTemplate.firsttemplate,
                        {},
                        {
                          DNPrefix: newEventSubject,
                          fromPE: this.mainPanel.FromPE,
                          fromGrantId: this.mainPanel.fromGrantId,
                          byPE: this.contextPE,
                          byGrantId: this.componentData.contextPEGrant.GrantID
                        }
                    ),
                    async (appointmentComponent) => {
                      return await this.doGrant(
                          PE,
                          this.lastTransactionId,
                          [{
                            onObject: appointmentComponent.Node,
                            onRole: "admin"
                          }],
                          this.componentData.messageBoxShareModes.offer
                      );
                    }
                  ], callback);
                } else {

                  let ToPE = PE;
                  if(this.componentData.currentForwardedMessage) {
                    ToPE = botPE;
                  }

                  let envelope = {
                    ToPE,
                    ByPE: this.envelopeByPE || this.contextPE
                  };

                  let lastBotMessage;

                  let PK = (this.componentData.botMode && !this.componentData.currentConversationRootThreadId) ? this.componentData.newBotRootThreadId : oxygenUtil.getGUID();

                  lastHistoryItem = historyItem = await this.postHistoryMessage(Object.assign({
                        PK,
                        FromPE: this.mainPanel.GatewayPE,
                        CredentialPE: this.CredentialPE,
                        AgentOfPE: this.mainPanel.AgentOfPE || this.mainPanel.GatewayPE,
                        GatewayPE: this.mainPanel.GatewayPE,
                        //TransactionId: this.lastTransactionId,
                        Note: JSON.stringify({String: this.getFullMessage(), Link: ''}),
                        EventLabel: 'Forward',
                        EventTemplate: this.setSendEventTemplate(),
                        //NoteTemplate: "MessageNoteTemplate-0056",
                        //NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
                        TaskID: taskId,
                        TaskTemplateID: this.standardTaskTemplateId,
                        SessionId: oxygenUtil.Cookies.get('sessionId'),
                        ArgJSON: JSON.stringify({ ForwardPE: PE,
                          ConversationId: this.componentData.currentForwardedMessage.data.PK,
                          RootConversationId: this.componentData.currentForwardedMessage.data.RootEventID}),
                      }, (
                          this.attributionRecord ? {
                            AttributionId: this.attributionRecord.ID
                          } : {}
                      ),
                      envelope, (BeginTime ? {BeginTime, EndTime} : {}),
                      (EventPath ? {EventPath} : {}),
                      /*( (this.componentData.botMode) ? {
                        CausingEventID: this.componentData.lastBotMessageEventId || PK,
                        RootEventID: this.componentData.currentBotRootThreadId || PK,
                      } : {}),
                      (isHistoryRow ? {
                        CausingEventID: mainRow.originalDataRow.data.PK,
                        RootEventID: mainRow.originalDataRow.data.RootEventID } : {}),*/
                      this.getLocationData(),
                      (this.lastSelectedContentTemplate && emailRow) ? (
                          await this.createEmailFCX(Object.assign({FromPE: this.envelopeByPE },envelope), mainRow)
                      ) : {}, (this.componentData.botMode ? {ArgJSON: JSON.stringify({botMessage: true})} : {} ) ));
                  let inbox;
                  //console.log('sendModeCommit', 'calling setWaitingMode');
                  if((inbox = window.devStore.viewPorts.find(e => ((this.viewport.ClientID === e.ClientID)) && e.isInbox)) &&
                      this.componentData.botMode) {
                    //console.log('sendModeCommit', 'inbox:', inbox.viewportID, ' - PK:', historyItem.PK);
                    oxygenUtil.callViewportFn(inbox.viewportID, 'setWaitingMode', [true, historyItem.PK]);
                  }

                  console.log('sendModeCommit', 'historyRow:', isHistoryRow, ' - replyPath:', mainRow && mainRow.originalDataRow &&  mainRow.originalDataRow.data.PK);
                  if(isHistoryRow && mainRow.originalDataRow.data.PK) {
                    console.log('sendModeCommit', 'inbox:', inbox,  'inbox-viewport:', inbox && inbox.viewportID);
                    oxygenUtil.callViewportFn(inbox.viewportID, 'resetReplyIcon', [mainRow.originalDataRow.data.PK]);

                  }

                  //console.log('results:', historyItem);
                  if (emailRow) {
                    if(isHistoryRow) {
                      this.updateReplyHistoryNote(mainRow.originalDataRow.data);
                    }
                    //console.log('sendModeCommit', 'inserting:', emailRow, ' - val:', historyItem.PK);
                    insertIds.set(emailRow, historyItem.PK);
                  }

                }
              }
            ], callback);
          }, async (error) => {

            if (!error) {


              //console.log('sendModeCommit', 'insertIds:', insertIds);
              //console.log('sendModeCommit', 'lastSelectedContentTemplate:', this.lastSelectedContentTemplate);
              if(!this.lastSelectedContentTemplate) {
                if(!this.attributionRecord && this.client.Attribution) {
                  this.attributionRecord = await oxygenUtil.getAttributionRecord(this.client.Attribution);
                }
                this.emailMessages.forEach((e) => {
                  let insertId;
                  //console.log('sendModeCommit', 'checking for:', e.emailRow, ' - val:', insertIds.get(e.emailRow));
                  if (insertId = insertIds.get(e.emailRow)) {
                    e.causingEventId = insertId;
                  }
                  let messageId;
                  if (messageId = this.getEmailMessageId(e.emailRow)) {
                    e.inReplyTo = messageId;
                  }

                  e.subject = this.setEmailSubject(e.emailRow);
                  if (this.getMessageAttachment()) {
                    this.addMessageAttachmentInfo(e);
                  }

                  if(this.attributionRecord) {
                    e.fromAttributionId = this.attributionRecord.ID;
                  }
                });

                async.parallel([
                  async () => {
                    await oxygenUtil.sendEmailMessages(this.contextPE, this.emailMessages)
                  },
                  async () => {
                    await oxygenUtil.sendPhoneMessages(this.contextPE, this.phoneMessages, { ClientID: this.ClientID})
                  }
                ], (error) => {
                  if (!error) {
                    this.resetMessageBox();
                  }
                });
              }
              else {
                this.resetMessageBox();
              }
            }

          });
        }
      ])
    },
    async sendChannel(channel, data) {
      channel = channel.replace('@', '');
      //console.log('sendChannel', 'params:', {mode : 'graph', clientId :this.client.Client, channel, data});
      window.BotServices.callManagerExec({mode : 'graph', clientId :this.client.Client, channel, data}, ()=>{
        this.resetMessageBox();
      });
    },
    async sendModeCommitNormal() {
      let taskId = oxygenUtil.getGUID();
      console.log('sendModeCommit', 'simpleMode:', this.currentSimpleMode);
      async.waterfall([
        (callback) => {
         // if (this.bodyComponentProps.component) {
          if(this.showBodyComponent) {
            this.saveBodyComponent(callback)
          } else {
            callback();
          }
        },
        async () => {
          let PEs = await this.getChatRecipientPEs();


          /*
          let T1, T2;
          if (this.isScheduleSet()) {
            let scheduleTimes = this.getScheduleTimes();

            T1 = scheduleTimes.T1;
            T2 = scheduleTimes.T2;
          }

           */

          let insertIds = new Map();
          let lastHistoryItem;
          async.each(PEs, (PE, callback) => {
            let historyRow, emailRow, phoneRow, EventPath = '', newEventSubject = '', mainRow;
            let isHistoryRow = false;
            let historyItem;
            async.series([
              (callback) => {
                if (typeof PE === "object") {

                  isHistoryRow = (PE.row && PE.row.fromInbox) || PE.fromInbox;
                  if (PE.fromInbox) {
                    mainRow = historyRow = PE;
                  } else if (PE.emailRow) {
                    mainRow = emailRow = PE.row;
                  } else if (PE.phoneRow) {
                    mainRow = phoneRow = PE.row;
                  }
                  PE = PE.data.PE;


//Checking if the subject line has been filled or not
                  let realValue;
                  if (!this.componentData.eventSubjectText) {
                    if (isHistoryRow && mainRow.originalDataRow.data.EventPath) {
                      newEventSubject = EventPath = mainRow.originalDataRow.data.EventPath;
                    }

                    callback();
                  } else {
                    if (isHistoryRow && mainRow.originalDataRow.data.EventPath) {
                      EventPath = `${mainRow.originalDataRow.data.EventPath} / `;
                    }
                    newEventSubject = EventPath = `${EventPath}${this.componentData.eventSubjectText}`;

                    callback();
                  }


                } else {
                  newEventSubject = this.componentData.eventSubjectText;
                  callback();
                }
              },
              async () => {
                if (mainRow && newEventSubject) {
                  mainRow.newEventSubject = newEventSubject;
                }
                if (this.getMessageAttachment()) {
                  await this.doGrant(PE, this.lastTransactionId);
                }
                /*else if (T1 && T2) {
                  async.waterfall([
                    this.mainPanel.createComponent.bind(
                        this.mainPanel,
                        this.parent.config.nodeIds.templates.appointmentTemplate.firsttemplate,
                        {},
                        {
                          DNPrefix: newEventSubject,
                          fromPE: this.mainPanel.FromPE,
                          fromGrantId: this.mainPanel.fromGrantId,
                          byPE: this.contextPE,
                          byGrantId: this.componentData.contextPEGrant.GrantID
                        }
                    ),
                    async (appointmentComponent) => {
                      return await this.doGrant(
                          PE,
                          this.lastTransactionId,
                          [{
                            onObject: appointmentComponent.Node,
                            onRole: "admin"
                          }],
                          this.componentData.messageBoxShareModes.offer
                      );
                    }
                  ], callback);
                } */
                else {


                  let envelope = {

                    ToPE: PE,
                    ByPE: this.envelopeByPE || this.contextPE
                  };
                  console.log('sendModeCommit', 'mode:', this.selectedModeButton.id);
                  let shareMessagePE;
                  if(this.selectedModeButton.id === 'share_message') {
                    envelope.ToPE = oxygenUtil.createSimpleOES(['bot', this.parsedContextPE[3], 'bot', this.parsedContextPE[3]]);
                    let inboxTermination = {
                      DisplayName : 'Inbox',
                      Termination : {
                        MediaType : 'WebComponent',
                        URL: '/simplia/dist/builds/inbox-wc/app.js',
                        Template: 'oxygen-inbox',
                        dataset: {
                          initializereplymode: true,
                          replymessagerootid: this.componentData.currentInboxFocusedMessage.data.RootEventID
                        }
                      }
                    }
                    shareMessagePE = await this.createBookmark(PE, this.componentData.shareAsAdminFlag ? 'admin': 'visitor',  this.parsedContextPE[3], inboxTermination, '');
                  }

                  console.log('sendModeCommit', 'calling postHistoryMessage - envelope:', envelope);
                  //console.log('sendModeCommit', 'currentForwardedMessage:',this.componentData.currentForwardedMessage );
                  let lastBotMessage;

                  let PK = (this.componentData.botMode && !this.componentData.currentConversationRootThreadId) ? this.componentData.newBotRootThreadId : oxygenUtil.getGUID();

                  let historyData = Object.assign({
                        PK,
                        TaskID: taskId,
                        TaskTemplateID: this.standardTaskTemplateId,
                        SessionId: oxygenUtil.Cookies.get('sessionId')
                      },
                      envelope,
                      (EventPath ? {EventPath} : {}),
                      this.getScheduledTimeData(),
                      this.getSendModeNote(),
                      this.getParentEventsData(isHistoryRow, mainRow, PK),
                      this.getLocationData(),
                      this.getCredentialData(),
                      this.getEventTemplateData(),
                      (this.lastSelectedContentTemplate && emailRow) ? (
                          await this.createEmailFCX(Object.assign({FromPE: this.envelopeByPE },envelope), mainRow)
                      ) : {},
                      {ArgJSON: JSON.stringify(Object.assign({},
                            this.componentData.botMode ? {botMessage: true} : {},
                            this.selectedModeButton.id === 'share_message' ? { FinalToPE: shareMessagePE }: {},
                            (this.componentData.currentForwardedMessage && !Array.isArray(this.componentData.currentForwardedMessage)) ? {OriginalByPE:this.componentData.currentForwardedMessage.data.ByPE} : {}
                        ))}
                  );

                  if(this.isBotPE(envelope.ToPE) || (this.isSessionBotPE(envelope.ToPE))) {
                    await this.setupBotMessageFlow(envelope.ToPE, PK, historyData);
                  }


                  lastHistoryItem = historyItem = await this.postHistoryMessage(historyData);

                  this.resetReplyIcon();

                  if(historyItem.CausingEventLabel && (historyItem.CausingEventLabel === 'Replace')) {
                    await this.postRevokeNewsEvent(historyItem);
                  }

                  if(this.componentData.commandMode) {
                    this.handleCommandMessages(historyItem);
                  }

                  let inbox;
                  //console.log('sendModeCommit', 'calling setWaitingMode');
                  if((inbox = window.devStore.viewPorts.find(e => ((this.viewport.ClientID === e.ClientID)) && e.isInbox)) &&
                      this.componentData.botMode) {
                    //console.log('sendModeCommit', 'inbox:', inbox.viewportID, ' - PK:', historyItem.PK);
                    oxygenUtil.callViewportFn(inbox.viewportID, 'setWaitingMode', [true, historyItem.PK]);
                  }

                  //console.log('sendModeCommit', 'historyRow:', isHistoryRow, ' - replyPath:', mainRow && mainRow.originalDataRow &&  mainRow.originalDataRow.data.PK);
                  if(isHistoryRow && mainRow.originalDataRow.data.PK) {
                    console.log('sendModeCommit', 'inbox:', inbox,  'inbox-viewport:', inbox && inbox.viewportID);
                    oxygenUtil.callViewportFn(inbox.viewportID, 'resetReplyIcon', [mainRow.originalDataRow.data.PK]);

                  }

                  if(this.componentData.replyMode) {
                    this.componentData.lastReplyMessage = historyItem;
                  }
                  //console.log('results:', historyItem);
                  if (emailRow) {
                    if(isHistoryRow) {
                      this.updateReplyHistoryNote(mainRow.originalDataRow.data);
                    }
                    //console.log('sendModeCommit', 'inserting:', emailRow, ' - val:', historyItem.PK);
                    insertIds.set(emailRow, historyItem.PK);
                  }

                }
              }
            ], callback);
          }, async (error) => {

            if (!error) {


              //console.log('sendModeCommit', 'insertIds:', insertIds);
              //console.log('sendModeCommit', 'lastSelectedContentTemplate:', this.lastSelectedContentTemplate);
              if(!this.lastSelectedContentTemplate) {
                if(!this.attributionRecord && this.client.Attribution) {
                  this.attributionRecord = await oxygenUtil.getAttributionRecord(this.client.Attribution);
                }
                this.emailMessages.forEach((e) => {
                  let insertId;
                  //console.log('sendModeCommit', 'checking for:', e.emailRow, ' - val:', insertIds.get(e.emailRow));
                  if (insertId = insertIds.get(e.emailRow)) {
                    e.causingEventId = insertId;
                  }
                  let messageId;
                  if (messageId = this.getEmailMessageId(e.emailRow)) {
                    e.inReplyTo = messageId;
                  }

                  e.subject = this.setEmailSubject(e.emailRow);
                  if (this.getMessageAttachment()) {
                    this.addMessageAttachmentInfo(e);
                  }

                  if(this.attributionRecord) {
                    e.fromAttributionId = this.attributionRecord.ID;
                  }
                });

                async.parallel([
                  async () => {
                    await oxygenUtil.sendEmailMessages(this.contextPE, this.emailMessages)
                  },
                  async () => {
                    await oxygenUtil.sendPhoneMessages(this.contextPE, this.phoneMessages, { ClientID: this.ClientID})
                  },
                  async () => {
                    //console.log('sendModeCommit', 'botMode:', this.componentData.botMode);
                    /*
                    if(this.componentData.botMode) {
                      //await this.sendBotMessages(lastHistoryItem)
                      await this.doBotConnect(lastHistoryItem);
                    }

                     */
                  }
                ], (error) => {
                  if (!error) {
                    this.resetMessageBox();
                  }
                });
              }
              else {
                this.resetMessageBox();
              }
            }

          });
        }
      ]);
    },
    async setupBotMessageFlow(toPE, PK, historyData) {
      this.callInboxFn('displayLoadingAnimation', [PK]);
      await window.oxygenUtil.doBotConnect(this.client.Client, toPE);
      console.log('setupBotMessageFlow', 'calling displayLoadingAnimation');

      /*
      this.retryIntervalId = window.setInterval(async ()=>{
        await window.oxygenUtil.doBotConnect(this.client.Client, toPE);
        await this.postHistoryMessage(historyData);
      }, 60 * 1000);

       */
    },
    resetRetryInterval() {
      window.clearInterval(this.retryIntervalId);
    },
    async createBookmark(PE, onRole, onObject, inboxTermination, label) {


      let bookmarkGrant = await oxygenUtil.putGrant({
        onObject,
        onRole,
        toPE: PE,
        fromPE: this.mainPanel.GatewayPE,
        fromGrantId: this.mainPanel.GatewayGrantId,
        byPE: this.envelopeByPE || this.contextPE,
        byGrantId: this.componentData.contextPEGrant.GrantID
      });

      let argJSON = JSON.stringify([
        {
          action: 'openChildPanel',
          params: [inboxTermination]
        }
      ])
      await oxygenUtil.addToRelatedLinkBookmarks(PE, bookmarkGrant.GrantPE, bookmarkGrant.Node, label, argJSON);
      return bookmarkGrant.GrantPE;
    },
    callInboxFn(fnName, fnParams) {
      console.log('callInboxFn', 'call for:', fnName);
      let inbox;
      if(inbox = window.devStore.viewPorts.find(e => ((this.viewport.ClientID === e.ClientID)) && e.isInbox)) {
        console.log('callInboxFn', 'calling:', fnName, ' - with:', fnParams);
        oxygenUtil.callViewportFn(inbox.viewportID, fnName, fnParams);
      }

    },
    isBotPE(PE) {
      let parsedPE = oxygenUtil.parseOES(PE).segments;
      console.log('isBotPE', 'bot:', (parsedPE[0] === 'bot'), ' - roles:', (parsedPE[0] === parsedPE[2]), ' - comp:', (parsedPE[1] === parsedPE[3]));
      return (parsedPE[0] === 'bot') && (parsedPE[0] === parsedPE[2]) && (parsedPE[1] === parsedPE[3]);
    },
    isSessionBotPE(PE) {
      let parsedPE = oxygenUtil.parseOES(PE).segments;
      return (parsedPE[0] === 'sessionbot') && (parsedPE[0] === parsedPE[2]) && (parsedPE[1] === parsedPE[3]);
    },
    async handleCommandMessages(historyItem) {
      if(!this.componentData.currentCommand) {
        await this.initializeCommandDialogue(historyItem)
      }
      else {
        this.messageCommands[this.componentData.currentCommand](historyItem);
      }
    },
    async initializeCommandDialogue(historyItem) {
      let command = Object.entries(this.messageCommands).find((e)=>{
        let note;
        return e[0].startsWith((note = oxygenUtil.tryParseJSON(historyItem.Note)) && note.String);
      });
      if(command) {
        this.componentData.currentCommand = command[0];
        this.componentData.nextCommandStep = 'start'
        let callback = await command[1](historyItem);
        if(!this.viewport.isInbox) {
          this.showChildViewport('showInbox', async ()=>{
            await this.$nextTick();
            callback && callback();
          });
        }
        else {
          callback && callback();
        }
      }
    },
    getScheduledTimeData() {
      let T1, T2;
      console.log('getScheduledTimeData', 'set:', this.isScheduleSet(), ' -startTime:', this.startTime);
      if (this.isScheduleSet() || this.startTime) {
        let scheduleTimes = this.getScheduleTimes();
        console.log('getScheduledTimeData', 'scheduleTimes:', scheduleTimes);
        T1 = scheduleTimes.T1;
        T2 = scheduleTimes.T2;
      }

      console.log('getScheduledTimeData', 'returnDAta:', Object.assign( {}, T1 ? {T1} : {}, T2 ? {T2} : {} ));
      return Object.assign( {}, T1 ? {T1} : {}, T2 ? {T2} : {} );
    },
    getSendModeNote() {
      if(this.componentData.currentForwardedMessage && !Array.isArray(this.componentData.currentForwardedMessage)) {
        return  this.createForwardedMessage()
      }
      else if(this.selectedModeButton.id === 'share_message') {
        return this.createSharedMessage();
      }
      else {
        return this.createNormalSendMessage();
      }
    },
    createForwardedMessage(createString) {
      let noteObj = oxygenUtil.tryParseJSON(this.componentData.currentForwardedMessage.data.Note),
          originalMessage = (noteObj && noteObj.String && `${noteObj.String}`) || '';

      let header = `From:${this.componentData.currentForwardedMessage.data.ByLeft}${(this.componentData.currentForwardedMessage.data.ByLeft !== this.componentData.currentForwardedMessage.data.ByRight) ? ` / ${this.componentData.currentForwardedMessage.data.ByRight}` : ''}`;
      return createString ? `${this.getFullMessage()}\n\n${header}\n\n${noteObj.String} ` : Object.assign({},
          {
            SegmentJSON: this.componentData.currentForwardedMessage.data.SegmentJSON,
            SegmentId: this.componentData.currentForwardedMessage.data.SegmentId,
            SegmentParentId: this.componentData.currentForwardedMessage.data.SegmentParentId,
            SegmentRootId: this.componentData.currentForwardedMessage.data.SegmentRootId
          },
          { Note: JSON.stringify(Object.assign({}, noteObj, { ForwardString: originalMessage, String: this.getFullMessage()})) });
    },
    createSharedMessage() {
      return { Note: this.componentData.currentInboxFocusedMessage.data.Note };
    },
    createNormalSendMessage() {
      return { Note: JSON.stringify({ String: this.getFullMessage(), Link: ''}) };
    },
    async postRevokeNewsEvent(historyItem) {
      return await this.postHistoryMessage(Object.assign({
        PK: oxygenUtil.getGUID(),
        SessionId: oxygenUtil.Cookies.get('sessionId'),
        ToPE: historyItem.ToPE,
        ByPE: historyItem.ByPE,
        EventTemplate: '_FFFFFFFFFFFFFF00001714771421159363_',
        Registrant: '_FFFFFFFFFFFFFF00001714771421159363_',
        EventLabel: 'RevokeNews',
        CausingEventID: historyItem.CausingEventID
      },
          this.getLocationData(),
          this.getCredentialData()
      ));
    },
    getEventTemplateData() {
      return Object.assign({
        EventLabel: this.setSendEventLabel(),
        EventTemplate: this.setSendEventTemplate(),
        NoteTemplate: "MessageNoteTemplate-0056",
        NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
      });
    },
    getCredentialData() {
      return Object.assign({
        FromPE: this.mainPanel.GatewayPE,
        CredentialPE: this.CredentialPE,
        AgentOfPE: this.mainPanel.AgentOfPE || this.mainPanel.GatewayPE,
        GatewayPE: this.mainPanel.GatewayPE,
      }, (
          this.attributionRecord ? {
            AttributionId: this.attributionRecord.ID
          } : {}
      ));
    },
    getParentEventsData(isHistoryRow, mainRow, PK) {
      let modeData = {
        'reply': (dataRow) => {
          return {
            CausingEventLabel: 'Reply',
            CausingEventID: dataRow.data.PK,
            RootEventID: dataRow.data.RootEventID
          }
        },

        'forward': (dataRow) => {
          if(Array.isArray(this.componentData.currentInboxFocusedMessage)) {
            console.log('getParentEventsData', 'data:', this.componentData.currentInboxFocusedMessage.map(e => e.data.PK));
            return {
              CausingEventLabel: 'Forward',
              CausingEventID: PK,
              CausingEventIDs: this.componentData.currentInboxFocusedMessage.map(e => e.data.PK),
              RootEventID: PK
            }
          }
          else {
            return {
              CausingEventLabel: 'Forward',
              CausingEventID: dataRow.data.PK,
              RootEventID: dataRow.data.RootEventID
            }
          }
        },
        'link': (dataRow) => {
          return {
            CausingEventLabel: 'Link',
            CausingEventID: dataRow.data.PK,
            RootEventID: dataRow.data.RootEventID
          }
        },
        'new': (dataRow) => {
          return {
            CausingEventLabel: 'New',
            CausingEventID: dataRow.data.CausingEventID,
            RootEventID: dataRow.data.RootEventID
          }
        },
        'replace': (dataRow) => {
          return {
            CausingEventLabel: 'Replace',
            CausingEventID: dataRow.data.PK,
            RootEventID: dataRow.data.RootEventID
          }
        },
        'train': (dataRow) => {
          return {
            CausingEventLabel: 'Replace',
            CausingEventID: dataRow.data.PK,
            RootEventID: dataRow.data.RootEventID
          }
        },
        'share_message': (dataRow) => {
          return {
            CausingEventLabel: 'Share',
            CausingEventID: dataRow.data.PK,
            RootEventID: dataRow.data.RootEventID
          }
        }
      }

      console.log('getParentEventsData', 'currentInboxFocusedMessage',this.componentData.currentInboxFocusedMessage, ' - mode:', this.selectedModeButton.id);
      return Object.assign( (this.componentData.botMode || (this.componentData.replyMode && this.componentData.lastConversationMessageEventId)) ? {
        CausingEventID: this.componentData.lastConversationMessageEventId || PK,
        RootEventID: this.componentData.currentConversationRootThreadId || PK,
      } :  ( (isHistoryRow || this.componentData.currentInboxFocusedMessage) &&
      modeData[this.selectedModeButton.id] ? modeData[this.selectedModeButton.id](isHistoryRow ? mainRow.originalDataRow :
          this.componentData.currentInboxFocusedMessage) : {}));
    },
    getHistoryContextForBot() {
      return Object.assign({
            ClientId: this.client.Client,
            GrantID: this.componentData.contextPEGrant.GrantID,
            ByPE: this.envelopeByPE || this.contextPE,
            ToPE: oxygenUtil.createSimpleOES(['bot', this.lbmAppId, 'bot', this.lbmAppId]),
            PK: oxygenUtil.getGUID(),
            FromPE: this.mainPanel.GatewayPE,
            CredentialPE: this.CredentialPE,
            AgentOfPE: this.mainPanel.AgentOfPE || this.mainPanel.GatewayPE,
            GatewayPE: this.mainPanel.GatewayPE,

            EventLabel: this.setSendEventLabel(),
            EventTemplate: this.setSendEventTemplate(),
            NoteTemplate: "MessageNoteTemplate-0056",
            NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
            TaskID: oxygenUtil.getGUID(),
            TaskTemplateID: this.standardTaskTemplateId,
        SessionId: oxygenUtil.Cookies.get('sessionId')
          }, (
              this.attributionRecord ? {
                AttributionId: this.attributionRecord.ID
              } : {}
          ), this.getLocationData() );
    },
    async sendBotMode(message) {

      //let url = `/BusinessAdvisoryBot-0084/System/ServerSide/lbm`,
      let url = `https://debianlargeserver-0050-kamalk-0054.laxroute53.com/BusinessAdvisoryBot-0084/System/ServerSide/lbm`,
          data = Object.assign({ sessionId: this.client.Client, message: message || this.getMessage(), context: this.getHistoryContextForBot() });
      //console.log('sendBotMode', 'url:', url);
      this.resetMessageBox();
      let response = await fetch(
          url,
          {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            mode: 'cors'
          }
      ).catch((e)=> {
        throw e;
      });


      let responseObj;
      if(response.ok && (responseObj = await response.json())) {
        //console.log('sendBotMode', 'responseObj:', responseObj);
        if(responseObj.context && responseObj.context.ToPE) {
          this.$refs.menuTable.deletePathRows(this.recipientPathPrefix);
          let parsedAppPE = oxygenUtil.parseOES(responseObj.context.ToPE).segments;
          await this.addRecipientPE(responseObj.context.ToPE, null, null, false);
          async.series([
            (callback) => {
              window.BotServices.BotConnect({ClientId: this.client.Client, ComponentId: parsedAppPE[3]}, callback);
            },
            async () => {
              await this.postHistoryMessage(
                  Object.assign({PK: oxygenUtil.getGUID(), Note: JSON.stringify({ String: responseObj.message, Link: ''})}, responseObj.context)
              );
            }
          ],(error)=>{

          });
        }
      }
    },
    async doBotReload(toPE) {
      return await window.oxygenUtil.doBotReload(this.client.Client, toPE);
    },
    async doBotConnect(toPE, params) {
      return await window.oxygenUtil.setBotConnectTracker(this.client.Client, toPE, params);
    },
    async sendBotMessagesOld(historyItem) {
      let fnMap = {
        'BusinessBuddy': this.sendBusinessBuddyMessages.bind(this),
        'AIChat': this.sendAIChatMessages.bind(this),
        'ResumeRanking': this.sendResumeAppMessages.bind(this)
      }
      let fn;
      if(fn = fnMap[this.componentData.botService]) {
        await fn(historyItem);
      }
    },
    async sendAIChatMessages() {


      let url = `/OxygenAI/OpenAI/CreateChatCompletion`,
          data = { messages: [].concat(
              this.componentData.openAIDialogues,
                this.componentData.currentComponentDialogues,
                [{role: 'user', content: this.getFullMessage()}])  };
      let response = await fetch(
          url,
          {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            mode: 'cors'
          }
      ).catch((e)=> {
        throw e;
      });

      let responseObj;
      if(response.ok && (responseObj = await response.json())) {
        //console.log('sendAIChatMessages', 'response:', responseObj);

        this.componentData.currentComponentDialogues.push({role: 'user', content: this.getFullMessage()}, responseObj);

        await oxygenUtil.updateComponentEx(component.Node,{
          'set': {
            'CurrentContext.OpenAIDialogues':this.componentData.currentComponentDialogues
          }
        });
        /*await this.postHistoryMessage(Object.assign({
              PK: oxygenUtil.getGUID(),
              ByPE: historyItem.ToPE || oxygenUtil.createSimpleOES([historyItem.ToLeftRole, historyItem.ToLeftId, historyItem.ToRightRole, historyItem.ToRightId]),
              ToPE: historyItem.ByPE,
              FromPE: this.mainPanel.GatewayPE,
              CredentialPE: this.CredentialPE,
              AgentOfPE: this.mainPanel.AgentOfPE || this.mainPanel.GatewayPE,
              GatewayPE: this.mainPanel.GatewayPE,
              //TransactionId: this.lastTransactionId,
              Note: JSON.stringify({ String: responseObj.advice, Link: ''}),
              EventLabel: this.setSendEventLabel(),
              EventTemplate: this.setSendEventTemplate(),
              NoteTemplate: "MessageNoteTemplate-0056",
              NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
              TaskID: oxygenUtil.getGUID(),
              TaskTemplateID: this.standardTaskTemplateId
            }, (
                this.attributionRecord ? {
                  AttributionId: this.attributionRecord.ID
                } : {}
            ),
            {
              CausingEventID: historyItem.PK,
              RootEventID: historyItem.RootEventID }, ( this.geolocation && this.geolocation.location) ? {
              Lat: this.geolocation.location.latitude,
              Long: this.geolocation.location.longitude,
              IPAddress: this.geolocation.traits.ip_address,
              City: this.geolocation.city.names.en,
              State: this.geolocation.postal.code,
              Country: this.geolocation.country.names.en,
              GeoIPLocation: JSON.stringify(this.geolocation),
              SessionId: oxygenUtil.Cookies.get('sessionId')
            } : {}));*/
        return responseObj;
      }
      return false;
    },
    createResumeRankingReplyNote(responseObj) {
      if(responseObj.property === 'text') {
        return JSON.stringify({String: responseObj.advice, Link: ''});
      }
      else {
        return JSON.stringify({String: responseObj.html, Link: responseObj.URL || '', LinkMeta: responseObj.type || ''});
      }
    },
    async sendResumeAppMessages(historyItem) {
      //let url = `https://debianlargeserver-0050-dataapps.laxroute53.com/ResumeRanking/System/ServerSide/api/chat`,
      let url = `/BusinessAdvisoryBot-0084/System/ServerSide/ResumeRanking`,
          data = Object.assign({ user_question: this.getFullMessage(), user_id: this.contextPE , user_context: historyItem });
      let response = await fetch(
          url,
          {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            mode: 'cors'
          }
      ).catch((e)=> {
        throw e;
      });

      let responseObj;
      if(response.ok && (responseObj = await response.json())) {
        //console.log('sendBotMessages', 'response:', responseObj);

        await this.postHistoryMessage(Object.assign({
              PK: oxygenUtil.getGUID(),
              ByPE: historyItem.ToPE || oxygenUtil.createSimpleOES([historyItem.ToLeftRole, historyItem.ToLeftId, historyItem.ToRightRole, historyItem.ToRightId]),
              ToPE: historyItem.ByPE,
              FromPE: this.mainPanel.GatewayPE,
              CredentialPE: this.CredentialPE,
              AgentOfPE: this.mainPanel.AgentOfPE || this.mainPanel.GatewayPE,
              GatewayPE: this.mainPanel.GatewayPE,
              //TransactionId: this.lastTransactionId,

              Note: this.createResumeRankingReplyNote(responseObj),
              EventLabel: this.setSendEventLabel(),
              EventTemplate: this.setSendEventTemplate(),
              NoteTemplate: "MessageNoteTemplate-0056",
              NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
              TaskID: oxygenUtil.getGUID(),
              TaskTemplateID: this.standardTaskTemplateId,
              SessionId: oxygenUtil.Cookies.get('sessionId')
            }, (
                this.attributionRecord ? {
                  AttributionId: this.attributionRecord.ID
                } : {}
            ),
            {
              CausingEventID: historyItem.PK,
              RootEventID: historyItem.RootEventID }, this.getLocationData()));
        return responseObj;
      }
      return false;
    },
    async sendBusinessBuddyMessages(historyItem) {
      //console.log('sendBotMessages', 'historyItem:', historyItem);
      //let url = `https://debianlargeserver-0050-dataapps.laxroute53.com/BusinessAdvisoryBot-0081/System/ServerSide/question`,
      let url = `/BusinessAdvisoryBot-0084/System/ServerSide/BusinessBuddy`,
          data = { user_question: this.getFullMessage(), user_id: this.contextPE , user_context: historyItem };
      let response = await fetch(
          url,
          {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            mode: 'cors'
          }
      ).catch((e)=> {
        throw e;
      });

      let responseObj;
      if(response.ok && (responseObj = await response.json())) {
        //console.log('sendBotMessages', 'response:', responseObj);

        await this.postHistoryMessage(Object.assign({
              PK: oxygenUtil.getGUID(),
              ByPE: historyItem.ToPE || oxygenUtil.createSimpleOES([historyItem.ToLeftRole, historyItem.ToLeftId, historyItem.ToRightRole, historyItem.ToRightId]),
              ToPE: historyItem.ByPE,
              FromPE: this.mainPanel.GatewayPE,
              CredentialPE: this.CredentialPE,
              AgentOfPE: this.mainPanel.AgentOfPE || this.mainPanel.GatewayPE,
              GatewayPE: this.mainPanel.GatewayPE,
              //TransactionId: this.lastTransactionId,
              Note: JSON.stringify({ String: responseObj.advice, Link: ''}),
              EventLabel: this.setSendEventLabel(),
              EventTemplate: this.setSendEventTemplate(),
              NoteTemplate: "MessageNoteTemplate-0056",
              NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
              TaskID: oxygenUtil.getGUID(),
              TaskTemplateID: this.standardTaskTemplateId,
              SessionId: oxygenUtil.Cookies.get('sessionId')
            }, (
                this.attributionRecord ? {
                  AttributionId: this.attributionRecord.ID
                } : {}
            ),
             {
              CausingEventID: historyItem.PK,
              RootEventID: historyItem.RootEventID }, this.getLocationData()));
        return responseObj;
      }
      return false;
    },
    setSendEventLabel() {
      return this.currentSimpleMode === 'schedule' ? 'Shared Schedule' : ( (this.componentData.currentForwardedMessage  && !Array.isArray(this.componentData.currentForwardedMessage))?
          this.componentData.currentForwardedMessage.data.EventLabel : 'Message');
    },
    setSendEventTemplate() {
      return this.currentSimpleMode === 'schedule' ? "_FFFFFFFFFFFFFF00001693298694651777_" : ( (this.componentData.currentForwardedMessage && !Array.isArray(this.componentData.currentForwardedMessage)) ?
          this.componentData.currentForwardedMessage.data.EventTemplate : "_FFFFFFFFFFFFFF00001575595750910042_");
    },
    createForwardedMessageOld(forEmail) {
      let noteObj = oxygenUtil.tryParseJSON(this.componentData.currentForwardedMessage.data.Note), originalMessage;
      if(noteObj) {
        let fromHeader = `${this.componentData.currentForwardedMessage.data.ByLeft}${(this.componentData.currentForwardedMessage.data.ByLeft !== this.componentData.currentForwardedMessage.data.ByRight)? ` / ${this.componentData.currentForwardedMessage.data.ByRight}`: ''}`;
        originalMessage = `From: ${fromHeader}\n\n\n${decodeURIComponent(noteObj.String)}`;
        if(forEmail) {
          originalMessage = originalMessage.replace(/<a.+Full\s+Email<\/a>/,'');
        }
      }
      //console.log('createForwardedMessage', 'noteObj:', noteObj);
      return `${this.getFullMessage() ? `${this.getFullMessage()}\n\n`: ''}
            ${noteObj ? originalMessage : ''}`;
    },
    setEmailSubject(emailRow) {
      let inReplyTo = this.getEmailMessageId(emailRow);

      //console.log('setEmailSubject', 'subject:', this.$refs.subjectInput.inputVal);
      if (this.$refs.subjectInput.inputVal) {
        return this.$refs.subjectInput.inputVal;
      }
      else if(this.$refs.subjectMenuTable.tableData.dataRows.length) {
        let row = this.$refs.subjectMenuTable.tableData.dataRows[0];
        if(row.type === this.rowTypes.attachment) {
          return row.data.component.DisplayName
        }
        else if(row.type === this.rowTypes.email){
          return row.data.emailAddress;
        }
        else if(row.type === this.rowTypes.phone){
          return row.data.phoneNumber;
        }
      }
      else if (inReplyTo) {
        return this.getEmailMessageAttribute(emailRow, 'subject');
      }
      return this.mainPanel.atComponent.DisplayName;
    },

    async createEmailFCX(envelope, emailRow) {
      //console.log('createEmailFCX', 'envelope:', envelope);
      if(!this.attributionRecord && this.client.Attribution) {
        this.attributionRecord = await oxygenUtil.getAttributionRecord(this.client.Attribution);
      }


      let inReplyTo = this.getEmailMessageId(emailRow);
      //console.log('createEmailFCX', 'inReplyTo:', inReplyTo);
      return {
        FCX: JSON.stringify([Object.assign({
          TaskTemplate: "_FFFFFFFFFFFFFF00001630603991560556_",
          ContentTemplate: this.lastSelectedContentTemplate,
          InitialContext: Object.assign({
            ToAddress: emailRow.data.emailAddress,
            Subject: this.setEmailSubject(emailRow),
            Content: this.getFullMessage(),

          }, (this.attributionRecord ? {SenderAttribution: this.attributionRecord, FromAttributionID: this.attributionRecord.ID} : {}),
              envelope, inReplyTo? { inReplyTo } : {} )
        },
            ((emailRow.data.emailInfo && emailRow.data.emailInfo.attribution) ?
            {
              InputJSON: {
                Database: "OxygenDatabase",
                Table: "Attribution",
                PK: "ID",
                Value: emailRow.data.emailInfo.attribution.ID
                //Value: this.client.Attribution
              }
            } : {})
        )])
      };
    },
    getEmailMessageId(emailRow) {
      let args;
      //console.log('getEmailMessageId', 'emailRow:', emailRow);
      if( emailRow.originalDataRow &&
          emailRow.originalDataRow.data &&
          (args = oxygenUtil.tryParseJSON(emailRow.originalDataRow.data.ArgJSON)) &&
          args.sesNotification) {
        //console.log('getEmailMessageId', 'sesNotification:', args.sesNotification);
        return args.sesNotification.mail.headers.find(e => e.name === "Message-ID").value;
      }

      return null;
    },
    getEmailMessageAttribute(emailRow, attribute) {
      let args;
      //console.log('getEmailMessageId', 'emailRow:', emailRow);
      if( emailRow.originalDataRow &&
          emailRow.originalDataRow.data &&
          (args = oxygenUtil.tryParseJSON(emailRow.originalDataRow.data.ArgJSON)) &&
          args[attribute]) {

        return args[attribute];
      }
      return null;
    },
    async updateReplyHistoryNote(historyData) {
      //console.log('updateReplyHistoryNote', 'attribution:', this.attributionRecord, ' client.Attributuion:', this.client.Attribution);
      if(!this.attributionRecord && this.client.Attribution) {
        this.attributionRecord = await oxygenUtil.getAttributionRecord(this.client.Attribution);
        //console.log('updateReplyHistoryNote', 'fetched - attribution:', this.attributionRecord );
      }
      await oxygenUtil.postHistoryMessage(
          {
            PK: historyData.PK,
            HistoryNotes: [{
              name: "_repliedTo",
              value: true,
              AttributionId: this.attributionRecord.ID,
              ByPE: this.envelopeByPE || this.contextPE,
              UpdateTime: oxygenUtil.getCurrentTime()
            }].concat(historyData.HistoryNotes ? historyData.HistoryNotes.filter(e => e.name !== "_repliedTo") : [])
          },
          this.client.Client,
          this.clientContext.GrantID || null,
          'History/Update'
      );

      await oxygenUtil.postHistoryMessage(
          {
            _id: historyData._id,
            _index: historyData._index,
            HistoryItem: {
              HistoryNotes: [{
                name: "_repliedTo",
                value: true,
                AttributionId: this.attributionRecord.ID,
                ByPE: this.envelopeByPE || this.contextPE,
                UpdateTime: oxygenUtil.getCurrentTime()
              }].concat(historyData.HistoryNotes ? historyData.HistoryNotes.filter(e => e.name !== "_repliedTo") : [])
            }
          },
          this.client.Client,
          this.clientContext.GrantID || null,
          'News/Update'
      );
    },
    async postHistoryMessage(historyData) {
      //console.log('postHistoryMessage', 'called');
      return await oxygenUtil.postHistoryMessage(historyData, this.client.Client, this.clientContext.GrantID || null)
    },
    toggleRibbon(item, event, ignoreIconList) {
      //console.log('arguments:', arguments);
      //console.log('toggleRibbon', 'item:', item);
      if (item.iconInfo.classes === this.toggleRibbonIconIds.expand) {
        //this.$refs.settingsRibbon.displayVerticalRibbonIcons(ignoreIconList);
        this.$nextTick(() => {
          this.$refs.settingsRibbon.expandRibbon();
        });
      } else {
        //this.$refs.settingsRibbon.removeVerticalRibbonIcons();
        this.$refs.settingsRibbon.collapseRibbon();
      }
      this.$refs.settingsRibbon.updateIconInfo(
          "toggle_ribbon",
          { type: "css", classes: `${(item.iconInfo.classes === this.toggleRibbonIconIds.expand) ? this.toggleRibbonIconIds.collapse :
                this.toggleRibbonIconIds.expand}`}
      );

    },
    setDirectedAlertData() {

    },
    async doRequestTask() {
      await this.doGrant('', this.lastTransactionId);
      this.resetMessageBox();
    },
    async shareModeCommit() {
      if(this.currentSimpleMode === 'request_task') {
        return this.doRequestTask();
      }
      async.waterfall([
        (callback) => {
          //if (this.bodyComponentProps.component) {
          if(this.showBodyComponent) {
            this.saveBodyComponent(callback)
          } else {
            callback();
          }
        },
        async () => {
          let PEs = await this.getChatRecipientPEs();
          console.log('shareModeCommit', 'PEs:', PEs);
//this.mainPanel.TypingChatEvent({data: this.getMessage()});

          if (PEs.length) {
            let BeginTime, EndTime;
            if (this.isScheduleSet()) {
              let scheduleTimes = this.getScheduleTimes();

              BeginTime = scheduleTimes.T1;
              EndTime = scheduleTimes.T2;
            }

            let insertIds = new Map();
            async.each(PEs, async (PE) => {
              let historyRow, emailRow, phoneRow, EventPath = '', newEventSubject, mainRow = {};
              if (typeof PE === "object") {

                if (PE.fromInbox) {
                  mainRow = historyRow = PE;
                } else if (PE.emailRow) {
                  mainRow = emailRow = PE.row;
                } else if (PE.phoneRow) {
                  mainRow = phoneRow = PE.row;
                }
                else {
                  mainRow = PE
                }
                 PE = PE.data.PE;
              }

              if (!this.componentData.eventSubjectText) {
                if (historyRow && historyRow.originalDataRow.data.EventPath) {
                  newEventSubject = EventPath = historyRow.originalDataRow.data.EventPath;
                }


              } else {
                if (historyRow && historyRow.originalDataRow.data.EventPath) {
                  EventPath = `${historyRow.originalDataRow.data.EventPath} / `;
                }
                newEventSubject = EventPath = `${EventPath}${this.componentData.eventSubjectText}`;
              }

              if (mainRow && newEventSubject) {
                mainRow.newEventSubject = newEventSubject;
              }

              //console.log('shareModeCommit', 'PE:', PE);
              //console.log('shareModeCommit', 'getMessageAttachment()):', this.getMessageAttachment());
              if (this.selectedModeButton.id === "alert") {
                await this.doAlert(PE, this.lastTransactionId);
              } else {
                if (this.getMessageAttachment()) {

                  await this.doGrant(PE, this.lastTransactionId, null, null);
                } else {
                  let historyItem = await this.postHistoryMessage(Object.assign({
                    PK: oxygenUtil.getGUID(),
                    FromPE: this.mainPanel.GatewayPE,
                    ToPE: PE,
                    GrantPE: PE,
                    ByPE: this.envelopeByPE || this.contextPE,
                    CredentialPE: this.CredentialPE,
                    AgentOfPE: this.mainPanel.AgentOfPE,
                    GatewayPE: this.mainPanel.GatewayPE,
                    //TransactionId: this.lastTransactionId,
                    Note: JSON.stringify({ String: (this.componentData.currentForwardedMessage && !Array.isArray(this.componentData.currentForwardedMessage))? this.createForwardedMessage() : this.getFullMessage(), Link: ''}),
                    EventLabel: 'Message',
                    EventTemplate: "_FFFFFFFFFFFFFF00001575595750910042_",
                    NoteTemplate: "MessageNoteTemplate-0056",
                    NoteTemplateID: "_FFFFFFFFFFFFFF00001633127893643639_",
                        AttributionId: this.attributionRecord.ID,
                        SessionId: oxygenUtil.Cookies.get('sessionId')
                  }, (BeginTime ? {BeginTime, EndTime} : {}),
                      (EventPath ? {EventPath} : {}), (historyRow ? {
                    CausingEventID: historyRow.originalDataRow.data.PK,
                    RootEventID: historyRow.originalDataRow.data.RootEventID } : {})
                  , this.getLocationData()));
                  if (emailRow) {
                      //console.log('shareModeCommit', 'inserting:', emailRow, ' - val:', historyItem.PK);
                      insertIds.set(emailRow, historyItem.PK);

                    }
                }
              }
            }, (error) => {
              if (!error) {
                //console.log('shareModeCommit', 'insertIds:', insertIds);
                this.emailMessages.forEach((e) => {
                  let insertId;
                  //console.log('shareModeCommit', 'checking for:', e.emailRow, ' - val:', insertIds.get(e.emailRow));
                  if (insertId = insertIds.get(e.emailRow)) {
                    e.causingEventId = insertId;
                  }
                  if (e.emailRow.newEventSubject) {
                    e.subject = e.emailRow.newEventSubject;
                  }
                  if (this.getMessageAttachment()) {
                    this.addMessageAttachmentInfo(e);
                  }
                });

                async.parallel([
                  async () => {
                    await oxygenUtil.sendEmailMessages(this.contextPE, this.emailMessages)
                  },
                  async () => {
                    await oxygenUtil.sendPhoneMessages(this.contextPE, this.phoneMessages, { ClientID: this.ClientID})
                  }
                ], (error) => {
                  if (!error) {
                    this.resetMessageBox();

                  }
                });
              }
            });
          } else {
            if (this.selectedModeButton.id === "requestLock") {
              this.requestLock();
            }
          }
        }
      ]);
    },
    getLocationData() {
      return (this.geolocation && this.geolocation.location) ? {
        Lat: this.geolocation.location.latitude,
        Long: this.geolocation.location.longitude,
        IPAddress: this.geolocation.traits.ip_address,
        City: this.geolocation.city.names.en,
        State: this.geolocation.postal.code,
        Country: this.geolocation.country.names.en,
        GeoIPLocation: JSON.stringify(this.geolocation)
      } : {};
    },
    addMessageAttachmentInfo(emailMessage) {
      emailMessage.emailAttachmentGrants = this.getMessageAttachment().map((attachment) => {
        return {
          grant: {
            fromPE: this.mainPanel.GatewayPE,
            fromGrantId: this.mainPanel.GatewayGrantId,
            byPE: this.envelopeByPE || this.contextPE,
            byGrantId: this.componentData.contextPEGrant.GrantID,
            CredentialPE: oxygenUtil.Cookies.get('credentialPE'),
            AgentOfPE: this.mainPanel.AgentOfPE,
            GatewayPE: this.mainPanel.GatewayPE,
            toPE: emailMessage.emailRow.data.PE,
            onObject: attachment.data.GrantRightID || (attachment.data.component.Node),
            onRole: attachment.roles.find(i => i.selected).role
          }, name: (attachment.data.GrantRightDN || attachment.data.component.DisplayName)
        }
      });
    },
    requestLock(callback) {
      this.mainPanel.sendAlert(
          "",
          "",
          {
            alertClientId: this.mainPanel.documentLockClient,
            alertMessage: this.getMessage(),
            header: 'Access Request',
            templateDN: this.mainPanel.config.nodeIds.templates.alerts.complexalert,
            approveButtons: ['Accept'],
            callbacks: {
              'Accept': [{
                clientCallbackFn: 'unsetDocumentLock',
                clientAddCallback: true
              }, {
                callbackFn: 'setDocumentLock',
                serverNodeId: this.mainPanel.component.Node,
                serverContainerId: this.parent.Y.app.getContainerId()
              }]
            }
          },
          callback
      );
      this.resetMessageBox();
    },
    resetMessageBoxGlobally() {
      this.setMessage('');
      this.componentData.messageBoxMode = '';
      this.componentData.currentCommand = '';
      this.componentData.lastReplyMessage = '';
      this.componentData.channelMessageSet = false;
      this.componentData.commandMode = false;
      this.componentData.homepageCurrentRoleAccount = '';
      this.componentData.homepageCurrentRoleAccounts = [];
      this.componentData.homepageAccountsMap = {};
      this.componentData.homepageRole = '';
      //this.componentData.homepageRoles = [];
      this.componentData.showHomepageRole  = false;
      this.componentData.currentForwardedMessage = null;
      this.componentData.showMessageBoxSubjectInput = true;
      this.componentData.showMessageBoxSubjectTable = false;
      this.componentData.showAgreementTitleTextbox = false;
      this.componentData.attachmentsSelectionFlag = false;
      this.componentData.replyAttachmentsSelectionFlag = false;
      this.componentData.replyInboxSelectionFlag = false;
      this.componentData.replyContactsSelectionFlag = false;
      this.componentData.eventSubjectText = '';
      this.componentData.eventSubjectPlaceholder = 'Subject';
      this.componentData.shareAsAdminFlag = false;
      this.$refs.menuTable.tableData.dataRows.forEach((e) => {
        if (e.searchComponent) {
          e.searchComponent.deselectRow(e.originalDataRow.path);
        }
      });
      this.$refs.menuTable.deletePathRows(this.recipientPathPrefix);
      this.$refs.attachmentsMenuTable.tableData.dataRows.forEach((e) => {
        if (e.attachmentsPanel) {
          e.attachmentsPanel.searchComponent.deselectRow(e.originalDataRow.path);
        }
      });
      //this.$refs.scheduleMenuTable.getRowAlt(this.startTimePath).dateTime = "";
      //this.$refs.scheduleMenuTable.getRowAlt(this.endTimePath).dateTime = "";
      if (this.componentData.showMessageBoxSchedule) {
        this.componentData.showMessageBoxSchedule = false;
        this.startTime = '';
        this.endTime = '';
        //this.scheduleClicked();
      }

      this.componentData.showMessageBoxScheduler = false;

      this.$refs.attachmentsMenuTable.resetTable();
      this.$refs.menuTable.resetTable();
      this.$refs.subjectMenuTable.resetTable();
      this.componentData.showMessageBoxAttachmentsList = false;
      this.componentData.showMessageBoxRecipientsTable = false;
      this.componentData.showMessageBoxSubjectTable = false;
      this.componentData.showMessageBoxRecipientsList = false;
      this.componentData.showTextarea = false;
      this.componentData.showInitialInput = true;
      this.componentData.textareaPlaceholder = 'Message';

//this.cancelButtonClicked();

      Object.keys(this.componentData.messageBoxModes).forEach(e => this.mainPanel.componentData[e] = false);
      this.mainPanel.componentData['messageBoxModeButtons'] = [];
      this.mainPanel.componentData['messageBoxModeButtons2'] = [];


      //this.$refs.menuTable.hideRow(this.recipientTextboxPath);
      this.componentData.showEventSubject = false;
      this.componentData.showSubject = false;

      let inbox;
      this.resetReplyIcon();

    },
    resetReplyIcon(path) {
      let inbox;
      if( (inbox = window.devStore.viewPorts.find(e => ((this.viewport.ClientID === e.ClientID)) && e.isInbox)))  {
        //console.log('resetReplyIcon', 'inbox:', inbox, ' - path:',  this.componentData.currentInboxFocusedMessage.path);
        oxygenUtil.callViewportFn(inbox.viewportID, 'resetReplyIcon',
            [(this.componentData.currentInboxFocusedMessage && this.componentData.currentInboxFocusedMessage.path) || '']);
        this.componentData.currentInboxFocusedMessage = '';
      }
    },
    removeAllRecipients() {
      this.$refs.menuTable.resetTable();
    },
    resetMessageBoxLocally() {
      this.textareaActivityFlag = false;
      if(this.$refs.agreementTitleInput) {
        this.$refs.agreementTitleInput._.data.inputVal = '';
      }

      if(this.$refs.subjectInput) {
        this.$refs.subjectInput.inputVal = '';
      }

      this.setHTMLContentButtonValue(false);

      this.currentSimpleMode = '';
      this.emailMessages = [];
      this.phoneMessages = [];
      this.resetBodyComponent();
      this.replyOptionsList.forEach((e) => {
        this.$refs.settingsRibbon && this.$refs.settingsRibbon.hideRibbonIcon(e);
      });





      if(this.$refs.initialInput) {
        this.$refs.initialInput.$el.parentElement.style.display = '';
        this.$refs.initialInput.$el.value = '';
      }


      //this.$refs.textarea.placeholder = 'Text. Email. Call. Meet. Share. Promise. Track.';

      this.simpleModeOptions.forEach((e) => {
        //this.uiMenu.showMenuItem(e[4]);
        //this.uiMenu.selectRow(e[4]);
        if(e[7]) {
          this.$refs.settingsRibbon && this.$refs.settingsRibbon.showRibbonIcon(e[2]);
        }

      });

      this.settingsOptions.forEach((e) => {
        //this.uiMenu.deselectMenuItem(e[4]);
        //this.uiMenu.hideMenuItem(e[4]);
        this.$refs.settingsRibbon && this.$refs.settingsRibbon.hideRibbonIcon(e[2]);
      });
      console.log('resetMessageLocally', 'ribbon:', this.$refs.settingsRibbon);
      this.$refs.settingsRibbon && this.$refs.settingsRibbon.hideRibbonIcon('switch_panel');
      this.$refs.settingsRibbon && this.$refs.settingsRibbon.hideRibbonIcon('cancel_send');
      //$(this.$refs.textarea).height('auto');
      //$(this.$refs.optionsSpan).height('42px');
    },
    cancelButtonClicked() {
      this.componentData.replyMode = false;
      this.componentData.botMode = false;
      this.componentData.commandMode = false;
      this.componentData.conversationMode = false;
      this.componentData.directBot = false;
      this.componentData.minimalMode = false;
      this.componentData.currentConversationRootThreadId = '';
      this.componentData.lastConversationMessageEventId = '';
      this.componentData.modeArgs = [];
      this.resetMessageBox(true);
    },
    resetMessageBox(cancelClicked) {
//this.embeddedMessageAttachment = null;
      this.componentData.textareaPlaceholder = 'Message';
      if(this.componentData.botMode || this.componentData.replyMode) {
        this.setMessage('');
        return ;
      }

      if(this.componentData.clientContactsMode === 'meeting') {
        this.$refs.menuTable.resetTable();
        this.setMessage('');
        return;
      }


      Object.keys(this.componentData.replyFlags).forEach((e)=>{
        this.componentData.replyFlags[e] = false;
        //this.uiMenu.deselectMenuItem(e);
      });




//this.parent.toggleMode(this.lastParentMode, false, ()=>{}, ()=>{});

      this.resetMessageBoxGlobally();
      this.resetMessageBoxLocally();

      window.devStore.viewPorts.filter(e => ((this.viewport.ClientID === e.ClientID)) && this.viewport.viewportID !== e.viewportID).forEach((e)=>{
        oxygenUtil.callMessageBoxFnWithReturn(e.viewportID, 'resetMessageBoxLocally', []);
      })
      /*
      [this.mainPanel, ...Object.values(this.mainPanel.childPanels)].forEach((panel) => {
        let fComp;
        if (fComp = panel.getFooterComponent()) {
          fComp.resetMessageBoxLocally();
        }
      });
      */
    },
    resetBodyComponent() {
      //$('#' + this.bodyComponentDivId).find('.vueWinBody').remove();
      if (this.bodyComponentProps.componentId && this.screenManager.allComponentInstances[this.bodyComponentProps.componentId]) {
        this.screenManager.allComponentInstances[this.bodyComponentProps.componentId].close(() => {
        });
      }
      this.bodyComponentProps.component = '';
      this.bodyComponentProps.componentId = '';
      this.showBodyComponent = false;
      this.htmlMessage = '';
      if(this.$refs.settingsRibbon) {
        this.$refs.settingsRibbon.hideRibbonIcon('save_body');
        this.$refs.settingsRibbon.hideRibbonIcon('saved_messages');
      }
    },
    addTemplateAttachment(dataRow, attachmentsPanel) {
      async.waterfall([
        /*
(callback) => {
let args = [ [dataRow].map(e =>({ id: e.data.GrantRightID, defaultRole: e.data.GrantRightR })), null, ["owner"], callback ];
this.parent.getAllComponentsRoles(...args);
},
(componentsRoles, callback) => {

*/
        (callback) => {
          let templatePrefix = this.parent.createSimplePartialOES(this.parent.parseOES(dataRow.leafRow.OES).segments.slice(0, -1));
          this.parent.runDBQuery({
            sql: `select distinct Action, Result, State from OxygenDatabase.GlobalBehaviours where ThreadID = ? and SubjectFFTTID like ?`,
            vals: [this.mainPanel.atComponent.Node, `${templatePrefix}%`]
          }, callback);
        },
        (behaviourResults, callback) => {
          //console.log('addTemplateAttachment', 'globalBehaviour-results:', behaviourResults);
          let actions = new Set(), results = new Set(), states = new Set();
          if (behaviourResults.length) {
            behaviourResults.forEach((e) => {
              actions.add(e.Action);
              results.add(e.Result);
              states.add(e.State);
            });
          }

          this.componentData.showMessageBoxAttachmentsList = true;
          this.$refs.attachmentsMenuTable.addRow({
            cols: [
              {
                registrantId: this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
                iconId: '_FFFFFFFFFFFFFF00001579202909427002_',
                callback: (dataRow, index, ev) => {

                }
              },
              {
                html: `<span style="font-size:${oxygenUtil.config.fontSize};">${oxygenUtil.encodeHTMLEntities(oxygenUtil.formatDN(dataRow.pathSegment))}</span>`,
                type: 'html',

              },
              {
                registrantId: this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
                iconId: this.iconIds.attachment,
                callback: (dataRow, index, ev) => {
                },
                styleObj: {
                  'color': 'black'
                }
              }
            ],
            backgroundColor: 'white',
            showCheckbox: true,
            showFolder: false,
            originalDataRow: dataRow,
            allActions: [...actions],
            allResults: [...results],
            allStates: [...states],
            isTemplateAttachment: true,
//data: dataRow.data,
            attachmentsPanel,
            path: `${dataRow.pathSegment}`,
            type: this.rowTypes.attachment,
//roles: componentsRoles[dataRow.data.GrantRightID],
            folderCol: {
              alt: {
                registrantId: this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
                iconId: this.iconIds.remove,
                callback: (dataRow) => {
                  this.$refs.attachmentsMenuTable.deleteRow(dataRow.originalDataRow.path);
                }
              }
            },
            secondRowComponent: this.templateAttachmentSecondRowComponent,
            secondRowProps: {},
            showSecondRow: true,
          });
          this.$nextTick(function () {
//this.$refs.attachmentsMenuTable.selectRow( `${dataRow.data.GrantID}`);
            callback();
          });
        }
      ], () => {
      });
    },
    addAttachment(dataRow, attachmentsPanel) {
      async.waterfall([
        (callback) => {
          let args = [[dataRow].map(e => ({
            id: e.data.GrantRightID,
            defaultRole: e.data.GrantRightR
          })), null, ["owner"], callback];
          this.parent.getAllComponentsRoles(...args);
        },
        (componentsRoles, callback) => {
          this.componentData.showMessageBoxAttachmentsList = true;
          this.$refs.attachmentsMenuTable.addRow({
            cols: [
              {
                registrantId: this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
                iconId: '_FFFFFFFFFFFFFF00001577153822886017_',
                callback: (dataRow, index, ev) => {
                  this.lastRoleClickEvent = ev;
                  this.showRoleMenu(dataRow.roles, {singleSelect: true});
                }
              },
              {
                html: `<span style="font-size:${oxygenUtil.config.fontSize};" >${oxygenUtil.encodeHTMLEntities(oxygenUtil.formatDN(dataRow.data.GrantRightDN))}</span>`,
                type: 'html',

              },
              {
                registrantId: this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
                iconId: this.iconIds.attachment,
                callback: (dataRow, index, ev) => {
                },
                styleObj: {
                  'color': 'black'
                }
              }
            ],
            backgroundColor: 'white',
            showCheckbox: true,
            showFolder: false,
            originalDataRow: dataRow,
            data: dataRow.data,
            attachmentsPanel,
            path: `${dataRow.data.GrantID}`,
            type: this.rowTypes.attachment,
            roles: componentsRoles[dataRow.data.GrantRightID],
            folderCol: {
              alt: {
                registrantId: this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
                iconId: this.iconIds.remove,
                callback: (dataRow) => {
                  this.$refs.attachmentsMenuTable.deleteRow(dataRow.path);
                }
              }
            }
          });
          this.$nextTick(function () {
//this.$refs.attachmentsMenuTable.selectRow( `${dataRow.data.GrantID}`);
            callback();
          });
        }
      ], () => {
      });
    },
    attachmentOptionsMenu(dataRow, index, event, target) {
      console.log('showEmailRecipientOptionsMenu', 'target:', target);
      this.simpleMenuOptions.length = 0;
      this.simpleMenuWidth = '350px';

      let options = [
        {
          icon: `far fa-link`,
          title: `Send As Smart Link`,
          callback: ()=>{
            dataRow.cols[2].html = `<span class="far fa-link"/>`;
            dataRow.smartLinkFlag = true;
          },
          path: '000-smartlink'
        }
      ];

      this.simpleMenuOptions.push(...options);

      this.$refs.simpleOptionsMenu.showMenuAlignedToElement(target, 'right', 'bottom');
    },
    attachSelectEvents(attachmentsPanel) {
      attachmentsPanel.searchComponent.$refs.menuTable.$on('row-selected', (dataRow, index) => {
        if (!dataRow.templateViewRow) {
          this.addAttachment(dataRow, attachmentsPanel);
        } else if (dataRow.templateViewLevel > 1) {
          this.addTemplateAttachment(dataRow, attachmentsPanel);
        }

      });

      attachmentsPanel.searchComponent.$refs.menuTable.$on('row-deselected', (dataRow, index) => {
        this.$refs.attachmentsMenuTable.deleteRow(dataRow.path);
        if (!this.$refs.attachmentsMenuTable.tableData.dataRows.length) {
          this.componentData.showMessageBoxAttachmentsList = false;
        }
      });
    },
    attachClicked() {
      this.parent.showNamedChildPanel('messageboxMessageAttachmentsView', this.parent.attachmentsViewType, Object.assign({
        panelTitle: "Select Message Attachment",
        noList: true,
        stopInitialSearch: true,
        _ignoreSelection: true
      }, {}), (attachmentsPanel) => {

        if (!attachmentsPanel.selectEventsAttached) {
          attachmentsPanel.selectEventsAttached = true;
          this.attachSelectEvents(attachmentsPanel);
        }
        let adminMode = true;
        attachmentsPanel.searchComponent.setSearchBarPlaceholder(`Search to Attach`)

        attachmentsPanel.setOwnerExclusion(true, () => {
        })
//attachmentsPanel.setSingleSelectValue(true);
        if (adminMode) {
          attachmentsPanel.setDirectoryWithCats('All', ['Grants']);
          attachmentsPanel.setAdminMode(() => {
            /*
attachmentsPanel.setSelectionMode(true, (attachments)=>{
console.log('attachClicked', 'attachments:', attachments);
this.embeddedMessageAttachment = attachments[0];
});

*/
          });
        } else {
          attachmentsPanel.searchDirectoryWithCats('All', ['Grants'], () => {
            /*
attachmentsPanel.setSelectionMode(true, (attachments)=>{
console.log('attachClicked', 'attachments:', attachments);
this.embeddedMessageAttachment = attachments[0];
});

*/
          });
        }
      });
    },
    scheduleClicked() {
      this.componentData.showMessageBoxSchedule = !this.componentData.showMessageBoxSchedule;
      if (this.componentData.showMessageBoxSchedule) {
        this.$refs.settingsRibbon.selectIcon('schedule');
      } else {
        this.$refs.settingsRibbon.unselectIcon('schedule');
      }
    },
    optionsClicked(event, icon) {
      this.optionsMenu.showAdjacent(event.currentTarget, this.parent);
    },
    selectMessageBoxMode(mode) {
      let modeArgs = {
        'send': this.setupSend.bind(this),
        'sms': this.setupSMS.bind(this),
        'forward': this.setupForward.bind(this),
        'link': this.setupLink.bind(this),
        'share_message': this.setupShareMessage.bind(this),
        'reply': this.setupReply.bind(this),
        'new': this.setupNewMessage.bind(this),
        'replace': this.setupReplaceMessage.bind(this),
        'train': this.setupReplaceMessage.bind(this),
        'send_schedule': this.setupShareSchedule.bind(this),
        'bot': this.setupBot.bind(this),
        'email': this.setupEmail.bind(this),
        'message': this.setupMessage.bind(this),
        'page': this.setupPage.bind(this),
        'invite': this.setupCall.bind(this),
        'offer': this.setupOffer.bind(this),
        'meet': this.setupMeet.bind(this),
        'promise': this.setupPromise.bind(this),
        'assign_homepage': this.setupAssignHomepage.bind(this),
        'remove_homepage': this.setupRemoveHomepage.bind(this),
        'agreement_offer': this.setupAgreementOffer.bind(this),
        'agreement_request': this.setupAgreementRequest.bind(this)
      }
      if(modeArgs.hasOwnProperty(mode)) {
        modeArgs[mode]();
      }
    },
    setupShareSchedule() {
      this.selectMode("send_component", this.componentData.messageBoxModes.sendMode.name, 'schedule');
    },
    setupAssignHomepage() {
      this.mainPanel.componentData.homepageAccountTitle = 'Account To Assign';
      this.mainPanel.componentData.showHomepageRole  = true;
      this.componentData.showMessageBoxRecipientsList = false;
      this.selectMode("homepage_assign_mode", "homepageAssignMode", 'assign_homepage');
    },
    setupRemoveHomepage() {
      this.mainPanel.componentData.homepageAccountTitle = 'Account To Remove';
      this.mainPanel.componentData.showHomepageRole  = true;
      this.componentData.showMessageBoxRecipientsList = false;
      this.selectMode("homepage_assign_mode", "homepageAssignMode", 'remove_homepage');
    },
    setupSend() {
      this.selectMode("send_component", this.componentData.messageBoxModes.sendMode.name, 'send');
    },
    setupForward() {
      this.selectMode("send_component", this.componentData.messageBoxModes.sendMode.name, 'forward');
    },
    setupLink() {
      this.selectMode("send_component", this.componentData.messageBoxModes.sendMode.name, 'link');
    },
    setupShareMessage(shareAsAdmin) {
      this.componentData.shareAsAdminFlag = !!shareAsAdmin;
      this.selectMode("send_component", this.componentData.messageBoxModes.sendMode.name, 'share_message');
    },
    setupNewMessage() {
      this.selectMode("send_component", this.componentData.messageBoxModes.sendMode.name, 'new');
    },
    setupReplaceMessage(trainFlag) {
      if(trainFlag) {
        this.selectMode("send_component", this.componentData.messageBoxModes.sendMode.name, 'train');
      }
      else {
        this.selectMode("send_component", this.componentData.messageBoxModes.sendMode.name, 'replace');
      }

    },
    setupReply() {
      this.selectMode("send_component", this.componentData.messageBoxModes.sendMode.name, 'reply');
      this.componentData.showMessageBoxSubjectInput = false;
      this.componentData.showMessageBoxRecipientsTable = false;
    },
    setupSMS() {
      this.selectMode("send_component", this.componentData.messageBoxModes.sendMode.name, 'sms');
      //this.$refs.menuTable.getRow(this.recipientTextboxPath).checkboxCol.alt.props.placeholder = 'Phone Number';
      this.recipientsListTextboxProps.placeholder = 'Phone Number';

    },
    setupBot() {
      this.selectMode("send_component", this.componentData.messageBoxModes.sendMode.name, 'bot');
    },
    setupEmail() {
      this.selectMode("send_component", this.componentData.messageBoxModes.sendMode.name, 'email');
//if(this.recipientsListTextboxProps) {
      //this.$refs.menuTable.getRowAlt(this.recipientTextboxPath).checkboxCol.alt.props.placeholder = 'Email';
      this.recipientsListTextboxProps.placeholder = 'Email';
//this.componentData.showEventSubject = true;
//    this.recipientsListTextboxProps.placeholder = 'Email';
//}
    },
    setupOfferTask() {
      this.selectMode("share_mode", "shareMode", 'offer_task');
    },
    setupRequestTask() {
      this.selectMode("share_mode", "shareMode", 'request_task');
      this.componentData.showMessageBoxRecipientsList = false;
    },
    setupMessage() {
      this.selectMode("send_component", this.componentData.messageBoxModes.sendMode.name, 'message');
    },
    setupPage() {
      this.selectMode("invitemodalid", this.componentData.messageBoxModes.meetingMode.name, 'page');
    },
    setupCall() {
      this.selectMode("invitemodalid", this.componentData.messageBoxModes.meetingMode.name, 'invite');
    },
    setupOffer() {
      this.selectMode("share_mode", this.componentData.messageBoxModes.shareMode.name, 'offer');
    },
    setupShare() {
      this.selectMode("share_mode", this.componentData.messageBoxModes.shareMode.name, 'share');
    },
    setupRequest() {
      this.selectMode("share_mode", this.componentData.messageBoxModes.shareMode.name, 'request');
    },
    setupTaskOffer() {
      this.selectMode("share_mode", this.componentData.messageBoxModes.shareMode.name, 'offer');
    },
    setupTaskRequest() {
      this.selectMode("share_mode", this.componentData.messageBoxModes.shareMode.name, 'request');
    },
    setupRequestContact() {
      this.selectMode("contact_mode", this.componentData.messageBoxModes.contactsMode.name, 'request_contact');
    },
    setupOfferContact() {
      this.selectMode("contact_mode", this.componentData.messageBoxModes.contactsMode.name, 'offer_contact');
    },
    setupAgreementOffer() {
      this.selectMode("agreement_mode", this.componentData.messageBoxModes.agreementMode.name, 'agreement_offer');
    },
    setupAgreementRequest() {
      this.selectMode("agreement_mode", this.componentData.messageBoxModes.agreementMode.name, 'agreement_request');
    },
    setupMeet() {
      this.selectMode("invitemodalid", this.componentData.messageBoxModes.meetingMode.name, 'meet');
    },
    setupPromiseOffer() {
      this.componentData.showAgreementTitleTextbox = true;
      this.componentData.showMessageBoxRecipientsList = true;
      this.selectMode("promise_mode", this.componentData.messageBoxModes.promiseMode.name, 'promise_offer');
    },
    setupPromiseRequest() {
      this.componentData.showAgreementTitleTextbox = true;
      this.componentData.showMessageBoxRecipientsList = true;
      this.selectMode("promise_mode", this.componentData.messageBoxModes.promiseMode.name, 'promise_request');
    },

    addModeRibbonIcons() {

      this.modeRibbonIcons = [
        {
          id: 'ui_menu', iconId: this.iconIds.UIMenu, fn: () => {
          }
        },
        /*{ id: 'send', iconId: this.iconIds.setupSend,
fn: this.setupSend.bind(this), reg: this.parent.config.dynamodb.tables.uiElements.registrants.basicvuewindowcomponent },*/
        {id: 'message', iconId: this.iconIds.message, fn: this.sendMessage.bind(this)},
        {id: 'email', iconId: this.iconIds.email, fn: this.sendEmail.bind(this)},
//{ id: 'schedule', iconId: this.iconIds.setupSchedule, fn: this.setupSchedule.bind(this) },

        {id: 'page', iconId: this.iconIds.page, fn: this.sendPage.bind(this)},
        {id: 'invite', iconId: this.iconIds.call, fn: this.setupCall.bind(this)},
        {id: 'meet', iconId: this.iconIds.meet, fn: this.setupMeet.bind(this)},
        {id: 'promise', iconId: this.iconIds.promise, fn: this.setupPromise.bind(this)},
        {id: 'offer', iconId: this.iconIds.offer, fn: this.setupOffer.bind(this)}
      ];
      this.modeRibbonIcons.forEach((e) => {
        //id, iconInfo, callback, tooltip, show, position
        this.$refs.modeRibbon.addLeftRibbonIcon(
            e.id,
            { type: 'css', classes: e.iconId },
            fn
        );

        /*
        this.$refs.modeRibbon.addRegisteredUIElement(
            this.parent.config.uiElements.registrants[e.reg || this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow][e.iconId],
            {fn: e.fn, id: e.id, type: this.parent.config.uiElements.types.lefticon, show: true},
            undefined,
            undefined,
            e.reg || this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
            e.iconId
        );

         */
      })

      this.$refs.modeRibbon.addRightRibbonIcon(
          "options",
          { type: "css", classes: this.iconIds.options },
          ()=>{}
      );

      /*
      this.$refs.modeRibbon.addRegisteredUIElement(
          this.parent.config.uiElements.registrants[this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow][this.iconIds.options],
          {
            fn: () => {
            }, id: "options", type: this.parent.config.uiElements.types.righticon, show: true
          },
          undefined,
          undefined,
          this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.options
      );

       */
      this.$nextTick(function () {
        this.selectMode("send_component", this.parent.componentData.messageBoxModes.contactsMode.name, 'send');
      });
    },
    toggleMode(modeName, setMode, modeFn, callback) {
      //console.log('toggleMode', 'modeName:', modeName, ' - this.mainPanel.componentData[modeName]:', this.mainPanel.componentData[modeName]);
      if(!this.mainPanel.componentData[modeName] || setMode) {

        Object.keys(this.componentData.messageBoxModes).filter(e => e !== modeName).forEach(e => this.mainPanel.componentData[e] = false);
        this.$nextTick(()=>{
          this.mainPanel.componentData[modeName] = true;
          this.componentData.messageBoxModeButtons = this.mainPanel.componentData[this.componentData.messageBoxModes[modeName].buttons];
          if(this.componentData.messageBoxModes[modeName].buttons2) {
            this.componentData.messageBoxModeButtons2 = this.mainPanel.componentData[this.componentData.messageBoxModes[modeName].buttons2];
          }
          else {
            this.componentData.messageBoxModeButtons2 = [];
          }
          //this.showActivityChatPanel(()=>{
          modeFn( ()=>{
            if(callback) {
              callback();
            }
          });
        });
      }
      else {
        this.mainPanel.componentData[modeName] = false;

        //panel.unsetChatMode();
        if(callback) {
          callback();
        }
      }
    },
    selectModeGlobally(parentId, parentMode, mode) {
      this.componentData.showTextarea = true;
      this.componentData.modeArgs = [parentId, parentMode, mode];
      this.componentData.messageBoxMode = mode;
      if (!this.componentData.messageBoxStateInitialized) {
        this.$nextTick(function () {
          //console.log('selectModeGlobally', 'setting replyRecipients to true');
          this.componentData.replyFlags['replyRecipients'] = true;
        });
        this.componentData.messageBoxStateInitialized = true;
      }

      if(!Object.values(this.componentData.replyFlags).some(e => e)) {
        this.componentData.replyFlags['replyRecipients'] = true;
      }
      //this.componentData.replyFlags['replyRecipients'] = true;

      this.componentData.messageBoxModes[parentMode].default = mode;
      this.toggleMode(parentMode, true, (callback) => { callback();
      }, () => {
        //console.log('setInitialContextRecipients', 'buttons', this.componentData.messageBoxModeButtons);
        this.$nextTick(()=>{
          this.setInitialContextRecipients();

        })
      });
      /*
      let row;
      if (row = this.parent.mainUIMenu.getRowAlt(`${parentId}/${mode}`)) {
        this.parent.mainUIMenu.selectedMenuItemRow = row;
        this.componentData.messageBoxModes[parentMode].default = this.parent.mainUIMenu.selectedMenuItemRow.data.id;
        this.parent.toggleMode(parentMode, true, () => {
        }, () => {
        });
      } else {
        this.componentData.messageBoxModes[parentMode].default = mode;
        this.parent.toggleMode(parentMode, true, () => {
        }, () => {
        });
      }

       */

      this.componentData.showEventSubject = true;
      this.componentData.showSubject = !(this.componentData.clientContactsMode === 'meeting') && !this.componentData.minimalMode && true;

      this.$nextTick(function () {
        //this.setPriorityRecipients();

      });

    },
    selectModeLocally(parentId, parentMode, mode) {

      this.currentSimpleMode = mode;
      this.lastParentMode = parentMode;

      this.$refs.settingsRibbon && this.$refs.settingsRibbon.showRibbonIcon('switch_panel');

      //console.log('selectModeLocally', 'setting placeholder as message');
      //this.componentData.textareaPlaceholder =  'Message';
      //this.componentData.textareaPlaceholder = this.co;
      //window.__initInput = this.$refs.initialInput;
      if(this.$refs.initialInput) {
        this.$refs.initialInput.$el.parentElement.style.display = 'none';
      }


      this.componentData.showInitialInput = false;
      //this.$refs.textarea.placeholder = 'Message';
      //this.replyOptionsUIMenu.selectRow('replyRecipients');

      if (this.componentData.replyFlags['replyRecipients']) {
        this.componentData.showMessageBoxRecipientsList = !(this.componentData.clientContactsMode === 'meeting') && !this.componentData.minimalMode && true;
        //this.$refs.menuTable.showRow(this.recipientTextboxPath);
      }

      if(this.$refs.settingsRibbon) {
        this.$refs.settingsRibbon.showRibbonIcon('cancel_send');
        this.$refs.settingsRibbon.showRibbonIcon('save_body');
        this.$refs.settingsRibbon.showRibbonIcon('saved_messages');


        this.simpleModeOptions.forEach((e) => {
          //this.uiMenu.deselectMenuItem(e[4]);
          //this.uiMenu.hideMenuItem(e[4]);
          this.$refs.settingsRibbon.hideRibbonIcon(e[2]);
        });
      }



      let defaultSelectedItems = [];/*.concat(
          (this.parent === this.mainPanel) ? [] : ['show_threadsubject'],
          (this.parent._isInbox) ? [] : ['show_inbox'],
          (this.parent._templateName === "ContactsMediaRoomClient-0055") ? [] : ['show_contacts'],
          (this.parent._templateName === this.parent.attachmentsViewType) ? [] : ['show_attachments'],
          (this.parent._templateName === "MediaRoomClient-0054") ? [] : ['show_media']
//,
//[ 'saved_template']
      );*/

      if (mode !== 'email' && mode !== 'sms') {
        //this.$refs.menuTable.getRow(this.recipientTextboxPath).checkboxCol.alt.props.placeholder = 'Name, Phone or Email';
      }
      this.$nextTick(function () {
        this.settingsOptions.forEach((e) => {
          //this.uiMenu.showMenuItem(e[4]);
          if(e[8]) {
            if(this.$refs.settingsRibbon) {
              this.$refs.settingsRibbon.showRibbonIcon(e[2]);
            }

          }
        });


        defaultSelectedItems.forEach((e) => {

          this.uiMenu.selectRow(e);
        });

      });

    },
    selectMode(...args) {
      if(this.componentData.clientContactsMode === 'meeting') {
        this.componentData.showMessageBoxRecipientsList = false;
      }
          //console.log('selectMode', 'args:', args);
      this.selectModeGlobally(...args);
      this.selectModeLocally(...args);

      window.devStore.viewPorts.filter(e => ((this.viewport.ClientID === e.ClientID)) && this.viewport.viewportID !== e.viewportID).forEach((e)=>{
        oxygenUtil.callMessageBoxFnWithReturn(e.viewportID, 'selectModeLocally', args);
      })
      /*
      [this.mainPanel, ...Object.values(this.mainPanel.childPanels)].forEach((panel) => {
        let fComp;
        if (fComp = panel.getFooterComponent()) {
          fComp.selectModeLocally(...args);
        }
      });

       */


      /*
if(this.currentSimpleMode) {
this.$refs.modeRibbon.unselectIcon(this.currentSimpleMode);
this.$refs.sendRowRibbon.hideRibbonIcon(this.currentSimpleMode);
}

*/


      /*
this.settingsOptions.forEach((e)=>{
this.uiMenu.showMenuItem(e);
this.uiMenu.selectRow(e);
});

*/


//this.$refs.modeRibbon.selectIcon(mode);
//this.$refs.sendRowRibbon.setRibbonIconColor(mode, '#0072C5')
//this.$refs.sendRowRibbon.showRibbonIcon(mode);


//if(mode !== 'email') {
//    this.componentData.showEventSubject = false;
//}

    },
    setInitialContextRecipients() {
      //console.log('setInitialContextRecipients', 'called');
      if (this.isPhoneMode() && this.initialContextPhones.length) {
        this.initialContextPhones.forEach((e) => {
          this.addPhone(oxygenUtil.parsePhone(e, 'US'), this.$refs.menuTable);
        });
      } else if (this.isEmailMode() && this.initialContextEmails.length) {
        this.initialContextEmails.forEach((e) => {
          this.addEmail(e, this.$refs.menuTable);
        });
      }
    },
    setPriorityRecipients() {
      if (this.isPhoneMode() && Array.isArray(this.componentData.priorityConfig.phoneNums) && this.componentData.priorityConfig.phoneNums.length) {
        this.componentData.priorityConfig.phoneNums.forEach((e) => {
          this.addPhone(window.libphonenumber.parsePhoneNumberFromString(e, 'US').format('E.164'), this.$refs.menuTable);
        });
      } else if (this.isEmailMode() && Array.isArray(this.componentData.priorityConfig.emails) && this.componentData.priorityConfig.emails.length) {
        this.componentData.priorityConfig.emails.forEach((e) => {
          this.addEmail(e, this.$refs.menuTable);
        });
      }
    },
    isPhoneMode() {
      //console.log('isPhoneMode', 'this.selectedModeButton:', this.selectedModeButton);
      return (this.selectedMode === 'meetingMode' ||
          (this.selectedMode === 'sendMode' && this.selectedModeButton.id === 'sms'));
    },
    isEmailMode() {
      return (this.selectedMode === 'sendMode' && this.selectedModeButton.id === 'email');
    },
    addSettingsRibbonIcons() {
      this.$refs.settingsRibbon.addLeftRibbonIcon(
          "ui_menu",
          { type: "css", classes: this.iconIds.UIMenu },
          this.showUIMenu.bind(this),
          "Send Menu"
      );



      let replyOptions = [
        /*[
this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
this.iconIds.reply,
"reply",
this.setReplyIcon.bind(this, 'reply'),
"reply",
{},
this.$refs.settingsRibbon
],*/
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
          this.iconIds.replyAll,
          "replyAll",
          this.setReplyIcon.bind(this, 'replyAll'),
          "replyAll",
          {},
          this.$refs.settingsRibbon,
          {
            menuIcon: true,
            group: this.replyOptionsList
          }
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
          this.iconIds.replyRole,
          "replyRole",
          this.setReplyIcon.bind(this, 'replyRole'),
          "replyRole",
          {},
          this.$refs.settingsRibbon,
          {
            menuIcon: true,
            group: this.replyOptionsList
          }
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
          this.iconIds.replySelf,
          "replySelf",
          this.setReplyIcon.bind(this, 'replySelf'),
          "replySelf",
          {},
          this.$refs.settingsRibbon,
          {
            menuIcon: true,
            group: this.replyOptionsList
          }
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
          this.iconIds.replyBot,
          "",
          this.setReplyIcon.bind(this, 'replyBot'),
          "replyBot",
          {},
          this.$refs.settingsRibbon,
          {
            menuIcon: true,
            group: this.replyOptionsList
          }
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
          this.iconIds.replySelect,
          "replySelect",
          this.setReplyIcon.bind(this, 'replySelect'),
          "replySelect",
          {},
          this.$refs.settingsRibbon,
          {
            showFolder: true,
            group: this.replyOptionsList
          }
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.replyRecipients,
          "replyRecipients",
          this.setReplyIcon.bind(this, 'replyRecipients'),
          "replyRecipients",
          {},
          this.$refs.settingsRibbon,
          {
            menuIcon: true,
            group: this.replyOptionsList
          }
        ],
      ];
      let selectMenuChildren = {
        replySelect: [
          ['<span>Contacts</span>', 'replySelect/contacts', {}, (...args)=>{
            this.selectContactsClicked(...args);
          } , () => {
          }, () => {
          }, {show: false}],
          ['<span>Inbox</span>', 'replySelect/inbox', {}, (...args)=> {
            this.selectInboxClicked(...args);}, () => {
          }, () => {
          }, {show: false}],
          ['<span>Attachments</span>', 'replySelect/attachments', {}, (...args)=> {
            //console.log('')
            this.selectAttachmentsClicked(...args); }, () => {
          }, () => {
          }, {show: false}]
        ]
      };

      /*
      replyOptions.forEach((e) => {
        this.replyOptionsUIMenu.addRegisteredIconItem(...e)
        if (selectMenuChildren[e[2]]) {
          selectMenuChildren[e[2]].forEach(e => this.replyOptionsUIMenu.addMenuItem(...e));
        }
      });

       */

      this.$refs.settingsRibbon.addRightRibbonIcon(
          "cancel_send",
          {type: "css", classes: `${this.iconIds.cancel} red-color`},
          this.cancelButtonClicked.bind(this),

          "Cancel",
          false
      )

      this.$refs.settingsRibbon.addRightRibbonIcon(
          "hide_header_mbox",
          {type: "css", classes: `far fa-eye-slash`},
          ()=>{
            this.showMessageBox = false;
            window.oxygenUtil.callViewportHeaderFnWithReturn(this.viewportID, 'hideHeader', []);
          },

          "Hide Header & MessageBox",

      )


      this.$nextTick(function () {
        //this.$refs.settingsRibbon.setRibbonIconColor('cancel_send', 'red');
      });


      this.$refs.settingsRibbon.addRightRibbonIcon(
          "toggle_ribbon",
          {type: "css", classes: this.toggleRibbonIconIds.expand},
          this.toggleRibbon.bind(this),
          "Toggle"
      );

      this.$refs.settingsRibbon.addRightRibbonIcon(
          "show_help",
          {type: "css", classes: this.iconIds.help},
          ()=>{},
          "Help"
      );


      this.$refs.settingsRibbon.addRightRibbonIcon(
          "save_body",
          {type: "css", classes: this.iconIds.saveAsTemplate},
          this.saveBodyClicked.bind(this),
          "Save Message",
          false
      );

      this.$refs.settingsRibbon.addRightRibbonIcon(
          "saved_messages",
          {type: "css", classes: "fal fa-input-text"},
          this.showSavedMessagesList.bind(this),
          "Retrieve Saved Messages",
          false
      );



      this.simpleModeOptions = [

        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.send,
          "send",
          this.setupSend.bind(this),
          "send",
          {},
          this.$refs.settingsRibbon,
            true
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.sms,
          "sms",
          this.setupSMS.bind(this),
          "sms",
          {},
          this.$refs.settingsRibbon,
          false
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.email,
          "email",
          this.setupEmail.bind(this),
          "email",
          {},
          this.$refs.settingsRibbon,
          false
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.call,
          "invite",
          this.setupCall.bind(this),
          "invite",
          {},
          this.$refs.settingsRibbon,
          false
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.meet,
          "meet",
          this.setupMeet.bind(this),
          "meet",
          {},
          this.$refs.settingsRibbon,
          false
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.offer,
          "offer",
          this.setupOffer.bind(this),
          "offer",
          {},
          this.$refs.settingsRibbon,
          false
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.share,
          "share",
          this.setupShare.bind(this),
          "share",
          {},
          this.$refs.settingsRibbon,
          false
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.share,
          "share Schedule",
          this.setupShareSchedule.bind(this),
          "share_schedule",
          {},
          this.$refs.settingsRibbon,
          false
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.request,
          "request",
          this.setupRequest.bind(this),
          "request",
          {},
          this.$refs.settingsRibbon,
          false
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.request,
          "request Contact",
          this.setupRequestContact.bind(this),
          "request_contact",
          {},
          this.$refs.settingsRibbon,
          false
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.offer,
          "offer Contact",
          this.setupOfferContact.bind(this),
          "offer_contact",
          {},
          this.$refs.settingsRibbon,
          false
        ],

        /*[
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.promise,
          "promise Offer",
          this.setupPromiseOffer.bind(this),
          "promise_offer",
          {},
          this.$refs.settingsRibbon,
          false
        ],*/
        /*[
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.promise,
          "promise Request",
          this.setupPromiseRequest.bind(this),
          "promise_request",
          {},
          this.$refs.settingsRibbon,
          false
        ],*/
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.page,
          "page",
          this.setupPage.bind(this),
          "page",
          {},
          this.$refs.settingsRibbon,
          false
        ]
      ];

      if(this.isAdminRole()) {
        this.simpleModeOptions.push([
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.homepage,
          "assign Homepage",
          this.setupAssignHomepage.bind(this),
          "assign_homepage",
          {},
          this.$refs.settingsRibbon,
          false
        ]);

        this.simpleModeOptions.push([
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.homepage,
          "Remove Homepage",
          this.setupRemoveHomepage.bind(this),
          "remove_homepage",
          {},
          this.$refs.settingsRibbon,
          false
        ]);
      }



      this.simpleModeOptions.forEach((e, index) => {
        //this.uiMenu.addRegisteredIconItem(...e)
        //console.log('addSettingsRibbonIcons', 'e:', e);
        if(!index) {

          this.$refs.settingsRibbon.addLeftRibbonIcon(
              "help_message",
              { type: "html", html: `<i style="font-size:7.5px;">Click &nbsp;<span style="cursor:auto;" class="${this.iconIds.UIMenu}"></span>&nbsp;for more SmartDesk Options</i>` },
              ()=> {

              }
          );

          this.$refs.settingsRibbon.addLeftRibbonIcon(
              "open_inbox",
              { type: "css", classes: this.iconIds.inbox },
              ()=> {
                this.showChildViewport('showInbox');
              },
              "Show Inbox"
          );

          this.$refs.settingsRibbon.addLeftRibbonIcon(
              "session_bot_mode",
              { type: "css", classes: "far fa-robot" },
              ()=> {
                this.setSessionBotMode();
              },
              "Smart Agent"
          );
        }

        this.$refs.settingsRibbon.addLeftRibbonIcon(
            e[2],
            (typeof e[1] === "object") ?
                { type: "html", html: e[1].html} :
                { type: "css", classes: e[1] },
            e[3],
            oxygenUtil.capitalizeFirstLetter(e[2]),
            e[7]
        );



      });





      this.$nextTick(function () {
        /*
        this.simpleModeOptions.forEach((e) => {
          this.uiMenu.selectRow(e[4]);
        })

         */
      });

      this.settingsOptions = [
        [
          '0001-reply',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: `${this.componentData.currentReplyIcon}`},
          "reply",
          (data, dataRow, index, menuTable)=>{
            if(!dataRow.selected) {
              menuTable.folderClick(dataRow, index);
            }
          },
          "reply",
          {},
          this.$refs.settingsRibbon,
            "Reply Options",
          false,
            false
        ],
        [
          '0001-reply/0001-replyAll',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: ` ${this.iconIds.replyAll}`},
          "replyAll",
          (...args)=>{
            this.setReplyIcon('replyAll');
            //this.replyIconClick(...args);
            this.setReplyIcon('replyAll');
          },
          "replyAll",
          {},
          this.$refs.settingsRibbon,
          "All",
          false,
          true
        ],
        [
          '0001-reply/0002-replyRole',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: ` ${this.iconIds.replyRole}`},
          "replyRole",
          (...args)=>{
            //this.replyIconClick(...args);
            this.setReplyIcon('replyRole');
          },
          "replyRole",
          {},
          this.$refs.settingsRibbon,
          "Selected Role",
            false,
          true
        ],
        [
          '0001-reply/0003-replySelf',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: ` ${this.iconIds.replySelf}`},
          "replySelf",
          (...args)=>{
            //this.replyIconClick(...args);
            this.setReplyIcon('replySelf');
          },
          "replySelf",
          {},
          this.$refs.settingsRibbon,
          "Self",
          false,
          true
        ],
        [
          '0001-reply/0004-replyBot',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: ` ${this.iconIds.replyBot}`},
          "replyBot",
          (...args)=>{
            //this.replyIconClick(...args);
            this.setReplyIcon('replyBot');
          },
          "replyBot",
          {},
          this.$refs.settingsRibbon,
          "Reply Bot",
          false,
          true
        ],
        [
          '0001-reply/0005-replySelect',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: ` ${this.iconIds.replySelect}`},
          "replySelect",
          (data, dataRow, index, menuTable)=>{
            menuTable.folderClick(dataRow, index)
          },
          "replySelect",
          {},
          this.$refs.settingsRibbon,
          "Selected Recipients",
          false,
          false
        ],
        [
          '0001-reply/0005-replySelect/0001-inbox',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: ` ${this.iconIds.inbox}`},
          "replySelectInbox",
          (...args)=>{
            //this.replyIconClick(...args);
            //this.selectInboxClicked(...args);
            this.replyIconClick(...args);
          },
          "replySelectInbox",
          {},
          this.$refs.settingsRibbon,
          "Inbox",
          false,
          true
        ],
        [
          '0001-reply/0005-replySelect/0002-attachments',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: ` ${this.iconIds.attachments}`},
          "replySelectAttachments",
          (...args)=>{
            //console.log('MessageBox', 'selectedAttachmentsClicked');
            //this.selectAttachmentsClicked(...args);
            this.replyIconClick(...args);
          },
          "replySelectAttachments",
          {},
          this.$refs.settingsRibbon,
          oxygenUtil.config.attachmentsTitle,
          false,
          true
        ],
        [
          '0001-reply/0005-replySelect/0003-live-contacts',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: ` ${this.iconIds.contacts}`},
          "replySelectLiveContacts",
          (...args)=>{
            //this.selectLiveContactsClicked(...args);
            this.replyIconClick(...args);
          },
          "replySelectLiveContacts",
          {},
          this.$refs.settingsRibbon,
          "Live Contacts",
          false,
          true
        ],
        [
          '0001-reply/0005-replySelect/0004-contacts',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: ` ${this.iconIds.contacts}`},
          "replySelectContacts",
          (...args)=>{
            //this.selectContactsClicked(...args);
            this.replyIconClick(...args);
          },
          "replySelectContacts",
          {},
          this.$refs.settingsRibbon,
          "Contacts",
          false,
          true
        ],
        [
          '0001-reply/0006-replyRecipients',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: ` ${this.iconIds.replyRecipients}`},
          "replyRecipients",
          (...args)=>{
            //console.log('MessageBox', 'replyRecipients clicked');
            this.replyIconClick(...args);
          },
          "replyRecipients",
          {},
          this.$refs.settingsRibbon,
          "To List",
          false,
          true
        ],

        [
          '0002-threadsubject',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.threadSubject,
          "show_threadsubject",
          ()=>{},
          //this.parent.showThreadSubjectPanel.bind(this.parent),
          "show_threadsubject",
          {},
          this.$refs.settingsRibbon,
            "Show Thread/Subject",
          false,
          true
        ],
        [
          '0003-inbox',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: this.iconIds.inbox},
          "show_inbox",
          ()=>{
            this.showChildViewport('showInbox');
          },
          //this.parent.showInboxPanel.bind(this.parent),
          "show_inbox",
          {},
          this.$refs.settingsRibbon,
            "Show Inbox",
          false,
          true
        ],
        [
          '0004-contacts',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: this.iconIds.contacts},
          "show_contacts",
          ()=>{
            this.showChildViewport('showContacts')
          },
          //this.parent.showContacts.bind(this.parent),
          "show_contacts",
          {},
          this.$refs.settingsRibbon,
            "Show Contacts",
          false,
          true
        ],
        [
          '0005-attachments',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: this.iconIds.attachments},
          "show_attachments",
          ()=>{
            this.showChildViewport('showAttachments');
          },
          //this.parent.showAttachments.bind(this.parent),
          "show_attachments",
          {},
          this.$refs.settingsRibbon,
            `Show ${oxygenUtil.config.attachmentsTitle}`,
          false,
          true
        ],
        [
          '0006-contenttemplate',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: this.iconIds.attachments},
          "set_content_template",
          ()=>{
            this.showContentTemplateSelectionForm()
          },
          //this.parent.showAttachments.bind(this.parent),
          "set_content_template",
          {},
          this.$refs.settingsRibbon,
          "Select Content Template",
          false,
          true
        ]
        /*,
        [
          '0006-media',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: this.iconIds.media},
          "show_media",
          ()=>{},
          //this.parent.showMainMediaPanel.bind(this.parent),
          "show_media",
          {},
          this.$refs.settingsRibbon,
            "Show Media",
          true
        ],*/
        /*[
this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
this.iconIds.savedTemplate,
"saved_template",
this.savedTemplateClicked.bind(this),
"saved_template",
{},
this.$refs.settingsRibbon
],*/
        /*[
this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
this.iconIds.attach,
"attach",
()=> {
this.attachmentMenu.showAdjacent(this.$refs.settingsRibbon.getRibbonIconElement("attach"), this.parent);
},
"attach",
{},
this.$refs.settingsRibbon
],*/
        /*[
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: this.iconIds.schedule},
          "schedule",
          this.scheduleClicked.bind(this),
          "schedule",
          {},
          this.$refs.settingsRibbon,
            "Schedule",
          false
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: this.iconIds.link},
          "link",
          () => {
          },
          "link",
          {},
          this.$refs.settingsRibbon,
            "Link",
          false
        ],
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          { type: 'css', classes: this.iconIds.save},
          "save",
          () => {
            this.showSaveOptionsForMessage();
          },
          "save",
          {},
          this.$refs.settingsRibbon,
        ]*/
        /*,
        [
          '',//this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
          this.iconIds.advanced,
          "advanced",
          () => {
            //this.parent.showAdvancedSendPanel(this.selectedModeButton ? this.selectedModeButton.id : 'send');
          },
          "advanced",
          {},
          this.$refs.settingsRibbon
        ]*/
      ]

      this.settingsOptions.forEach((e) => {
        //this.uiMenu.addRegisteredIconItem(...e);
        //console.log(`adding ${e[2]}`);
        this.$refs.settingsRibbon.addLeftRibbonIcon(
            e[2],
            e[1],
            e[3],
            e[7],
            e[8]
        );
      });

      window.__messageBox = this;
      let currentViewport = window.devStore.rootMenu.find(e => e.ViewPortID === this.viewportID);
      let isInbox = currentViewport.Path.endsWith('/Inbox');
      console.log('addSettingsRibbonIcons', 'viewport:', currentViewport);
      console.log('addSettingsRibbonIcons', 'isInbox:', isInbox);
      this.$refs.settingsRibbon.addLeftRibbonIcon(
          "switch_panel",
          isInbox ? { type: "html", html: `<span class="icon-thread16-simplia"></span>` } :
              { type: "css", classes: `fal fa-inbox` },
          async ()=>{
            if(isInbox) {
              let rootMenuItem = window.devStore.rootMenu.find(e => e.ViewPortID === oxygenUtil.getMainViewportIDFromClient(this.client.Client));
              console.log('switch_panel-callback', 'viewportId:',rootMenuItem.ViewPortID);
              //oxygenUti.putViewportOnTop(rootMenuItem.ViewportID);
              window.oxygenUtil.putViewportOnTop(rootMenuItem.ViewPortID);
              await this.$nextTick();
              window.oxygenUtil.putViewportOnTop(rootMenuItem.ViewPortID);
              //window.oxygenUtil.putViewportOnTop(rootMenuItem.ViewPortID);
            }
            else {
              let inbox = window.devStore.rootMenu.find(e => ((e.ClientRowID === this.client.Client) && e.Path.endsWith('/Inbox')));
              console.log('switch_panel-callback', 'inbox:', inbox);
              if(inbox) {
                window.oxygenUtil.putViewportOnTop(inbox.ViewPortID);
                await this.$nextTick();
                window.oxygenUtil.putViewportOnTop(inbox.ViewPortID);
                //window.oxygenUtil.putViewportOnTop(inbox.ViewPortID);
              }
              else {
                this.showChildViewport('showInbox');
              }

            }
          },
          isInbox ? "Open Thread/Subject" : "Open Inbox",
          false
      );


      this.$nextTick(function () {
        /*
        this.settingsOptions.map(e => e[4]).forEach((e) => {
          this.uiMenu.hideMenuItem(e);
        });

         */
      });


      /*
this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
this.iconIds.replyRecipients,
"replyRecipients",
this.setReplyIcon.bind(this, 'replyRecipients'),
"replyRecipients",
{},
this.$refs.settingsRibbon
*/

      /*


this.$refs.settingsRibbon.addRegisteredUIElement(
this.parent.config.uiElements.registrants[this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow][this.iconIds.link],
{ fn: ()=>{  }, id: "link", type: this.parent.config.uiElements.types.righticon, show: true },
undefined,
undefined,
this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
this.iconIds.link
);


this.$refs.settingsRibbon.addRegisteredUIElement(
this.parent.config.uiElements.registrants[this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow][this.iconIds.schedule],
{ fn: ()=>{ this.scheduleClicked(); }, id: "schedule", type: this.parent.config.uiElements.types.righticon, show: true },
undefined,
undefined,
this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
this.iconIds.schedule
);


this.$refs.settingsRibbon.addRegisteredUIElement(
this.parent.config.uiElements.registrants[this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow][this.iconIds.attach],
{ fn: ()=>{ this.attachClicked(); }, id: "attach", type: this.parent.config.uiElements.types.righticon, show: true },
undefined,
undefined,
this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
this.iconIds.attach
);

this.$refs.settingsRibbon.addRegisteredUIElement(
this.parent.config.uiElements.registrants[this.parent.config.dynamodb.tables.uiElements.registrants.navpanel][this.iconIds.savedTemplate],
{ fn: ()=>{ this.savedTemplateClicked(); }, id: "saved_template", type: this.parent.config.uiElements.types.righticon, show: true },
undefined,
undefined,
this.parent.config.dynamodb.tables.uiElements.registrants.navpanel,
this.iconIds.savedTemplate
);

this.$refs.settingsRibbon.addRegisteredUIElement(
this.parent.config.uiElements.registrants[this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow][this.iconIds.inbox],
{ fn: ()=>{ this.parent.showInboxPanel(); }, id: "show_inbox", type: this.parent.config.uiElements.types.righticon, show: true },
undefined,
undefined,
this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
this.iconIds.inbox
);

this.$refs.settingsRibbon.addRegisteredUIElement(
this.parent.config.uiElements.registrants[this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow][this.iconIds.threadSubject],
{ fn: ()=>{ this.parent.showThreadSubjectPanel(); }, id: "show_threadsubject", type: this.parent.config.uiElements.types.righticon, show: true },
undefined,
undefined,
this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
this.iconIds.threadSubject
);
*/

      /*
this.$refs.settingsRibbon.addRegisteredUIElement(
this.parent.config.uiElements.registrants[this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow][this.iconIds.meetingLink],
{ fn: ()=>{ this.showMeetingLink(); }, id: "meeting_link", type: this.parent.config.uiElements.types.righticon, show: false },
undefined,
undefined,
this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
this.iconIds.meetingLink
);

*/
      /*
this.$refs.settingsRibbon.addRegisteredUIElement(
this.parent.config.uiElements.registrants[this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow][this.iconIds.advanced],
{ fn:()=>{ this.parent.showAdvancedSendPanel(); }, id: "advanced", type: this.parent.config.uiElements.types.righticon, show: true },
undefined,
undefined,
this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
this.iconIds.advanced
);

*/

      /*
this.sendRowRibbonIcons = [
//{ id: 'send', iconId: this.iconIds.send,
//    fn: this.sendClicked.bind(this),  show: true },
{ id: 'email', iconId: this.iconIds.email, fn: this.sendClicked.bind(this) },
//{ id: 'schedule', iconId: this.iconIds.setupSchedule, fn: this.setupSchedule.bind(this) },
{ id: 'message', iconId: this.iconIds.message, fn: this.sendClicked.bind(this),show: true  },
{ id: 'page', iconId: this.iconIds.page, fn: this.meetingModeCommit.bind(this) },
{ id: 'invite', iconId: this.iconIds.call, fn: this.meetingModeCommit.bind(this) },
{ id: 'meet', iconId: this.iconIds.meet, fn: this.meetingModeCommit.bind(this) },
{ id: 'offer', iconId: this.iconIds.offer, fn: this.setupOffer.bind(this) }

];


this.sendRowRibbonIcons.forEach((e)=>{
this.$refs.sendRowRibbon.addRegisteredUIElement(
this.parent.config.uiElements.registrants[this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow][e.iconId],
{ fn:()=>{ e.fn() }, id: e.id, type: this.parent.config.uiElements.types.lefticon, show: (typeof e.show !== "undefined") ? e.show : false },
undefined,
undefined,
this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
e.iconId
);
});


*/

      this.$nextTick(function () {
//console.log('addSettingsRibbonIcons', 'setting icon styles');
//this.$refs.settingsRibbon.setIconStyle("advanced", {"padding": "5px 0px"});
//this.$refs.settingsRibbon.setIconStyle("attach", {"padding": "9px 12px 9px 5px"});
      });
      /*

this.$refs.settingsRibbon.addRegisteredUIElement(
this.parent.config.uiElements.registrants[this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow][this.parent.panelTypeIconIds.attachments],
{ fn: this.openAttachmentPanel.bind(this), id: "attachmentPanel", type: this.parent.config.uiElements.types.righticon, show: true },
undefined,
undefined,
this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
this.parent.panelTypeIconIds.attachments
);

this.$refs.settingsRibbon.addRegisteredUIElement(
this.parent.config.uiElements.registrants[this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow][this.parent.panelTypeIconIds.contacts],
{ fn: this.openContactsPanel.bind(this), id: "contactPanel", type: this.parent.config.uiElements.types.righticon, show: true },
undefined,
undefined,
this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
this.parent.panelTypeIconIds.contacts
);

this.$refs.settingsRibbon.addRegisteredUIElement(
this.parent.config.uiElements.registrants[this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow][this.parent.panelTypeIconIds.inbox],
{ fn: this.openRecentPanel.bind(this), id: "recentPanel", type: this.parent.config.uiElements.types.righticon, show: true },
undefined,
undefined,
this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow,
this.parent.panelTypeIconIds.inbox
);

this.$refs.settingsRibbon.addRegisteredUIElement(
this.parent.config.uiElements.registrants[this.parent.config.dynamodb.tables.uiElements.registrants.basicrootvuewindow][this.parent.panelTypeIconIds.threadSubject],
{ fn: this.openThreadSubjectPanel.bind(this), id: "threadSubjectPanel", type: this.parent.config.uiElements.types.righticon, show: true },
undefined,
undefined,
this.parent.config.dynamodb.tables.uiElements.registrants.threadSubject,
this.parent.panelTypeIconIds.contacts
);

*/
    },
    setMessageBoxVisibility(val) {
      this.showMessageBox = val;
    },
    isAdminRole() {
      let subjectRole = oxygenUtil.parseOES(this.contextPE).segments[2].toLowerCase();
      //console.log('isAdminRole', 'subjectRole:', subjectRole, ' - val:',['admin', 'owner', 'holder'].includes(subjectRole));
      return ['admin', 'owner', 'holder'].includes(subjectRole);
    },
    cancelButtonClickedOld() {
      Object.keys(this.componentData.messageBoxModes).forEach(e => Vue.set(this.mainPanel.componentData, e, false));
      this.mainPanel.componentData['messageBoxModeButtons'] = [];
      this.mainPanel.componentData['messageBoxModeButtons2'] = [];

      /*
Object.keys(this.componentData.replyFlags).forEach((e)=>{
this.componentData.replyFlags[e] = false;
this.uiMenu.deselectMenuItem(e);
});

*/

      this.replyOptionsList.forEach((e) => {
        this.$refs.settingsRibbon.hideRibbonIcon(e);
      });

      this.$refs.settingsRibbon.hideRibbonIcon('cancel_send');

      this.simpleModeOptions.forEach((e) => {
        this.uiMenu.showMenuItem(e[4]);
        this.uiMenu.selectRow(e[4]);

      });

      this.settingsOptions.forEach((e) => {
        this.uiMenu.deselectMenuItem(e[4]);
        this.uiMenu.hideMenuItem(e[4]);
      });

      //console.log('cancelButtonClicked', 'setting placeholder as default');
      this.componentData.textareaPlaceholder = 'Text. Email. Call. Meet. Share. Promise. Track.';
      //this.$refs.textarea.placeholder = 'Text. Email. Call. Meet. Share. Promise. Track.';
      if(this.$refs.initialInput) {
        this.$refs.initialInput.$el.parentElement.style.display = '';
      }
      this.componentData.showTextarea = false;
      this.componentData.showInitialInput = true;
      this.$refs.menuTable.hideRow(this.recipientTextboxPath);
      this.componentData.showEventSubject = false;
      this.componentData.showSubject = false;
    },
    async showPreferenceForm(dataRow) {
      this.formContainerTitle = "Set Preference";
      this.formRows.length = 0;

      this.formRows.push(
          {
            type: "input",
            name: "preference",
            label: "Preference",
            value: dataRow.Preference || ''
          },
          {
            type: "button",
            css: "spaced-button",
            name: "setPreference",
            text: "Set",
            size: "medium",
            view: "flat",
            color: "primary"
          }
      );
      this.$refs.formContainer.showContainerAlignedToElementInViewport(
          document.getElementById(this.viewportID).querySelector(".main-panel-header-title"),
          'bottom',
          document.getElementById(this.viewportID).getBoundingClientRect()
      );

      await this.$nextTick();
      this.$refs.formContainer.formInstance.getItem("setPreference").events.on("click", async ()=>{
        dataRow.Preference = this.$refs.formContainer.formInstance.getItem("preference").getValue();
        this.$refs.formContainer.hide();
      });
    },
    async showContentTemplateSelectionForm() {
      this.formContainerTitle = "Select Content Template";
      this.formRows.length = 0;
      let contentTemplates = await oxygenUtil.getContentTemplates(this.contextPE);
      this.formRows.push(
          {
            type: "select",
            name: "template",
            label: "Content Template",

            options:[
              { value: '', content: 'None'}
            ].concat(contentTemplates.length ? contentTemplates.map((e) => {
                  return {value: e.GrantRightID, content: e.GrantRightDN}
                }) : []),


            value: this.lastSelectedContentTemplate
          },
          {
            type: "button",
            css: "spaced-button",
            name: "setContentTemplate",
            text: "Select",
            size: "medium",
            view: "flat",
            color: "primary"
          }
      );
      this.$refs.formContainer.showContainerAlignedToElementInViewport(
          document.getElementById(this.viewportID).querySelector(".main-panel-header-title"),
          'bottom',
          document.getElementById(this.viewportID).getBoundingClientRect()
      );

      await this.$nextTick();
      this.$refs.formContainer.formInstance.getItem("setContentTemplate").events.on("click", async ()=>{
          this.lastSelectedContentTemplate = this.$refs.formContainer.formInstance.getItem("template").getValue();
          this.$refs.formContainer.hide();
      });
    },
    savedTemplateClicked(icon) {
      async.series([
        (callback) => {
          if (!this.savedMessagesMenu) {
            this.parent.createSavedMessagesMenu(this.setMessage.bind(this), true, this.implementMessageTemplate.bind(this), (menu) => {
              this.savedMessagesMenu = menu;
              callback();
            });
          } else {
            callback();
          }
        },
        (callback) => {
          this.savedMessagesMenu.showAdjacent(
              icon || this.$refs.settingsRibbon.getRibbonIconElement('saved_template'),
              this.parent);
          callback();
        }
      ], () => {
      });
    },
    newBodyClicked() {
      this.parent.showAllTemplatesAndDrafts((attachmentsPanel) => {
        attachmentsPanel.setSelectionMode(true, (templates) => {
          if (templates[0]) {
            this.addNewComponentDiv(templates[0], (error, templatePanel) => {
              if (!error) {

              }
            });
//}
          }
        });
      });
    },
    implementMessageTemplate(templatePE, callback) {
      let parsedPE = this.mainPanel.parseOES(templatePE);
      async.waterfall([
        this.mainPanel.getComponent.bind(this.mainPanel, parsedPE[3]),
        (templateComponent, callback) => {
          if (templateComponent.Code && templateComponent.Code.Type && templateComponent.Code.Type === 'iframe') {
            callback();
          } else {
            this.addNewComponentDiv(templatePE, callback);
          }
        }
      ], callback);
    },
    addNewComponentDiv(templatePE, callback) {
      //console.log('addNewComponentDiv', 'templatePE:', templatePE);
      this.mainPanel.pullPanel(
          this.mainPanel.clientNodeId,
          this.parent.config.anchorClients.relations.child,
          templatePE,
          {
            callerContext: this.mainPanel.addStandardParams({}),
            clientData: {
              initialHide: true,
              componentData: {
                setResizeObserver: false,
                disableChat: true
              }
            }
          },
          (error, data) => {
            let component;
            if (!error) {
              component = this.setBodyRowComponent(data.clientNodeId);
            }
            callback(error, component);
          }
      );
    },
    createSaveMenu(callback) {
      let saveMenu = new BaseOxygenRightMenu(this.parent.Y, {
        parent: this.parent,
        parentPanel: this.parent,
        menuTitle: 'Save Menu',
        noShow: true
      });

      saveMenu.init(() => {
        this.parent.standardMenus['simplesend_body_savemenu'] = saveMenu;
        saveMenu.addAction("saveAsFinal", "Save As Final", () => {
          let bodyComponentPanel = this.screenManager.allComponentInstances[this.bodyComponentProps.componentId];
          bodyComponentPanel.saveAsFinalParams = {openPE: false};
          bodyComponentPanel.showSavePanel(bodyComponentPanel._saveAsFinal.bind(bodyComponentPanel), false);
        }, true);
        saveMenu.addAction("saveAsTemplate", "Save As Template", () => {
          //console.log('saveAsTemplate-callback', 'componentId:', this.bodyComponentProps.componentId);
          let bodyComponentPanel = this.screenManager.allComponentInstances[this.bodyComponentProps.componentId];
          //console.log('saveAsTemplate-callback', 'bodyComponentPanel:', bodyComponentPanel);
          bodyComponentPanel.showSavePanel(bodyComponentPanel._saveAsFinal.bind(bodyComponentPanel), true);
        }, true);
        saveMenu.addAction("saveAsDraft", "Save As Draft", () => {
          this.screenManager.allComponentInstances[this.bodyComponentProps.componentId]._saveAsDraft();
        }, true);

        callback(saveMenu);
      });
    },
    async saveBodyClicked() {
      this.formContainerTitle = "Save Message Template";
      this.formRows.length = 0;

      this.formRows.push(
          {
            type: "input",
            name: "templateName",
            label: "Name",
            value: ''
          },
          {
            type: "button",
            css: "spaced-button",
            name: "saveTemplate",
            text: "Save",
            size: "medium",
            view: "flat",
            color: "primary"
          }
      );
      this.$refs.formContainer.showContainerAlignedToElementInViewport(
          document.getElementById(this.viewportID).querySelector(".main-panel-header-title"),
          'bottom',
          document.getElementById(this.viewportID).getBoundingClientRect()
      );

      await this.$nextTick();
      this.$refs.formContainer.formInstance.getItem("saveTemplate").events.on("click", async ()=>{
        let templateName = this.$refs.formContainer.formInstance.getItem("templateName").getValue();
        await oxygenUtil.runDBQuery(
            `insert into OxygenDatabase.MessageTemplates (TemplateName, TemplateText, ContextPE, MetaType) values(?,?,?,?)`,
            [templateName, this.getMessage(), this.contextPE, 'Template']
        );
        this.$refs.formContainer.hide();
      });
    },
    async saveMessageTemplates() {
        await async.eachOf(this.currentMessageTemplates, async (templateData, index)=> {
          if((this.$refs.multipleFormsContainer.formData[index].TemplateName != templateData.TemplateName) ||
              (this.$refs.multipleFormsContainer.formData[index].TemplateText != templateData.TemplateText)) {
            await oxygenUtil.runDBQuery(
                `update OxygenDatabase.MessageTemplates set TemplateName = ?, TemplateText = ? where ID = ?`,
                [
                  this.$refs.multipleFormsContainer.formData[index].TemplateName,
                  this.$refs.multipleFormsContainer.formData[index].TemplateText,
                  templateData.ID
                ]
            );
          }

        });
    },
    saveBodyClickedOld() {
      async.series([
        (callback) => {
          if (!this.saveBodyMenu) {
            this.createSaveMenu((menu) => {
              this.saveBodyMenu = menu;
              callback();
            });
          } else {
            callback()
          }
        },
        (callback) => {
          this.saveBodyMenu.showAdjacent(this.$refs.settingsRibbon.getRibbonIconElement('save_body'), this.parent);
          callback();
        }
      ]);
    },
    setBodyRowComponent(componentId) {
      let component;
      if (component = this.parent.Y.screenManager.allComponentInstances[componentId]) {
        this.resetBodyComponent();
        this.bodyComponentProps.componentId = componentId;
        this.bodyComponentProps.component = component;

        //$(component.windowElement).find('.main-content-body').removeClass('main-content-body');
        this.$watch('parent.componentData.breakpoint', (newVal) => {
          component.componentData.breakpoint = newVal;
        }, {immediate: true});

        //$('#' + this.bodyComponentDivId).append($(component.windowElement).find('.vueWinBody'));
        this.showBodyComponent = true;
        //this.$refs.settingsRibbon.showRibbonIcon('save_body');

//this.parent.setBreakpoint(this.parent.config.screen.breakpoints.sm.str);

      }
      return component;
    },
    setBodyComponentContent(content) {
      this.$refs.squireComponent.setContent(content);
    },
    async getBodyComponentContent() {
      return await this.getBodyComponentContentPromise();
    },
    getBodyComponentContentPromise() {
      return new Promise((resolve, reject)=>{
        this.$refs.squireComponent.getContent((error, content)=>{
          if(error) {
            return reject(error);
          }
          resolve(content);
        });
      });
    },
    saveBodyComponent(callback) {
      this.$refs.squireComponent.getContent((error, content)=>{
        if(error) {
          return callback(error);
        }
        this.htmlMessage = content;
        callback();
      });
    },
    saveBodyComponentOld(callback) {
      let panelComponent = this.bodyComponentProps.component;
      let parsedCurrentPE = this.parent.parseOES(this.mainPanel.GrantPE).segments;
      let params = {
        isTemplate: false,
        DNPrefix: panelComponent.atComponent.DisplayName,
        isChild: false,
        contextPE: this.mainPanel.GrantPE,
        componentId: panelComponent.atComponent.Node,
        initialContext: {},
        openPE: false,
        newAdminGrantToPE: oxygenUtil.createSimpleOES(["bot", parsedCurrentPE[1], parsedCurrentPE[2], parsedCurrentPE[3]])
      };
      async.parallel([
        (callback) => {
          panelComponent.saveAsFinal(params, (error, responseData) => {
            this.htmlBodyTip = responseData.data;
            callback(error);
          });
        },
        (callback) => {
          panelComponent.getContent((error, content) => {
            if (error) {
              return callback(error);
            }
            this.htmlMessage = content;
            callback();
          });
        }
      ], (error) => {
        panelComponent.close(() => {
        });
        callback(error);
      });
    },
    /*
switchCurrentlySelectedPanel(newPanel, callback) {
if(this.currentlySelectedPanel) {
this.currentlySelectedPanel.unsetChatMode();
}
this.currentlySelectedPanel = newPanel;
this.currentlySelectedPanel.setChatMode(callback);
},
openAttachmentPanel(event, item) {
this.parent.showAttachments(event, item, {}, (panel)=>{
this.switchCurrentlySelectedPanel(panel,()=>{

});
});
},
openContactsPanel(event, item){
this.parent.showContacts(event, item, {}, (panel)=>{
this.switchCurrentlySelectedPanel(panel,()=>{

});
});
},
openRecentPanel(event, item) {
this.parent.showActivityChatPanel((panel)=>{
this.switchCurrentlySelectedPanel(panel,()=>{

});
});
},
openThreadSubjectPanel(event, item) {
this.parent.showThreadSubjectPanel(event, item, {}, (panel)=>{
this.switchCurrentlySelectedPanel(panel,()=>{

});
});
},*/
    getSelectedReplyFlag() {
      return Object.keys(this.componentData.replyFlags).find(e => this.componentData.replyFlags[e]);
    },
    getSelectedReplyFlags() {
      return Object.keys(this.componentData.replyFlags).filter(e => (this.componentData.replyFlags[e] && !['replyRecipients', 'replySelect'].includes(e)));
    },
    selectOptionClicked(childViewportFnName, path, flagName) {
      //console.log('selectOptionClicked', 'childViewportFnName:', childViewportFnName);
      this.showChildViewport(childViewportFnName);

      this.setReplyIcon(flagName);
    },
    selectContactsClicked(...args) {
      if(this.client.childViewports && this.client.childViewports.showNormalContacts) {

        this.componentData.replyContactsSelectionFlag = true;
        this.client.childViewports.showNormalContacts();
        this.setReplyIcon('replySelect', ...args);
      }

      /*
      this.parent.showContacts({}, null, {}, () => {
        this.setReplyIcon('replySelect', ...args);
      });

       */
    },
    selectLiveContactsClicked(...args) {
      if(this.client.childViewports && this.client.childViewports.showContacts) {

        this.componentData.replyContactsSelectionFlag = true;
        this.client.childViewports.showContacts();
        this.setReplyIcon('replySelect', ...args);
      }

      /*
      this.parent.showContacts({}, null, {}, () => {
        this.setReplyIcon('replySelect', ...args);
      });

       */
    },
    selectInboxClicked(...args) {
      if(this.client.childViewports && this.client.childViewports.showInbox) {

        this.componentData.replyInboxSelectionFlag = true;
        this.client.childViewports.showInbox();
        this.setReplyIcon('replySelect', ...args);
      }

      /*
      this.parent.showInboxPanel({}, null, {}, () => {
        this.setReplyIcon('replySelect', ...args);
      });

       */
    },
    selectAttachmentsClicked(...args) {
      if(this.client.childViewports && this.client.childViewports.showAttachments) {

        this.componentData.replyAttachmentsSelectionFlag = true;
        this.client.childViewports.showAttachments();
        this.setReplyIcon('replySelect', ...args);
      }

      /*
      this.parent.showAttachments({}, null, {}, () => {
        this.setReplyIcon('replySelect', ...args);
      });

       */
    },
    setReplyIcon(iconId, ...args) {

//console.log('setReplyIcon', 'args:', args);
//console.log('setReplyIcon', 'iconId:', iconId, ' - row:', this.uiMenu.getRow(iconId));
      //this.mainPanel.lastRoleClickPanel = this.parent;
      //if (args[0] instanceof UIEvent) {
//this.componentData.replyFlags[iconId] = !this.componentData.replyFlags[iconId];
        //this.showReplyOptionsUIMenu(args[0]);
        //this.lastRoleClickEvent = args[0];

      //} else {
        /*
if(this.uiMenu.getRow(iconId).selected) {
this.uiMenu.deselectRow(iconId);
}
else {
this.uiMenu.selectRow(iconId);
}

*/
        let currentIconId;
        //console.log('setReplyIcon', 'selectedReplyFlag:', this.getSelectedReplyFlag());
        if (currentIconId = this.getSelectedReplyFlag()) {
          this.componentData.replyFlags[currentIconId] = false;
        }
        //this.replyOptionsUIMenu.selectRow(iconId);



        this.$nextTick(function () {
//console.log('setReplyIcon', 'iconId:', iconId, ' - flag-pre:', this.componentData.replyFlags[iconId]);
          this.componentData.replyFlags[iconId] = true;
//console.log('setReplyIcon', 'iconId:', iconId, ' - flag-post:', this.componentData.replyFlags[iconId]);
        });
        this.lastRoleClickEvent = null;
      //}

    },
    unselectReplyIcon(iconId) {
      this.$refs.settingsRibbon.hideRibbonIcon(iconId);
      //this.replyOptionsUIMenu.deselectRow(iconId);
      if (iconId === 'replyRecipients') {
        this.componentData.showMessageBoxRecipientsList = false;
      }
      let icon = this.settingsOptions.find(e => e[2] === iconId);
      icon[8] = false;
    },
    selectReplyIcon(iconId) {
      /*
if(!this.componentData.replyFlags[iconId]) {
console.log('updateReplyIcon', 'iconId:', iconId);
this.resetReplyFlags();
}

*/
      let icon = this.settingsOptions.find(e => e[2] === iconId);
      //console.log('selectReplyIcon', 'iconId:', iconId);
      //console.log('selectReplyIcon', 'option:', this.settingsOptions.find(e => e[2] === iconId));
      //console.log('selectReplyIcon', 'path:', this.settingsOptions.find(e => e[2] === iconId)[0]);
      //console.log('selectReplyIcon', 'menuTable:', this.$refs.ribbonMenu.menuTable);
      this.$refs.settingsRibbon.showRibbonIcon(iconId);
      //window._menuTable = this.$refs.ribbonMenu.menuTable;
      //this.replyOptionsUIMenu.selectRow(iconId);
      //this.$refs.ribbonMenu.menuTable.selectRow(this.settingsOptions.find(e => e[2] === iconId)[0]);
      icon[8] = true;
      this.$nextTick(function () {
//this.$refs.settingsRibbon.selectIcon(iconId);
        Object.keys(this.componentData.replyFlags).filter(e => (e !== iconId)).forEach(e => (this.componentData.replyFlags[e] = false));
//this.componentData.replyFlags[iconId] = true;
        //if ((iconId === 'replyRole') && (this.mainPanel.lastRoleClickPanel === this.parent)) {
        if (iconId === 'replyRole') {
          this.setReplyRole();
        }
        if (iconId === 'replyRecipients') {
          this.componentData.showMessageBoxRecipientsList = !(this.componentData.clientContactsMode === 'meeting') && !this.componentData.minimalMode && true;
        }
        if (iconId === 'replySelect' && this.parent.searchComponent && !this.parent._ignoreSelection) {
          this.selectionEnabled = true;
        }
        if (iconId === 'replySelf') {
//this.componentData.replyFlags['replyAll'] = false;
//this.componentData.replyFlags['reply'] = false;
//this.$refs.settingsRibbon.unselectIcon('replyAll');
//this.$refs.settingsRibbon.unselectIcon('reply');
        }
      });
    },
    setReplyRole() {
      async.waterfall([
        async ()=> {
          return this.getRoles(null, ['bot']);
        },
        async (roles) => {
          //console.log('setReplyRole', 'roles:', roles);
          this.showRoleMenu(Object.values(roles)[0]);
        }
      ], () => {
      });
    },
    resetReplyFlags(flagName) {
      Object.keys(this.componentData.replyFlags).filter(e => e !== flagName).forEach((e) => {
//console.log('setReplyFlags', 'iconId:', e);
        this.componentData.replyFlags[e] = false;
//this.$refs.settingsRibbon.unselectIcon(e);
      });
    },
    getRibbon() {
      return this.$refs.settingsRibbon;
    },
    getFullMessage() {
      if (this.htmlMessage) {
        return `${this.getMessage() ? `${this.getMessage()}\n\n` : ''}  ${this.htmlMessage}`;
      } else {
        return this.getMessage();
      }
    },
    getMessage() {
      //return this.componentData.messageBoxText;
      return this.$refs.textarea.$el.value;
    },
    setMessage(message) {
      this.componentData.messageBoxText = this.$refs.textarea.inputVal = message;
    },
    valueChanged() {

    },
    getSelectedRole() {
      return this.selectedRole;
    },
    getSelectedRoleOld() {
      let roles = this.roleMenu.menuTable.getSelectedRows();
      if (roles.length) {
        return roles[0].roleStr;
      }
      return null;
    },
    async addPhone(phoneNumber, menuTable, dataRow, fromInbox, preferredRole, allowRemoval) {
      allowRemoval = (typeof allowRemoval !== "undefined") ? allowRemoval : (this.componentData.botMode ? false : true);
      menuTable = menuTable || this.$refs.menuTable;
      await async.waterfall([
        async ()=>{
          return await oxygenUtil.getPhoneInfo(phoneNumber);
        },
        async (phoneInfo) => {
          //console.log('phoneInfo:', phoneInfo);
          if (!menuTable.getRow(`${this.recipientPathPrefix}${phoneNumber}`)) {
            let parsedGatewayPE = oxygenUtil.parseOES(phoneInfo.personalGatewayPE).segments;


            this.$nextTick(function () {
              //this.initializeFnMap.get(menuTable)();

              this.$nextTick(function () {

                menuTable.addRow(Object.assign({
                  cols: [
                    /*{
                      html:`<span class="fal fa-share-alt"/>`,
                      callback: (dataRow, index, ev) => {
                        this.lastRoleClickEvent = ev;
                        this.showRoleMenu(dataRow.roles, {singleSelect: true});
                      }
                    },*/
                    {
                      html: `<span class="table-icon fas fa-question" style="color: lightgrey; font-size:13px;  padding-bottom: 6px; padding-left:5px; padding-right: 5px;"/>`,
                      tooltip: 'Show Details',
                      callback: (...args) => {
                        this.showRecipientDetails(...args);
                      }
                    },
                    {
                      html: `<span style="font-size:${oxygenUtil.config.fontSize};" class="pointer" >${phoneNumber}</span>`,
                      tooltip: `${phoneNumber}`,
                      type: 'html',
                    },
                    {
                      html:`<span class="${this.getMenuTableIcon(menuTable)}"/>`,
                      callback: (dataRow, index, ev) => {
                      },
                      styleObj: {
                        'color': 'black'
                      }
                    }
                  ],
                  backgroundColor: 'white',
                  originalDataRow: dataRow,
                  fromInbox: !!fromInbox,
                  //isInbox: this.parent._isInbox,
                  hideCheckbox: true,
//noCheckboxCol: true,
                  showFolder: false,
                  data: {
                    phoneNumber,
                    phoneInfo,
                    PE: phoneInfo.personalGatewayPE,
                    GrantLeftR: parsedGatewayPE[0],
                    GrantLeftID: parsedGatewayPE[1],
                    GrantRightR: parsedGatewayPE[2],
                    GrantRightID: parsedGatewayPE[3]
                  },
                  path: `${this.recipientPathPrefix}${phoneNumber}`,
                  type: this.rowTypes.phone,
                  roles: this.accountRoles.filter(e => {
                    return this.componentData.offerGuestAccountEnabled ? (e.role === "admin") : true;
                  }).map((e) => {
                    if (this.componentData.offerGuestAccountEnabled) {
                      e.selected = true;
                    }
                    if(preferredRole) {
                      e.selected = false;
                    }
                    return Object.assign({}, e);

                  }).concat(preferredRole ? {role: preferredRole, selected: true} : [])
                }, allowRemoval ? {
                  folderCol: {
                    alt: {
                      html: `<span class="fas fa-times"/>`,
                      callback: (dataRow) => {
                        menuTable.deleteRow(dataRow.path);
                        if(menuTable === this.$refs.subjectMenuTable) {
                          this.componentData.showMessageBoxSubjectInput = true;
                          this.componentData.showMessageBoxSubjectTable = false;
                        }
                      }
                    }
                  }
                }: {}), 0);
                this.$nextTick(function () {
//this.$refs.menuTable.selectRow(`${this.recipientPathPrefix}${phoneNumber}`);
                });
              });
            });
          } else {
//this.$refs.menuTable.selectRow(`${this.recipientPathPrefix}${phoneNumber}`);
          }

        }
      ]);
      if(menuTable === this.$refs.menuTable) {
        this.componentData.showMessageBoxRecipientsTable = !(this.componentData.clientContactsMode === 'meeting') && !this.componentData.minimalMode && true;
      }
      else if(menuTable === this.$refs.attachmentsMenuTable) {
        this.componentData.showMessageBoxAttachmentsList = true;
      }
      else if(menuTable === this.$refs.subjectMenuTable) {
        this.componentData.showMessageBoxSubjectInput = false;
        this.componentData.showMessageBoxSubjectTable = true;
      }
    },
    async addEmail(emailAddress, menuTable, dataRow, fromInbox, preferredRole, allowRemoval) {
      menuTable = menuTable || this.$refs.menuTable;
      allowRemoval = (typeof allowRemoval !== "undefined") ? allowRemoval : (this.componentData.botMode ? false : true);
      await async.waterfall([
        async ()=>{
          return await oxygenUtil.getEmailAddressInfo(emailAddress);
        },
        async (emailInfo) => {
          //console.log('emailInfo:', emailInfo);
          if (!menuTable.getRow(`${this.recipientPathPrefix}${emailAddress}`) && emailInfo && emailInfo.personalGatewayPE) {
            let parsedGatewayPE = oxygenUtil.parseOES(emailInfo.personalGatewayPE).segments;
            this.$nextTick(function () {
              //this.initializeFnMap.get(menuTable)();

              this.$nextTick(function () {
                //console.log('adding row to menuTable')
                menuTable.addRow(Object.assign({
                  cols: [
                    {
                      html: `<span class="table-icon fas fa-question" style="color: lightgrey; font-size:13px;  padding-bottom: 6px; padding-left:5px; padding-right: 5px;"/>`,
                      tooltip: 'Show Details',
                      callback: (...args) => {
                        this.showRecipientDetails(...args);
                      }
                    },
                    {
                      html: `<span style="font-size:${oxygenUtil.config.fontSize};" class="pointer">${emailAddress}</span>`,
                      tooltip: `${emailAddress}`,
                      type: 'html',
                    },
                    {

                      html:`<span class="${this.getMenuTableIcon(menuTable)}"/>`,
                      callback: (dataRow, index, ev) => {
                      },
                      styleObj: {
                        'color': 'black'
                      }
                    }
                  ],
                  backgroundColor: 'white',
                  originalDataRow: dataRow,
                  fromInbox: !!fromInbox,
                  //isInbox: this.parent._isInbox,
                  hideCheckbox: true,
                  showFolder: false,
                  data: {
                    emailAddress,
                    emailInfo,
                    PE: emailInfo.personalGatewayPE,
                    GrantLeftR: parsedGatewayPE[0],
                    GrantLeftID: parsedGatewayPE[1],
                    GrantRightR: parsedGatewayPE[2],
                    GrantRightID: parsedGatewayPE[3]
                  },
                  path: `${this.recipientPathPrefix}${emailAddress}`,
                  type: this.rowTypes.email,
                  roles: this.accountRoles.filter(e => {
                    return this.componentData.offerGuestAccountEnabled ? (e.role === "admin") : true;
                  }).map((e) => {
                    if (this.componentData.offerGuestAccountEnabled) {
                      e.selected = true;
                    }
                    if(preferredRole) {
                      e.selected = false;
                    }
                    return Object.assign({}, e);

                  }).concat(preferredRole ? {role: preferredRole, selected: true}: [])
                }, allowRemoval ? {
                  folderCol: {
                    alt: {
                      html: `<span class="fas fa-times"/>`,
                      callback: (dataRow) => {
                        menuTable.deleteRow(dataRow.path);
                        if(menuTable === this.$refs.subjectMenuTable) {
                          this.componentData.showMessageBoxSubjectInput = true;
                          this.componentData.showMessageBoxSubjectTable = false;
                        }
                      }
                    }
                  },
                  rightMenuCallback: (...args) => {
                    console.log('emailRow-rightMenuCallback');
                    this.showEmailRecipientOptionsMenu(...args);
                  }
                } : {}), 0);
                this.$nextTick(function () {
//this.$refs.menuTable.selectRow(`${this.recipientPathPrefix}${emailAddress}`);
                });
              });
            });
          } else {
//this.$refs.menuTable.selectRow(`${this.recipientPathPrefix}${emailAddress}`);
          }
        }
      ]);

      if(menuTable === this.$refs.menuTable) {
        this.componentData.showMessageBoxRecipientsTable = !(this.componentData.clientContactsMode === 'meeting') && !this.componentData.minimalMode && true;
      }
      else if(menuTable === this.$refs.attachmentsMenuTable) {
        this.componentData.showMessageBoxAttachmentsList = true;
      }
      else if(menuTable === this.$refs.subjectMenuTable) {
        this.componentData.showMessageBoxSubjectInput = false;
        this.componentData.showMessageBoxSubjectTable = true;
      }

    },
    showEmailRecipientOptionsMenu(dataRow, index, event, target) {
      console.log('showEmailRecipientOptionsMenu', 'target:', target);
      this.simpleMenuOptions.length = 0;
      this.simpleMenuWidth = '350px';

      let options = [
        {
          icon: `far fa-closed-captioning`,
          title: `Set as BCC`,
          callback: ()=>{
            dataRow.cols[2].html = `<span class="far fa-closed-captioning"/>`;
            dataRow.bccFlag = true;
          },
          path: '000-bcc'
        }
      ];

      this.simpleMenuOptions.push(...options);

      this.$refs.simpleOptionsMenu.showMenuAlignedToElement(target, 'right', 'bottom');
    },
    async addChannel(channelName, menuTable) {
      //console.log('addChannel', 'channelName:', channelName);
      menuTable.addRow({
        cols: [

          {
            html: `<span class="table-icon fas fa-question" style="color: lightgrey; font-size:13px;  padding-bottom: 6px; padding-left:5px; padding-right: 5px;"/>`,
            tooltip: 'Show Details',
            callback: (...args) => {

            }
          },
          {
            html: `<span style="font-size:${oxygenUtil.config.fontSize};" class="pointer">${channelName}</span>`,
            tooltip: `${channelName}`,
            type: 'html',
          },
          {

            html:`<span class="${this.iconIds.channel}"/>`,
            callback: (dataRow, index, ev) => {
            },
            styleObj: {
              'color': 'black'
            }
          }
        ],
        backgroundColor: 'white',


        //isInbox: this.parent._isInbox,
        hideCheckbox: true,
        showFolder: false,
        data: {
          channelName
        },
        path: `${this.recipientPathPrefix}${channelName}`,
        type: this.rowTypes.channel,

        folderCol: {
          alt: {
            html: `<span class="fas fa-times"/>`,
            callback: (dataRow) => {
              menuTable.deleteRow(dataRow.path);
              if(menuTable === this.$refs.subjectMenuTable) {
                this.componentData.showMessageBoxSubjectInput = true;
                this.componentData.showMessageBoxSubjectTable = false;
              }
            }
          }
        }
      }, 0);
      this.componentData.showMessageBoxSubjectInput = false;
      this.componentData.showMessageBoxSubjectTable = true;
    },
    async addNewComponent(DNPrefix, menuTable) {
      menuTable = menuTable || this.$refs.menuTable;
      let guid = oxygenUtil.getGUID();
      let component = await oxygenUtil.createComponent("_FFFFFFFFFFFFFF00001585270492801337_", {

      }, {
        Node: guid,
        DNPrefix,
        toPE: this.contextPE
      });

      let allRoles = await oxygenUtil.getAllComponentsRoles(
          [
            {
              id: component.Node,
              defaultRole: ['visitor', 'admin','holder']
            }
          ],
          [{componentId: component.Node, role: "visitor"},{componentId: component.Node, role: "bot"},{componentId: component.Node, role: "admin"}],
          ['owner'],
      );
      this.addValidatedPE(component, allRoles[component.Node], menuTable);
    },
    addValidatedPE(component, allRoles, menuTable, addSubAccount) {
      //console.log('addValidatedPE', 'component:', component, ' - allRoles:', allRoles);
      console.log('addValidatedPE', 'addSubAccount:', addSubAccount);
      menuTable = menuTable || this.$refs.menuTable;
      async.series([
        async () => {
          if (this.componentData.offerGuestAccountEnabled) {
            let gatewayPE = oxygenUtil.createSimpleOES(['admin', component.Node, 'admin', component.Node]);
            let results = await oxygenUtil.runDBQuery(
                `select * from OxygenDatabase.Attribution where GatewayPE = ? and AccountType = ?`,
                [gatewayPE, 'PrimaryAccount']
            ).catch((e)=>{
              throw e;
            });
            if (results.length) {
              return;
            } else {
              throw new Error('Invalid PrimaryAccount PE');
            }
          }

        },
        (callback) => {
          //console.log('addValidatedPE', 'adding row');
          //menuTable.deleteRow(this.recipientTextboxPath);
          this.$nextTick(function () {
            //this.initializeFnMap.get(menuTable)();

            this.$nextTick(function () {
              menuTable.addRow(Object.assign({
                cols: [].concat(
                  {
                    html: `<span class="table-icon fas fa-question" style="color: lightgrey; font-size:13px;  padding-bottom: 6px; padding-left:5px; padding-right: 5px;"/>`,
                    tooltip: 'Show Details',
                    callback: (...args) => {
                      (menuTable === this.$refs.menuTable ) ? this.showRecipientDetails(...args) : this.showAttachmentDetails(...args);
                    }
                  },
                  {
                    html: `<span style="font-size:${oxygenUtil.config.fontSize};">${oxygenUtil.encodeHTMLEntities(oxygenUtil.formatDN(component.DisplayName))}</span>`,
                    tooltip: `${oxygenUtil.encodeHTMLEntities(component.DisplayName)}`,
                    type: 'html',

                  },
                    (menuTable === this.$refs.attachmentsMenuTable) ?
                        {
                          html: `<span title="Preference" class="fal fa-folder-gear"/>`,
                          callback: (dataRow, index, ev) => {
                            this.showPreferenceForm(dataRow);
                          },
                          styleObj: {
                            'color': 'black'
                          }
                        } :
                        [],
                  {
                    html: `<span class="${this.getMenuTableIcon(menuTable)}"/>`,
                    callback: (dataRow, index, ev) => {
                    },
                    styleObj: {
                      'color': 'black'
                    }
                  }
                ),
                backgroundColor: 'white',
                hideCheckbox: true,
                showFolder: false,
                data: {component},
                menuTable,
                path: `${this.recipientPathPrefix}${component.Node}`,
                type: this.rowTypes.attachment,
                addSubAccount,
                roles: allRoles ? allRoles.filter(e => {
                  return this.componentData.offerGuestAccountEnabled ? (e.role === "admin") : true;
                }).map((e) => {
                  if (this.componentData.offerGuestAccountEnabled) {
                    e.selected = true;
                  }
                  return Object.assign({}, e);
                }) : [],
                folderCol: {
                  alt: {
                    html: `<span class="${this.iconIds.remove}"/>`,
                    callback: (dataRow) => {
                      dataRow.menuTable.deleteRow(dataRow.path);
                      if(menuTable === this.$refs.subjectMenuTable) {
                        this.componentData.showMessageBoxSubjectInput = true;
                        this.componentData.showMessageBoxSubjectTable = false;
                      }
                    }
                  }
                }
              }, (menuTable === this.$refs.attachmentsMenuTable) ? {
                rightMenuCallback: (...args) => {
                  this.attachmentOptionsMenu(...args);
                },
              }: {}), 0);

              this.$nextTick(function () {
                let roleObj, selectedRole = (allRoles &&  (roleObj = allRoles.find(e => e.selected)) && roleObj.role ) || 'admin';
                let connectPE = oxygenUtil.createSimpleOES([selectedRole, component.Node, selectedRole, component.Node]);
                window.oxygenUtil.setBotConnectTracker(this.client.Client, connectPE);
                callback()
//this.$refs.menuTable.selectRow(`${this.recipientPathPrefix}${component.Node}`);
              });

            });
          })

        }
      ], () => {
        if(menuTable === this.$refs.menuTable) {
          this.componentData.showMessageBoxRecipientsTable = !(this.componentData.clientContactsMode === 'meeting') && !this.componentData.minimalMode && true;
        }
        else if(menuTable === this.$refs.attachmentsMenuTable) {
          this.componentData.showMessageBoxAttachmentsList = true;
        }
        else if(menuTable === this.$refs.subjectMenuTable) {
          this.componentData.showMessageBoxSubjectInput = false;
          this.componentData.showMessageBoxSubjectTable = true;
        }
      });
    },
    getMenuTableIcon(menuTable) {

      let icon = new WeakMap(
          [
            [this.$refs.menuTable, this.iconIds.recipient],
            [this.$refs.attachmentsMenuTable, this.iconIds.attachment],
            [this.$refs.subjectMenuTable, this.iconIds.subject]
          ]
      );

      return icon.get(menuTable);
    },
    getCurrentMessageBoxFromEvent(ev) {
      let viewportId = ev.target.closest('div[name="oxygen-viewport"]').id, viewport;
      //console.log('getCurrentMessageBoxFromEvent', 'viewportId:', viewportId);
      //console.log('getCurrentMessageBoxFromEvent', 'viewport:', window.devStore.viewPorts.find(e => e.viewportID === viewportId));
      if(viewport = window.devStore.viewPorts.find(e => e.viewportID === viewportId)) {
        //console.log('getCurrentMessageBoxFromEvent', 'returning correct MessageBox');
        return viewport.MessageBox;
      }
      return this;
    },
    async showAttachmentDetails(dataRow, index, ev) {
      let details = this.getDetailsInfo(dataRow);
      this.componentData.subjectLabelInDetailsForm = oxygenUtil.config.attachmentTitle;
      this.componentData.subjectRoleLabelInDetailsForm = `${oxygenUtil.config.attachmentTitle} Role`;
      this.componentData.addThreadInDetailsForm = false;
      this.componentData.subjectRoleChangeInDetailsForm = (role) => {
        dataRow.roles.find(e => e.selected).selected = false;
        dataRow.roles.find(e => e.role === role).selected = true;
      };

      Object.assign(this.componentData.detailsData, {
        RightDN: dataRow.data.component.DisplayName,
        RightRole: dataRow.roles.map(e => e.role),
        SelectedRightRole: dataRow.roles.find(e => e.selected).role,
      });


      this.getCurrentMessageBoxFromEvent(ev).$refs.detailsForm.showContainerAlignedToElementInViewport(ev.target, 'top', this.getCurrentMessageBoxFromEvent(ev).$refs.mainDiv.getBoundingClientRect());

    },
    async showRecipientDetails(dataRow, index, ev) {

      async.waterfall([
        async ()=> {
          let details = this.getDetailsInfo(dataRow);
          //console.log('showRecipientDetails', 'details:', details);
          let parsedPE = oxygenUtil.parseOES(details.PE).segments;
          let { components } = await oxygenUtil.callCommonServiceAPI("simplia-api","getMultipleComponents", { componentIds: {asComponent: parsedPE[1], atComponent: parsedPE[3]} });
          //console.log('showRecipientDetails', 'details:', details, ' - components:', components);
          let selectedRole;
          //console.log('showRecipientDetails', 'selectedRole:', details.roles.find(e => e.selected));
          return { components, details, selectedThreadRole: parsedPE[0], selectedSubjectRole: (selectedRole = details.roles.find(e => e.selected)) ? selectedRole.role : parsedPE[2] };
        },
        async ({components, details, selectedThreadRole, selectedSubjectRole}) => {
          //console.log('showRecipientDetails', 'components:', components);
          this.componentData.subjectLabelInDetailsForm = 'Subject';
          this.componentData.subjectRoleLabelInDetailsForm = 'Subject Role';
          this.componentData.addThreadInDetailsForm = !details.subjectOnly;
          this.componentData.subjectRoleChangeInDetailsForm = (role) => {
            details.roles.find(e => e.selected).selected = false;
            details.roles.find(e => e.role === role).selected = true;
          };

          Object.assign( this.componentData.detailsData, {
            RightDN: components.atComponent.DisplayName,
            RightRole: details.roles ? details.roles.map(e => e.role) : selectedSubjectRole,
            SelectedRightRole: selectedSubjectRole,

          }, !details.subjectOnly ? { LeftDN: components.asComponent.DisplayName,
            LeftRole: selectedThreadRole, SelectedLeftRole: selectedThreadRole} : {});
          //this.$refs.detailsForm.showContainerAlignedToElementInViewport(ev.target, 'bottom', this.$el.parentElement.getBoundingClientRect());
          //console.log('showRecipientDetails', 'details:', this.componentData.detailsData, ' ev:', ev);
          this.getCurrentMessageBoxFromEvent(ev).$refs.detailsForm.showContainerAlignedToElementInViewport(ev.target, 'top', this.getCurrentMessageBoxFromEvent(ev).$refs.mainDiv.getBoundingClientRect());
          //console.log('showRecipientDetails', 'detailsForm shown - form:',  this.getCurrentMessageBoxFromEvent(ev).$refs.detailsForm);
        }
      ]);
    },
    optionsMenuRowSelected(dataRow, index) {
      if(this.getSelectedReplyFlag() === 'replyRole') {
        this.selectedRole = dataRow.data.roleObj.role;
        this.$refs.newOptionsMenu.hideMenu();
      }
    },
    optionsMenuRowDeselected(dataRow, index) {
      if(this.getSelectedReplyFlag() === 'replyRole') {
        this.selectedRole = dataRow.data.roleObj.role;
        this.$refs.newOptionsMenu.hideMenu();
      }
    },
    showRoleMenu(roles) {
      this.containerTitle = 'Select Role';
      this.options.length = 0;
      this.menuWidth = '350px';
      this.options.push(...roles.map((roleObj, i) =>{
        return {
          icon: '',
          roleObj: roleObj,
          title: oxygenUtil.capitalizeFirstLetter(roleObj.role),
          callback: (data) => {
            //this.setReplyIcon('replyRole');
            this.selectedRole = roleObj.role
          },
          path: `${i}`.padStart(3,'0'),
          menuParams: {
            selected: this.selectedRole ? (this.selectedRole === roleObj.role) : roleObj.selected
          }
        };
      }));
      //console.log('showRoleMenu', 'options:', this.options);
      this.$refs.newOptionsMenu.showMenuAlignedToElement(this.$refs.settingsRibbon.$el, 'right', 'top');
    },
    showRoleMenuOld(roles, params) {
      this.roleMenu.deleteAllRows();
      let counter = 1;
      let clickCallback = (roleDataRow) => {
        if (roleDataRow.role.selected) {
          this.roleMenu.menuTable.deselectRow(roleDataRow.path);
          roleDataRow.role['selected'] = false;
          roleDataRow['showCheckbox'] = false;
        } else {
          if (params.singleSelect) {
            let selectedRows = this.roleMenu.menuTable.getSelectedRows();
            selectedRows.forEach((row) => {
              this.roleMenu.menuTable.deselectRow(row.path)
              row.role['selected'] = false;
              row['showCheckbox'] = false;
            });
          }
          this.roleMenu.menuTable.selectRow(roleDataRow.path);
          roleDataRow.role['selected'] = true;
          roleDataRow['showCheckbox'] = true;
        }
      };

      roles.forEach((roleObj) => {
        let rowData = {
          cols: [
            {
              html: `<span style="cursor: pointer;">${roleObj.role}</span>`,
              callback: clickCallback
            }
          ],
          path: `${counter}`,
          show: true,
          role: roleObj,
          roleStr: roleObj.role,
          roles: roles,
          showCheckbox: false,
          checkboxCol: {
            settings: {
              disabled: true,
              disabledCallback: clickCallback
            }
          }
        };
        if (roleObj.selected) {
          rowData.showCheckbox = true;
        }
        this.roleMenu.addRow(rowData);
        if (roleObj.selected) {
          this.roleMenu.menuTable.selectRow(counter);
        }
        counter++;
      });
      let icon = (this.lastRoleClickEvent) ? ($(this.lastRoleClickEvent.target || this.lastRoleClickEvent.currentTarget).hasClass('ribbon-icon') ?
              this.lastRoleClickEvent.target || this.lastRoleClickEvent.currentTarget :
              $(this.lastRoleClickEvent.target || this.lastRoleClickEvent.currentTarget).parents('.ribbon-icon')[0]) :
          this.getRibbon().getRibbonIconElement('replyRole');
      this.$nextTick(function () {
        this.roleMenu.showAdjacent(icon, this.parent);
      });
      this.lastRoleClickEvent = null;
    },
    createSimpleStringRowComponent() {
      return {
        template: `
          <input type="text" style="background-color: white; border:0;" v-model="inputVal" type="text" ref="inputRef"
                 size="35"/>
        `,
        props: ['dataRow', 'tableData', 'value', 'parent', 'menuTable', 'messageBoxComponent', 'mainPanel'],
        data: () => {
          return {}
        },
        mounted() {
          //console.log('createSimpleStringRowComponent', 'string-row mounted');
          this.$nextTick(function () {
//if(!this.dataRow.inputParserEnabled) {
            //console.log('createSimpleStringRowComponent', 'creating InputParser');
            this.parser = new InputParser(this.$refs.inputRef, {inputCallback: this.inputParsed.bind(this)})
//    this.dataRow.inputParserEnabled = true;
//}

          });
        },
        computed: {
          inputVal: {
            get() {
              return this.value;
            },
            set(val) {
              this.$emit('input', val);
            }
          }
        },
        beforeDestroy() {
          /*
console.log('beforeDestroy', 'inputRef:', this.$refs.inputRef, ' obj:', this.parent.Y.screenManager.awesompleteMap.get(this.$refs.inputRef));
let obj;
if(obj = this.parent.Y.screenManager.awesompleteMap.get(this.$refs.inputRef)) {
obj.awesomplete.awesompleteInstance.container.remove();
obj.awesomplete.destroy();

this.$forceUpdate();
this.$nextTick(function(){
this.$nextTick(function() {
console.log('beforeDestroy', 'inputRef:', this.$refs.inputRef);
});
});
}

*/
        },
        methods: {
          inputParsed(data) {
            let pathExp = /^(.+)\/.+$/;
            //console.log('inputParsed', 'data:', data);
            if (this.dataRow.path === `${this.messageBoxComponent.recipientTextboxPath}`) {
              if (data.type === 'email') {
                this.messageBoxComponent.addEmail(data.value.trim(), this.menuTable);
                this.inputVal = '';
                return true;
              } else if (data.type === 'phone') {
                this.messageBoxComponent.addPhone(window.libphonenumber.parsePhoneNumberFromString(data.value, 'US').format('E.164'), this.menuTable);
                this.inputVal = '';
                return true;
              }
            }
            if (data.type === 'component') {//&&
//(( this.$refs.inputRef.dataset.awesompleteVal &&  (this.$refs.inputRef.dataset.awesompleteVal === data.value) ))) {
              let existingText = this.inputVal;
              this.inputVal = '';
//this.$forceUpdate();
              async.waterfall([
                this.mainPanel.getComponentByDisplayName.bind(this.mainPanel, data.value.trim()),
                (component, callback) => {
                  this.parent.getAllComponentsRoles(
                      [
                        {
                          id: component.Node,
                          defaultRole: ["admin", "holder", "visitor", "bot"]
                        }
                      ],
                      [{componentId: component.Node, role: "visitor"},{componentId: component.Node, role: "admin"},{componentId: component.Node, role: "bot"}],
                      ['owner'],
                      (error, allRoles) => {
                        //console.log('inputParsed', 'allRoles:', allRoles);
                        callback(error, component, allRoles);
                      });
                },
                (component, allRoles, callback) => {
                  this.messageBoxComponent.addValidatedPE(component, allRoles[component.Node], this.menuTable)
                  callback();
                }
              ], (error) => {
                if (!error) {
                  this.inputVal = '';
                  return true;
                } else {
                  this.inputVal = existingText;
                  return true;
                }


              });
              return true;
            } else if (data.type === 'string') {
              /*
async.waterfall([
(callback) => {
this.mainPanel.createComponent(
this.parent.config.nodeIds.templates.justadisplayname.firsttemplate,
{},
{
DNPrefix: this.inputVal,
toPE: this.mainPanel.GrantPE
},
callback
);
},
(component, callback) => {
this.mainPanel.getGrant(component.grants.adminGrant.Node, (error, grant)=>{
callback(error, component, grant);
});
},
(component, grant, callback) => {
this.parent.getAllComponentsRoles([{id: component.Node, defaultRole: "admin"}], null, [], (error, allRoles)=>{
callback(error, component, allRoles);
});
},
(component, allRoles, callback) => {
this.messageBoxComponent.addValidatedPE(component, "admin", allRoles[component.Node]);
callback();
}
],(error)=>{
return true;
})

*/
              return true;
            } else {
              return false;
            }
          }
        },
        watch: {}
      };
    }
  }
}
</script>
<style>
@import 'lotus-font-icons/style.css';
@import '@vuepic/vue-datepicker/dist/main.css';
@import 'node_modules/floating-vue/dist/style.css';

input[type=text]:focus, textarea:focus {
  outline: 0;
}

.red-color {
  color: red;
}

.grey-background {
  background-color: lightgrey;
}

.dhx_button--view_flat.dhx_button--color_primary {
  background-color: #0072C5;
  outline-width: 0;
}

.dhx_button--view_flat {
  display: -webkit-box;
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  align-items: center;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: #fff;
  -webkit-transition: background-color .2s ease-in,color .2s ease-in,box-shadow .2s ease-in;
  transition: background-color .2s ease-in,color .2s ease-in,box-shadow .2s ease-in;
}

.dhx_button--size_medium {
  padding: 6px 16px;
  text-transform: uppercase;
  line-height: 20px;
}

.dhx_button {
  overflow: visible;
  position: relative;
  text-decoration: none;
  background-image: none;
  border: 0;
  touch-action: manipulation;
  -webkit-appearance: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  white-space: nowrap;
  cursor: pointer;
}

.dhx_button--view_flat {
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Roboto,Arial,Tahoma,Verdana,sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: #fff;
  transition: background-color .2s ease-in,color .2s ease-in,box-shadow .2s ease-in;
}

textarea::placeholder {
  padding-top: 12px;
}

.simplia-tooltip {
  background-color:  #0072C5;
  color: white;
}

</style>